const enMessages = {
  "rules.override.session": "Session override",
  "rules.override.active.session": "Allow active session override",
  "common.api.key.message": "Please configure your API key in the settings",
  "common.api.key.missing": "API Key is missing",
  "common.delete.error": "Error deleting",
  "apis.google.maps.description": "Google Maps provides accurate maps and real-time navigation routes",
  "google.maps": "Google Maps",
  "common.long": "Longitude",
  "common.lat": "Latitude",
  "common.api.config": "API Configuration",
  "common.api.configs": "API Configurations",
  "common.api.configs.add": "Add API Configuration",
  "common.api.configs.edit": "Edit API Configuration",
  "common.api.configs.delete": "Delete API Configuration",
  "common.api.configs.delete.multiple": "Delete API Configurations",
  "common.api.configs.delete.multiple.confirm": "Are you sure you want to delete the selected API configurations?",
  "common.api.configs.delete.multiple.success": "API configurations successfully deleted",
  "common.api.key": "API Key",
  "common.maps": "Maps",
  "common.maps.satellite": "Satellite",
  "common.maps.terrain": "Terrain",
  "common.maps.hybrid": "Hybrid",
  "MD5": "",
  "common.master": "Head Office",
  "common.filial": "Branch",
  "common.error.invalid.format.core.max": "Value above limit, maximum allowed",
  "common.error.invalid.format.core.min": "Value below limit, minimum allowed",
  "common.id": "ID",
  "common.portuguese": "Portuguese",
  "common.english": "English",
  "common.spanish": "Español",
  "common.sync": "Synchronization",
  "common.next": "Next",
  "common.prev": "Previous",
  "common.none": "None",
  "common.user": "User",
  "common.used": "Used",
  "common.password": "Password",
  "common.security": "Security",
  "common.site": "Site",
  "common.threat": "Threat",
  "common.malicious": "Malicious IP",
  "common.server": "Server",
  "common.servers": "Servers",
  "common.port": "Port",
  "common.hostname": "Hostname",
  "common.host": "Host",
  "common.domain": "Domain",
  "common.force.safe.search": "Force Safe Search",
  "common.timezone": "Timezone",
  "common.language": "Language",
  "common.cancel": "Cancel",
  "common.yes": "Yes",
  "common.no": "No",
  "common.close": "Close",
  "common.save": "Save",
  "common.backup": "Backup",
  "common.backups": "Backups",
  "common.restore": "Restore",
  "common.uptime": "Uptime",
  "common.disc": "Disc",
  "common.idle": "Idle",
  "common.time.system": "Date & Time",
  "common.add.to.list": "Add to list",
  "common.add.to.filter": "Add to filter",
  "common.del.to.list": "Remove to list",
  "common.group": "Group",
  "common.devicesWithoutGroup": "Devices Without Group",
  "common.create": "Create",
  "common.delete": "Delete",
  "common.create.name": "Create {name}",
  "common.delete.name": "Delete {name}",
  "common.system.updates": "Updates",
  "common.update": "Update",
  "common.updates": "Updates",
  "common.edit": "Edit",
  "common.configure": "Configure",
  "common.view": "View",
  "common.name": "Name",
  "common.description": "Description",
  "common.version": "Version",
  "common.mode": "Mode",
  "common.protocol": "Protocol",
  "common.protocols": "Protocols",
  "common.position": "Position",
  "common.enabled": "Enabled",
  "common.disabled": "Disabled",
  "common.disableds": "Disabled",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.any": "any",
  "common.always": "always",
  "common.total": "Total",
  "common.back": "Back",
  "common.clear": "Clear",
  "common.template": "Template",
  "common.template.name": "Template Name",
  "common.confirm":
    "Are you sure you want to {action} the following {type}{len, plural, one {} other {s}}{value}?",
  "common.confirm.policy":
    "Are you sure you want to delete the following policy(s)?",
  "common.confirm.group":
    "Are you sure you want to delete the following group(s)?",
  "common.confirm.delete": "Are you sure?",
  "common.select_all": "Select All",
  "common.allow_all": "Allow All",
  "common.deny_all": "Deny All",
  "common.block_all": "Block All",
  "common.disable_all": "Disable All",
  "common.warning_all": "Warning All",
  "common.deselect_all": "Deselect All",
  "common.noGroup": "No Group",
  "common.invalid.value": "Invalid Value!",
  "common.invalid.form": "Please review this form!",
  "common.required.field": "Required field",
  "common.text.too.long": "Maximum character limit reached",
  "common.text.too.long.70c": "The value cannot be longer than 70 characters",
  "common.passive": "Passive",
  "common.informations": "Informations",
  "common.conditions": "Conditions",
  "common.inspection": "Inspection",
  "common.controls": "Controls",
  "common.rule": "Rule",
  "common.reason": "Reason",
  "common.user.agent": "Platform",
  "common.copied": "Copied",
  "common.allow": "Allow",
  "common.allowed": "Allowed",
  "common.alloweds": "Allowed",
  "common.deny": "Deny",
  "common.declined": "Declined",
  "common.decline": "Decline",
  "common.denied": "Denied",
  "common.warning": "Warning",
  "common.reject": "Reject",
  "common.all": "All",
  "common.allDevices": "All Devices",
  "common.selected": "Selected",
  "common.selected.objects": "{count} Selected",
  "common.general": "General",
  "common.config": "Configuration",
  "common.type": "Type",
  "common.logtype": "Log type",
  "common.logs": "Logs",
  "common.groups": "Groups",
  "common.sources": "Sources",
  "common.clone": "Clone",
  "common.working": "Working...",
  "common.actions": "Actions",
  "common.action": "Action",
  "common.client": "Client",
  "common.system": "System",
  "common.license": "License",
  "common.sessions": "Sessions",
  "common.services": "Services",
  "common.interfaces": "Interfaces",
  "common.interface": "Interface",
  "common.email": "E-mail",
  "common.email.report": "Send Report by Email",
  "common.email.group.report": "Send report to email group",
  "common.error.email.group.report": "Some emails are not valid",
  "common.placeholder.email.group.report": "Add emails",
  "common.users": "Users",
  "common.profiles": "Profiles",
  "common.audit": "Audit",
  "common.save.success": "Saved successfully",
  "common.save.error": "Error saving!",
  "common.processes": "Processes",
  "common.remove": "Remove",
  "common.device": "Device",
  "common.deviceLogger": "Device/Logger",
  "common.status": "Status",
  "common.block": "Block",
  "common.quarantine": "Quarantine",
  "common.pcap": "PCAP",
  "common.packetLogger": "Packet Logger",
  "common.prefixPcap": "File prefix",
  "common.minFile": "Tamaño mínimo de archivo (MB)",
  "common.profile_filesize": "Tamaño máximo do arquivo (MB)",
  "common.quantity": "Quantity",
  "common.risk": "Risk",
  "common.high": "High",
  "common.medium": "Medium",
  "common.low": "Low",
  "common.category": "Category",
  "common.sid": "SID",
  "common.blocked": "Blocked",
  "common.blockeds": "Blocked",
  "common.unblocked": "Unblocked",
  "common.source": "Source",
  "common.destination": "Destination",
  "common.enable": "Enable",
  "common.disable": "Disable",
  "common.unblock": "Unblock",
  "common.profile": "Profile",
  "common.custom": "Custom",
  "common.deleted": "{name} deleted successfully",
  "common.date": "Date",
  "common.archive": "File",
  "common.service": "Service",
  "common.search": "Search",
  "common.filters": "Filters",
  "common.filter": "Filter",
  "common.task": "Task",
  "common.auditor": "Auditor",
  "common.created": "Created",
  "common.accept": "Accept",
  "common.activity": "Activity",
  "common.logger": "Logger",
  "common.error": "Error",
  "common.error.network": "Network error!",
  "common.error.required": "{name} is required",
  "common.error.required.ip.forwarding": "IP is required",
  "common.error.alphanumeric":
    "Field alphanumeric lowercase required (a-z0-9_-)",
  "common.error.invalid": "{name} is invalid",
  "common.error.invalid.value": "Invalid value",
  "common.error.invalid.format": "Invalid format",
  "common.error.fetch": "Error on fetch the data.",
  "common.error.character": "Invalid character.",
  "common.error.min.character":
    "The field must be at least {number} characters",
  "common.authentication.required": "MFA field is required",
  "common.error.version": "Unsupported Version",
  "common.error.file.notFound": "File not found",
  "common.error.url": "{name} must be a valid url.",
  "common.error.url.fail": "Invalid url.",
  "common.error.url.https": "This URL must be a https.",
  "common.error.email": "{name} must be a valid email.",
  "common.error.saml.service.name":
    "Accepts lowercase alphanumeric. ([a-z0-9_-])",
  "common.error.snap.version":
    "Incompatible Snapshot - Server version: {serverVersion} - Snapshot version: {snapVersion}",
  "common.error.dont.permition": "Your login does not allow access to this area.",
  "common.top": "Top",
  "common.hits": "Hits",
  "common.traffic": "Traffic",
  "common.select": "Select",
  "common.page": "Page",
  "common.done": "Done",
  "common.provisioning": "Provisioning",
  "common.connect": "Connected",
  "common.identification": "Identification",
  "common.model": "Model",
  "common.scheduled": "Scheduled",
  "common.firewall": "Firewall",
  "common.default": "Default",
  "common.dhcp": "DHCP",
  "common.confirm.ok": "Confirm",
  "common.uuid": "UUID",
  "common.add": "Add",
  "common.company": "Company",
  "common.devTemplate": "Device Template",
  "common.polPackage": "Policy Package",
  "common.devComm": "Device Community",
  "common.alreadyExists": "Already Exists",
  "common.dns": "DNS",
  "common.dns_server": "DNS Server",
  "common.progress": "Progress",
  "common.import": "Import {name}",
  "common.list": "List",
  "common.templates": "Device Templates",
  "common.templates.combo": "Device Template",
  "common.community": "Device Community",
  "common.certificate": "Certificate",
  "common.certificate.remote": "Remote CA",
  "common.certificates": "Certificates",
  "common.years": "Years",
  "common.country": "Country",
  "common.state": "State",
  "common.city": "City",
  "common.organization": "Organization",
  "common.unit": "Organizational Unit",
  "common.expires": "Expires in (years)",
  "common.license.expires.at": "License will expire on:",
  "common.show.all": "Show All",
  "common.items.not.found": "No items found ",
  "common.apply": "Apply",
  "common.values": "Values",
  "common.time": "Time",
  "common.ip": "IP",
  "common.ips": "IP's",
  "common.network": "Network",
  "common.simultaneous.transfers": "Simultaneous transfers",
  "common.whitelist": "Allowed Addresses",
  "common.blacklist": "Blocked Addresses",
  "common.invalid.fields": "Invalid fields",
  "common.dnsServer": "DNS Server",
  "common.domain1": "Domain.com",
  "common.dns1": "DNS Primary",
  "common.dns2": "DNS Secondary",
  "common.dnssuffix": "Suffix DNS",
  "common.gateway": "Gateway",
  "common.ntpserver": "NTP Server",
  "common.ipExample": "1.1.1.1",
  "common.maskExample": "255.255.255.255",
  "common.object.address": "Address",
  "common.object.service": "Service",
  "common.object.time": "Time",
  "common.object.schedule": "Schedule",
  "common.object.dictionary": "Dictionary",
  "common.object.content": "Content",
  "common.profile.webfilter": "Web Filter Profile",
  "common.profile.webfilter.inUse": "Can't delete profile! Profile in use",
  "common.profile.appcontrol": "Application Control Profile",
  "common.profile.atp": "Threat Protection Profile",
  "common.profile.ips": "Intrusion Prevention Profile",
  "common.profile.ssl": "SSL Inspection Profile",
  "common.profile.sdwan": "SD-WAN Profile",
  "common.profile.sdwan.space.error": "Profile name with space",
  "common.manager.delete.group.message.withdevice":
    "There device associated with group {name}! Are you sure you want to delete?",
  "common.manager.delete.group.message":
    "Are you sure you want to delete the group {name}?",
  "common.wizard.network.dns1": "DNS Server 1",
  "common.wizard.network.dns2": "DNS Server 2",
  "common.wizard.network.dns1.error": "DNS Server 1 is required",
  "common.policy": "Policy",
  "common.established": "Established",
  "common.new": "New",
  "common.start": "Start",
  "common.paste.here": "Paste Here",
  "common.stop": "Stop",
  "common.zone": "Zone",
  "common.bytes": "Bytes",
  "common.bytes.received": "Bytes Received",
  "common.bytes.sent": "Bytes Sent",
  "common.bytes.total": "Bytes Total",
  "common.packages": "Packages",
  "common.packages.combo": "Policy Package",
  "common.packages.received": "Packages Received",
  "common.packages.sent": "Packages Sent",
  "common.packages.total": "Packages Total",
  "common.connection": "Connection",
  "common.connections": "Connections",
  "commom.confirm.delete": "Are you sure you want to delete?",
  "common.application": "Application",
  "common.attack": "Attack",
  "common.malware": "Malware",
  "common.latency": "Latency",
  "common.jitter": "Jitter",
  "common.packetLoss": "Packet Loss",
  "common.bandwidth": "Bandwidth",
  "common.balancing": "Balancing",
  "common.traffic.distribution": "Traffic Distribution",
  "common.deploy": "Deploy",
  "common.import-file": "Import File",
  "common.custom-signature": "Custom Signature",
  "common.wizard.admin.repass.mismatch":
    "Password confirmation does not matches",
  "common.authentication": "Authentication",
  "common.routes": "Routes",
  "common.dont.permission": "You don't have permission to execute this action.",
  "common.dont.permission.page":
    "You don't have permission to access this page.",
  "common.dont.permission.delete": "You don't have permission to delete this.",
  "common.dont.permission.clone": "You don't have permission to clone this.",
  "common.dont.permission.edit": "You don't have permission to edit this.",
  "common.blocked.ha": "High Availabilty Enabled - State: Backup - Blocked Access.",
  "common.server.error":
    "Server error, please contact the system administrator",
  "common.login.form": "Log-in to your account",
  "common.login.form.email": "E-mail address",
  "common.login.form.email.required": "E-mail is required",
  "common.login.form.password": "Password",
  "common.login.form.password.required": "Password is required",
  "common.login.form.forgot": "Forgot password?",
  "common.devin": "Device",
  "common.mask": "Mask",
  "common.mac": "MAC",
  "common.sso": "SSO",
  "common.read": "Read",
  "common.write": "Write",
  "common.settings": "Settings",
  "common.exception": "Exception",
  "common.transparent": "Transparent",
  "common.select.time.ini": "Select a start time",
  "common.select.time.end": "Select a end time",
  "common.record": "record",
  "common.records": "records",
  "common.first": "First",
  "common.limit.profile": "Limit of profiles created.",
  "common.src": "Source",
  "common.dst": "Destination",
  "common.virtualAddress": "Virtual Address",
  "common.duration": "Duration",
  "common.packets": "Packets",
  "common.event": "Event",
  "common.storages": "Storages",
  "common.storage": "Storage",
  "common.virtualDomain": "Virtual Domain",
  "common.logging": "Logging",
  "common.notifications": "Notifications",
  "common.highAvailability": "High Availability",
  "common.vdom": "Virtual Domains",
  "common.days": "Days",
  "common.months": "Months",
  "common.unlimited": "Unlimited",
  "common.disk": "disk",
  "common.ipAddress": "IP Address",
  "common.reload": "Reload",
  "common.time.conection": "Time Conection",
  "common.secret": "Secret",
  "common.size": "Size",
  "common.perSecond": "per second",
  "common.perMinute": "per minute",
  "common.perHour": "per hour",
  "common.login": "Login",
  "common.logout": "Logout",
  "common.share": "Share",
  "common.directory": "Directory",
  "common.policies": "per hour",
  "common.seconds": "second(s)",
  "common.max": "Max",
  "common.authenticated": "Authenticated",
  "common.auth": "Auth",
  "common.modules": "Modules",
  "common.delete.success": "Successfully removed",
  "common.disabled.success": "Successfully disabled",
  "common.clone.success": "Successfully cloned",
  "common.clone.error": "Error cloned",
  "common.nothing.delete": "No items to be deleted",
  "common.disclaimer": "Disclaimer",
  "common.minutes": "Minutes",
  "common.hours": "Hours",
  "common.at.hours": "at",
  "common.at.day": "Day",
  "common.completed": "Completed",
  "common.administrators": "Administrators",
  "common.users.profiles": "Users Profiles",
  "common.auth.servers": "Auth Servers",
  "common.identity.provider": "Identity Provider",
  "common.audit.log": "Audit Log",
  "common.high.availability": "High Availability",
  "common.standalone": "Standalone",
  "common.integrated": "Integrated",
  "common.disclaimer.login.title": "Login Disclaimer",
  "common.initial.space.error": "Initial space is not allowed",
  "common.remote": "Remote",
  "common.workers": "Workers",
  "common.Lease": "Leases",
  "common.complete": "Complete",
  "common.diff": "Differential",
  "common.name.already.exists": "Profile name already exists!",
  "common.access.control": "Access Control",
  "common.select.device.logger": "Select Device/Logger",
  "common.vpn": "VPN",
  "common.static.routing": "Static Routing",
  "common.relevance": "Relevance",
  "common.local": "Local",
  "common.maintenance": "Maintenance",
  "common.all.files": "All files",
  "common.temporary": "Temporary",
  "common.reports": "Reports",
  "common.statistics": "Statistics",
  "common.invalid.form.risk.item": "It is not allowed to choose more than two items per risk",
  "common.copy": "Copy",
  "common.access.multifactor": "MFA",
  "common.access.multifactor.active": "Two-factor identification",
  "common.access.multifactor.validate": "User with registered key",
  "device.config.success": "Device configured",
  "common.waiting": "Waiting",
  "common.waiting.approval": "Waiting for approval",
  "common.in_progress": "Applying initial settings",
  "common.registry": "Registering",
  "common.license.expired": "Expired license",
  "provisioning.batch": "Checking batch",
  "provisioning.error.batch": "Error batch",
  "common.config.device": "Configuring device",
  "common.waiting.key.exchange": "Waiting for key exchange",
  "common.connecting": "Connecting device",
  "common.confirmSignatures": "Confirm change in {value} signatures?",
  "deploy.sending": "Sending deploy",
  "deploy.applying": "Applying deploy",
  "administration.profiles.datagrid.name": "Name",
  "administration.profiles.datagrid.email": "E-mail",
  "administration.profiles.datagrid.key": "Key",
  "country.local": "Local Network",
  "country.AD": "Andorra",
  "country.AE": "United Arab Emirates",
  "country.AF": "Afghanistan",
  "country.AG": "Antigua and Barbuda",
  "country.AI": "Anguilla",
  "country.AL": "Albania",
  "country.AM": "Armenia",
  "country.AO": "Angola",
  "country.AP": "Asia/Pacific Region",
  "country.AQ": "Antarctica",
  "country.AR": "Argentina",
  "country.AS": "American Samoa",
  "country.AT": "Austria",
  "country.AU": "Australia",
  "country.AW": "Aruba",
  "country.AX": "Aland Islands",
  "country.AZ": "Azerbaijan",
  "country.BA": "Bosnia and Herzegovina",
  "country.BB": "Barbados",
  "country.BD": "Bangladesh",
  "country.BE": "Belgium",
  "country.BF": "Burkina Faso",
  "country.BG": "Bulgaria",
  "country.BH": "Bahrain",
  "country.BI": "Burundi",
  "country.BJ": "Benin",
  "country.BL": "Saint Barthelemy",
  "country.BM": "Bermuda",
  "country.BN": "Brunei Darussalam",
  "country.BO": "Bolivia",
  "country.BQ": "Bonaire, Saint Eustatius and Saba",
  "country.BR": "Brazil",
  "country.BS": "Bahamas",
  "country.BT": "Bhutan",
  "country.BV": "Bouvet Island",
  "country.BW": "Botswana",
  "country.BY": "Belarus",
  "country.BZ": "Belize",
  "country.CA": "Canada",
  "country.CC": "Cocos (Keeling) Islands",
  "country.CD": "Congo, The Democratic Republic of the",
  "country.CF": "Central African Republic",
  "country.CG": "Congo",
  "country.CH": "Switzerland",
  "country.CI": "Cote d'Ivoire",
  "country.CK": "Cook Islands",
  "country.CL": "Chile",
  "country.CM": "Cameroon",
  "country.CN": "China",
  "country.CO": "Colombia",
  "country.CR": "Costa Rica",
  "country.CU": "Cuba",
  "country.CV": "Cape Verde",
  "country.CW": "Curacao",
  "country.CX": "Christmas Island",
  "country.CY": "Cyprus",
  "country.CZ": "Czech Republic",
  "country.DE": "Germany",
  "country.DJ": "Djibouti",
  "country.DK": "Denmark",
  "country.DM": "Dominica",
  "country.DO": "Dominican Republic",
  "country.DZ": "Algeria",
  "country.EC": "Ecuador",
  "country.EE": "Estonia",
  "country.EG": "Egypt",
  "country.EH": "Western Sahara",
  "country.ER": "Eritrea",
  "country.ES": "Spain",
  "country.ET": "Ethiopia",
  "country.EU": "Europe",
  "country.FI": "Finland",
  "country.FJ": "Fiji",
  "country.FK": "Falkland Islands (Malvinas)",
  "country.FM": "Micronesia, Federated States of",
  "country.FO": "Faroe Islands",
  "country.FR": "France",
  "country.GA": "Gabon",
  "country.GB": "United Kingdom",
  "country.GD": "Grenada",
  "country.GE": "Georgia",
  "country.GF": "French Guiana",
  "country.GG": "Guernsey",
  "country.GH": "Ghana",
  "country.GI": "Gibraltar",
  "country.GL": "Greenland",
  "country.GM": "Gambia",
  "country.GN": "Guinea",
  "country.GP": "Guadeloupe",
  "country.GQ": "Equatorial Guinea",
  "country.GR": "Greece",
  "country.GS": "South Georgia and the South Sandwich Islands",
  "country.GT": "Guatemala",
  "country.GU": "Guam",
  "country.GW": "Guinea-Bissau",
  "country.GY": "Guyana",
  "country.HK": "Hong Kong",
  "country.HM": "Heard Island and McDonald Islands",
  "country.HN": "Honduras",
  "country.HR": "Croatia",
  "country.HT": "Haiti",
  "country.HU": "Hungary",
  "country.ID": "Indonesia",
  "country.IE": "Ireland",
  "country.IL": "Israel",
  "country.IM": "Isle of Man",
  "country.IN": "India",
  "country.IO": "British Indian Ocean Territory",
  "country.IQ": "Iraq",
  "country.IR": "Iran, Islamic Republic of",
  "country.IS": "Iceland",
  "country.IT": "Italy",
  "country.JE": "Jersey",
  "country.JM": "Jamaica",
  "country.JO": "Jordan",
  "country.JP": "Japan",
  "country.KE": "Kenya",
  "country.KG": "Kyrgyzstan",
  "country.KH": "Cambodia",
  "country.KI": "Kiribati",
  "country.KM": "Comoros",
  "country.KN": "Saint Kitts and Nevis",
  "country.KP": "Korea, Democratic People's Republic of",
  "country.KR": "Korea, Republic of",
  "country.KW": "Kuwait",
  "country.KY": "Cayman Islands",
  "country.KZ": "Kazakhstan",
  "country.LA": "Lao People's Democratic Republic",
  "country.LB": "Lebanon",
  "country.LC": "Saint Lucia",
  "country.LI": "Liechtenstein",
  "country.LK": "Sri Lanka",
  "country.LR": "Liberia",
  "country.LS": "Lesotho",
  "country.LT": "Lithuania",
  "country.LU": "Luxembourg",
  "country.LV": "Latvia",
  "country.LY": "Libyan Arab Jamahiriya",
  "country.MA": "Morocco",
  "country.MC": "Monaco",
  "country.MD": "Moldova, Republic of",
  "country.ME": "Montenegro",
  "country.MF": "Saint Martin",
  "country.MG": "Madagascar",
  "country.MH": "Marshall Islands",
  "country.MK": "Macedonia",
  "country.ML": "Mali",
  "country.MM": "Myanmar",
  "country.MN": "Mongolia",
  "country.MO": "Macao",
  "country.MP": "Northern Mariana Islands",
  "country.MQ": "Martinique",
  "country.MR": "Mauritania",
  "country.MS": "Montserrat",
  "country.MT": "Malta",
  "country.MU": "Mauritius",
  "country.MV": "Maldives",
  "country.MW": "Malawi",
  "country.MX": "Mexico",
  "country.MY": "Malaysia",
  "country.MZ": "Mozambique",
  "country.NA": "Namibia",
  "country.NC": "New Caledonia",
  "country.NE": "Niger",
  "country.NF": "Norfolk Island",
  "country.NG": "Nigeria",
  "country.NI": "Nicaragua",
  "country.NL": "Netherlands",
  "country.NO": "Norway",
  "country.NP": "Nepal",
  "country.NR": "Nauru",
  "country.NU": "Niue",
  "country.NZ": "New Zealand",
  "country.OM": "Oman",
  "country.PA": "Panama",
  "country.PE": "Peru",
  "country.PF": "French Polynesia",
  "country.PG": "Papua New Guinea",
  "country.PH": "Philippines",
  "country.PK": "Pakistan",
  "country.PL": "Poland",
  "country.PM": "Saint Pierre and Miquelon",
  "country.PN": "Pitcairn",
  "country.PR": "Puerto Rico",
  "country.PS": "Palestinian Territory",
  "country.PT": "Portugal",
  "country.PW": "Palau",
  "country.PY": "Paraguay",
  "country.QA": "Qatar",
  "country.RE": "Reunion",
  "country.RO": "Romania",
  "country.RS": "Serbia",
  "country.RU": "Russian Federation",
  "country.RW": "Rwanda",
  "country.SA": "Saudi Arabia",
  "country.SB": "Solomon Islands",
  "country.SC": "Seychelles",
  "country.SD": "Sudan",
  "country.SE": "Sweden",
  "country.SG": "Singapore",
  "country.SH": "Saint Helena",
  "country.SI": "Slovenia",
  "country.SJ": "Svalbard and Jan Mayen",
  "country.SK": "Slovakia",
  "country.SL": "Sierra Leone",
  "country.SM": "San Marino",
  "country.SN": "Senegal",
  "country.SO": "Somalia",
  "country.SR": "Suriname",
  "country.SS": "South Sudan",
  "country.ST": "Sao Tome and Principe",
  "country.SV": "El Salvador",
  "country.SX": "Sint Maarten",
  "country.SY": "Syrian Arab Republic",
  "country.SZ": "Swaziland",
  "country.TC": "Turks and Caicos Islands",
  "country.TD": "Chad",
  "country.TF": "French Southern Territories",
  "country.TG": "Togo",
  "country.TH": "Thailand",
  "country.TJ": "Tajikistan",
  "country.TK": "Tokelau",
  "country.TL": "Timor-Leste",
  "country.TM": "Turkmenistan",
  "country.TN": "Tunisia",
  "country.TO": "Tonga",
  "country.TR": "Turkey",
  "country.TT": "Trinidad and Tobago",
  "country.TV": "Tuvalu",
  "country.TW": "Taiwan",
  "country.TZ": "Tanzania, United Republic of",
  "country.UA": "Ukraine",
  "country.UG": "Uganda",
  "country.UM": "United States Minor Outlying Islands",
  "country.US": "United States",
  "country.UY": "Uruguay",
  "country.UZ": "Uzbekistan",
  "country.VA": "Holy See (Vatican City State)",
  "country.VC": "Saint Vincent and the Grenadines",
  "country.VE": "Venezuela",
  "country.VG": "Virgin Islands, British",
  "country.VI": "Virgin Islands, U.S.",
  "country.VN": "Vietnam",
  "country.VU": "Vanuatu",
  "country.WF": "Wallis and Futuna",
  "country.WS": "Samoa",
  "country.YE": "Yemen",
  "country.YT": "Mayotte",
  "country.ZA": "South Africa",
  "country.ZM": "Zambia",
  "country.ZW": "Zimbabwe",

  "certificate.country": "Abbreviation of two letters. Ex .: US",
  "certificate.state": "Full Ex .: New York",
  "certificate.organization": "Company name",
  "certificate.unit": "Ex .: Department",
  "certificate.email": "admin@domain",
  "certificate.keysize": "Key Size",

  "maintenance.remove.clear.directory": "Do you want to clear the entire directory?",
  "maintenance.remove.clear.directory.restart.proxy": "Do you want to clear the entire directory? You will need to restart the proxy service.",

  "network.settings.title": "Network Settings",
  "network.general.form.gateway": "Gateway",
  "network.general.form.dns1": "DNS Server 1",
  "network.general.form.dns2": "DNS Server 2",
  "network.general.form.ntp1": "NTP Server 1",
  "network.general.form.ntp2": "NTP Server 2",
  "network.interface.datagrid.name": "Name",
  "network.interface.datagrid.address": "Address",
  "network.interface.datagrid.mask": "Mask",
  "network.interface.datagrid.status": "Status",
  "network.interface.datagrid.actions": "Actions",
  "network.interface.form.title": "Edit Interface",
  "network.interface.form.status": "Enable",
  "network.interface.form.ip": "IP Address",
  "network.interface.form.ip.invalid": "Invalid IP address",
  "network.interface.form.mask.invalid": "Invalid mask address",
  "network.interface.form.mask": "Mask Address",
  "network.interface.error.ip": "IP address field is required",
  "network.interface.save.success": "Settings successfully changed!",
  "network.interface.save.error": "Settings have not been saved!",
  "network.interface.searchInterfaces": "Search Interfaces",
  "network.interface.error.mask": "Mask address field is required",
  "network.email.connectionTest": "Test SMTP connection",
  "network.email.connectionError": "SMTP connection failed",
  "network.email.connectionAuthFailed": "SMTP authentication failed",
  "network.email.connectionSuccess": "SMTP connection success",
  "network.email.hostname.required": "Hostname is required",
  "network.email.port.required": "Port is required",
  "network.email.user.required": "User is required",
  "network.email.pass.required": "Pass is required",
  "network.email.security.required": "Security is required",

  "administration.title": "Administration",
  "administration.titleComplete": "Administration Profile",
  "administration.user.title": "Administration User",
  "administration.profiles.datagrid.profile": "Profile",
  "administration.profiles.datagrid.actions": "Actions",
  "administration.profiles.actions.create": "Create Profile",
  "administration.profiles.actions.delete": "Delete Profile",
  "administration.profiles.actions.clone": "Clone Profile",
  "administration.profiles.modal.title": "Create Profile",
  "administration.profiles.modal.name": "Name",
  "administration.profiles.modal.devices": "Devices",
  "administration.profiles.modal.devicesGroups": "Device Groups",
  "administration.profiles.modal.clone.text": "Are you sure you want to clone?",
  "administration.profiles.modal.delete.text":
    "Are you sure you want to delete?",
  "administration.profiles.modal.clone.success": "Profile cloned successfully!",
  "administration.profiles.modal.clone.error": "Profile have not been cloned!",
  "administration.profiles.modal.clone.error.already":
    "Profile has already been cloned",
  "administration.profile.save.deleted": "Profile deleted successfully!",
  "administration.profiles.save.deleted": "Profiles deleted successfully!",
  "administration.profiles.save.deleted.errorAlready":
    "Already admin users on profile {name}",
  "administration.profiles.save.deleted.error": "Can not delete profile {name}",

  //Controle de acesso -----
  "administration.control.actions.create": "Create Control",
  "administration.control.actions.delete": "Delete Control",

  "administration.users.datagrid.name": "Name",
  "administration.users.datagrid.email": "E-mail",
  "administration.users.datagrid.type": "Type",
  "administration.users.datagrid.profile": "Profile",
  "administration.users.datagrid.actions": "Actions",
  "administration.users.datagrid.auditor": "Auditor",
  "administration.users.datagrid.api_access": "Access API",
  "administration.users.actions.create": "Create User",
  "administration.users.actions.delete": "Delete User",
  "administration.users.actions.clone": "Clone User",
  "administration.users.modal.title": "Admin User",
  "administration.users.modal.auditor": "Auditor",
  "administration.users.modal.auditor.required": "Auditor is required!",
  "administration.users.modal.api_access": "Access API",
  "administration.users.modal.api_access.required": "Access API is required!",
  "administration.users.modal.name": "Name",
  "administration.users.modal.name.required": "Name is required!",
  "administration.users.modal.email": "E-mail",
  "administration.users.modal.email.required": "E-mail is required!",
  "administration.users.modal.user": "User",
  "administration.users.modal.user.required": "User is required!",
  "administration.users.modal.type": "Type",
  "administration.users.modal.type.required": "Type is required!",
  "administration.users.modal.server": "Server",
  "administration.users.modal.server.required": "Server is required!",
  "administration.users.modal.password": "Password",
  "administration.users.modal.password.required": "Password is required!",
  "administration.users.modal.confirmPassword": "Confirm Password",
  "administration.users.modal.confirmPassword.required":
    "Confirmation Password is required!",
  "administration.users.modal.profile": "Profile",
  "administration.users.modal.profile.required": "Profile is required!",
  "administration.users.save.success": "User saved successfully!",
  "administration.users.save.error": "User have not been saved!",
  "administration.users.delete.error": "Users have not been deleted!",
  "administration.user.delete.error": "User have not been deleted!",
  "administration.user.delete.pk":
    "Failed to delete user! There are tasks linked to this user.",

  "administration.users.save.error.differentPass": "Passwords do not match",
  "administration.users.save.error.wakePass": "Weak password",

  "administration.users.save.deleted": "Users deleted successfully!",
  "administration.user.save.deleted": "User deleted successfully!",

  "administration.servers.datagrid.server.name": "Name",
  "administration.servers.datagrid.primary.server": "Primary",
  "administration.servers.datagrid.secondary.server": "Secondary",
  "administration.servers.datagrid.authentication.type": "Authentication Type",
  "administration.servers.datagrid.type.server": "Type",
  "administration.servers.form.nas.ip.addresses": "NAS IP Addresses",
  "administration.servers.form.secondary.server": "Secondary Server",
  "administration.servers.form.primary.server": "Primary Server",
  "administration.servers.form.server.error": "Servers must be different",
  "administration.servers.form.already.exists":
    "Already exists a field the same name",
  "administration.servers.form.duplicate.server": "Duplicate server",
  "administration.servers.form.settings": "Settings",
  "administration.servers.form.filter.user": "User Filter",
  "administration.servers.form.login": "Login",
  "administration.servers.form.password": "Password",
  "administration.servers.form.ssl": "SSL",
  "administration.servers.form.radius": "Radius",
  "administration.servers.form.ldap": "Ldap",
  "administration.servers.form.base": "Base",
  "administration.servers.form.title.ldap": "LDAP server",
  "administration.servers.form.modalAddLdap.help.hostname": "Enter Hostname (FQDN) or IP Address",
  "administration.servers.form.servers.title": "Timing Servers",
  "administration.servers.form.servers.error.inuse": "Unable to delete profile! Server in use",
  "administration.servers.form.modalAddLdap.help.port": "Enter the Communication Port",
  "administration.servers.form.modalAddLdap.type": "Certificate or Login and Password option",
  "administration.servers.form.modalAddLdap.identity.name": "Name attribute",
  "administration.servers.form.modalAddLdap.identity.member": "Member attribute",
  "administration.servers.form.modalAddLdap.identity.description": "Description attribute",
  "administration.servers.form.modalAddLdap.filter.group": "Group Filter",
  "administration.servers.form.modalAddLdap.info.ssl": "For Certificate authentication type the SSL checkbox is required.",
  "administration.servers.form.login.attribute": "Login Attribute",
  "administration.servers.datagrid.save.success": "Profile saved successfully",
  "administration.servers.datagrid.edit.success": "Profile edited successfully",
  "administration.servers.action.delete.success": "Profile deleted successfully",
  "administration.servers.action.delete.error": "Profile deleted error",
  "administration.servers.action.create.radius": "Create Radius",
  "administration.servers.action.create.ldap": "Create Ldap",
  "administration.servers.action.delete": "Delete Server",
  "administration.servers.action.delete.text":
    "Are you sure you want to delete",
  "administration.servers.action.connection.test": "Test Connection",
  "administration.servers.action.auth.test": "Test Authentication",
  "administration.servers.action.connection.success": "Connection successfully",
  "administration.servers.action.connection.error": "Connection error",
  "administration.servers.action.auth.success": "Authentication successfully",
  "administration.servers.action.auth.error": "Authentication error",
  "administration.audit.modal.title": "Audit View",

  /* START - Adicionado por Fabio Dias 10/12/200 - EN */
  "administration.identity.user.interface": "Interface de Login padrão",
  "administration.identity.service.provider": "Service Provider",
  "administration.identity.service.provider.disabled":
    "Service Provider Disabled",
  "administration.identity.saml.enable": "Enabled",
  "administration.identity.service.name": "Service Name",
  "administration.identity.service.description": "Service Description",
  "administration.identity.url.base": "Base URL",
  "administration.identity.url.base.login": "Base URL Login",
  "administration.identity.url.base.logout": "Base URL Logout",
  "administration.identity.url.base.metadata": "Base URL Metadata",
  "administration.identity.x509.cert": "Certificate",
  "administration.identity.x509.cert.new": "Add Certificate",
  "administration.identity.x509.cert.public": "Certificate - Public Key (.crt)",
  "administration.identity.x509.cert.private":
    "Certificate - Private Key (.key)",
  "administration.identity.x509.cert.pem": "Certificate (.pem)",
  "administration.identity.x509.cert.type": "Certificate Type",
  "administration.identity.x509.cert.type.pem": "(.pem)",
  "administration.identity.x509.cert.type.other": "(.crt/key)",
  "administration.identity.nameid.format": "Name ID Format",
  "administration.identity.url.test": "Test URL",
  "administration.identity.url.assertion": "Assertion URL",
  "administration.identity.url.logout": "Logout URL",
  "administration.identity.url.metadata": "Metadata URL",
  "administration.identity.id": "Entity ID",
  "administration.identity.sson.url": "Single Sign On Service URL",
  "administration.identity.ssoff.url": "Single Log Out Service URL",
  "administration.identity.binding.sso": "SSO Binding",
  "administration.identity.binding.slo": "SLO Binding",
  "administration.identity.binding.post": "Post",
  "administration.identity.binding.redirect": "Redirect",
  "administration.identity.username": "Username",
  "administration.identity.email.address": "E-mail Address",
  "administration.identity.user.name": "Username Attribute",
  "administration.identity.user.email": "Email Attribute",
  "administration.identity.saml.profile": "Profile Attribute",
  "administration.identity.user.profile": "GSM Users' Profiles",
  "administration.identity.user.persist": "Persist User",
  "administration.identity.user.audit": "Auditor",
  "administration.identity.export.metadata":
    "Export Metadata Identity Provider (XML)",
  "administration.identity.import.metadata":
    "Import Metadata Identity Provider (XML)",
  "administration.identity.import.file": "Import Certificate",
  "administration.identity.export.file": "Export Certificate",
  "administration.identity.add.file": "Add Certificate",
  "administration.identity.add.certificate": "Certificate added successfully",
  "administration.identity.add.certificate.fail": "Failed to add certificate",
  "administration.identity.import.certificate":
    "Certificate imported successfully",
  "administration.identity.import.certificate.fail":
    "Failed to import certificate",
  "administration.identity.import.certificate.invalid":
    "not found in certificate",
  "administration.identity.save.certificate.error":
    "Add or import a certificate before downloading",
  "administration.identity.save.success": "Identity Provider save successfully",
  "administration.identity.save.error": "Identity Provider have not been saved",
  "administration.identity.login.error":
    "Login error with Identity Provider. Please check your settings.",
  /* END - Adicionado por Fabio Dias 10/12/200 - EN */

  "system.general.timezone.select": "Select a timezone",
  "system.general.language.select": "Select a language",
  "system.general.save.success": "Settings successfully changed!",
  "system.general.save.disclaimer": "Save Disclaimer",
  "system.general.save.sessions": "Save Sessions",
  "system.general.save.services": "Save Services",
  "system.general.save.error": "Settings have not been saved!",
  "system.general.host.domain.error":
    "The hostname added to the domain must contain a maximum of 64 characters",
  "system.backupModal.title": "System Backup",
  "system.backupModal.key": "Key",
  "system.backupModal.confirm": "Confirm Key",
  "system.backupModal.error.key": "Key field is required",

  "system.backupModal.error.confirm": "Key confirm field is required",
  "system.backupModal.error.duplicate.key": "The keys need to be the same",
  "system.general.message.disclaimer.pt": "Message - Brazilian portuguese",
  "system.general.message.disclaimer.en": "Message - English",
  "system.general.message": "Message",

  "system.restoreModal.title": "System Restore",
  "system.restoreModal.success": "System restored successfully!",
  "system.restoreModal.error.invalid": "Invalid key or backup file!",
  "system.restoreModal.key": "Key",
  "system.restoreModal.file": "Backup File",
  "system.restoreModal.error.key": "Key field is required",
  "system.restoreModal.error.file": "Backup File field is required",
  "system.restoreModal.upload.success": "file uploaded successfully",
  "system.restoreModal.upload.failed": "file upload failed",
  "system.restoreModal.upload.error.name":
    "File name cannot contain blank spaces!",

  "system.updates.connection.success": "Connection successful",
  "system.updates.connection.error": "Connection failed ",
  "system.updates.test.connection": "Test Connection ",
  "system.updates.save.proxy": "Save Proxy",
  "system.updates.reload.server": "Reload Server",
  "system.updates.save.server": "Save Server",
  "system.updates.proxy": "Update",
  "system.updates.confirm.reload.server":
    "Do you want to update the system and the bases?",
  "system.updates.scheduled.update": "Update schedule",
  "system.updates.automatically": "Update system automatically",
  "system.updates.bases.automatically": "Update bases automatically",
  "system.updates.server.proxy": "Proxy Server",
  "sandbox.form.advanced.note": "Probability acceptable (%)",
  "sandbox.form.advanced.note.error": "Inform value between 0 and 100",
  "sandbox.form.advanced.token": "Token",

  "system.storages.delete.confirm":
    "Are you sure you want to delete the system storages",
  "system.storages.delete.confirmMult":
    "Are you sure you want to delete the following system storages?",
  "system.storage.delete.title": "Confirm delete",

  "system.storages.actions.create.success":
    "System storage successfully created!",
  "system.storages.actions.create.error": "System storage have not been saved!",
  "system.storages.actions.delete.success":
    "System storage deleted successfully!",
  "system.storages.actions.delete.error": "System storage deleting error!",
  "system.storages.actions.delete.error.total":
    "{number} item(s) have not been deleted. System storage in use.",

  "system.storages.smb": "Storage SMB",
  "system.storages.nfs": "Storage NFS",
  "system.storages.ssh": "Storage SSH",
  "system.storages.usb": "Storage USB",
  "system.storages.ssh.public.key": "Public Key",
  "system.storages.usb.public.key": "Public Key",
  "system.storages.sftp.public.key": "Public Key",
  "system.storages.ssh.compression": "Compression",
  "system.storages.usb.compression": "Compression",
  "system.storages.sftp.compression": "Compression",
  "system.storages.ssh.copy": "Copy public key",
  "system.storages.usb.copy": "Copy public key",
  "system.storages.sftp.copy": "Copy public key",
  "system.storages.nfs.bytes.reading": "Reading Bytes",
  "system.storages.nfs.bytes.writing": "Writing Bytes",
  "system.storages.nfs.bytes.block.size": "Block sizes Bytes",
  "system.storages.nfs.disable.locking": "Disable locking",
  "system.storages.nfs.operation.mode": "Operation Mode",
  "system.storages.nfs.soft": "Soft",
  "system.storages.nfs.hard": "Hard",
  "system.storages.nfs.enable.posix": "Enable posix",
  "system.storages.nfs.extra.options": "Extra Options",
  "system.storages.add.actions.success": "Storage added successfully",
  "system.storages.del.actions.success": "Storage deleted successfully",
  "system.virtualDomain.del.actions.success":
    "Virtual domain deleted successfully",
  "system.virtualDomain.add.actions.success":
    "Virtual domain added successfully",
  "system.storages.upd.actions.success": "Storage updated successfully",
  "system.storages.del.actions.error.use": "Deleted error. Storage in use.",
  "system.storages.usb.device_usb": "USB Device",
  "system.storages.storage.unavailable": "Storage unavailable",
  "system.storages.storage.only.logger":
    "This Storage is mounted on the logger",
  "system.storages.only.logger": "Only Logger",

  "system.certificate.save.success": "Certificate successfully saved",
  "system.certificate.save.error": "Certificate have not been saved",
  "system.certificate.save.settings": "Save certificate",

  "license.serial": "Serial Number",
  "license.key": "License Key",
  "license.key.required": "License key is required",
  "license.status": "License Status",
  "license.expire": "License Expire Date",
  "license.registry": "Registry Date",
  "license.devices": "Number of Devices",
  "license.terms.accept": "Accept",
  "license.terms.accept.terms.of.use": "Terms Of Use",
  "license.terms.required": "Please agree the terms and conditions!",
  "license.terms.EULA":
    "BLOCKBIT\n" +
    "\n" +
    "END USER LICENSE AGREEMENT\n" +
    "\n" +
    'BY CLICKING "CONTINUE", YOU OR THE ENTITY THAT YOU REPRESENT ("LICENSEE") ARE UNCONDITIONALLY CONSENTING TO BE BOUND BY AND ARE BECOMING A PARTY TO THIS END USER LICENSE AGREEMENT ("AGREEMENT") WITH BLOCKBIT TECNOLOGIA LTDA.(“BLOCKBIT”). IF THESE TERMS ARE CONSIDERED AN OFFER, ACCEPTANCE IS EXPRESSLY LIMITED TO SUCH TERMS. IF LICENSEE DOES NOT UNCONDITIONALLY AGREE TO THE FOREGOING, CLICK THE "CANCEL" BUTTON AND THE INSTALLATION PROCESS WILL NOT CONTINUE. IF YOU CLICK THE “ACCEPT” BUTTON TO CONTINUE WITH INSTALLATON YOU ARE REPRESENTING AND WARRANTING THAT YOU ARE AUTHORIZED TO BIND LICENSEE.\n' +
    "\n" +
    "\n" +
    "1. Grant of License and Restrictions. Subject to the terms hereof, payment of all fees, and any applicable user/use limitations, BLOCKBIT grants Licensee a personal, non-sublicensable, nonexclusive, right to use the software that is directly accessible through this installation process, but only: (i) in object code form only (“Software”); (ii) on a specifically authorized machine located at a Licensee site authorized by BLOCKBIT; and (iii) in accordance with BLOCKBIT’s price list. BLOCKBIT retains ownership of the Software and Licensee will maintain the copyright notice and any other notices that appear on the Software or on any media containing the Software.\n" +
    "2. Updates, Content and Support Services. Updates, content and/or support services are not necessarily provided with the Software, and may require additional payment or include additional terms and conditions. However, to the extent that an update to the Software and/or content is provided, such update/content shall be deemed “Software” provided subject to this Agreement, and shall be licensed for use only on the specific machine for which it is licensed. If content/support services are provided, BLOCKBIT reserves the right to change the scope or duration of such services at any time, and to access, freely use and distribute data collected from Licensee through such services. If such services are made available, Licensee may be required to pay fees or other charges for use or access to some or all such services, which fees and terms will be specified in the invoice or order form for such service.\n" +
    "3. Restrictions. Licensee will not (and will not allow any third party to): (i) reverse engineer or attempt to discover any source code or underlying ideas or algorithms of the Software; (ii) provide, lease, lend, disclose, use for timesharing or service bureau purposes, or otherwise use or allow others to use for the benefit of any third party, the Software (except as expressly and specifically authorized by BLOCKBIT); (iii) without the express prior written consent of BLOCKBIT, conduct any benchmarking or comparative study or analysis involving the Software (“Benchmarking”) for any reason or purpose except, to the limited extent absolutely necessary, to determine the suitability of the Software to interoperate with Licensee’s internal computer systems; (iv) disclose to any third party any Benchmarking or any other information related thereto; (v) use the Software or any Benchmarking in connection with the development of products that compete with the Software; or (vi) reproduce, alter or modify the Software. Prior to disposing of any media or apparatus containing any part of the Software, Licensee shall completely destroy the Software contained therein. All the limitations and restrictions on Software in this Agreement also apply to documentation, reports and screens. Further, Software licensed without charge or for a nominal charge will be deemed a free evaluation license and only may be used for purposes of evaluating whether to obtain a paid license, and not for any productive use. LICENSEE ACKNOWLEDGES THAT THE SOFTWARE MAY INCLUDE FEATURES TO PREVENT USE AFTER THE APPLICABLE LICENSE PERIOD AND/OR USE INCONSISTENT HEREWITH. Licensee acknowledges that Software may be distributed alongside or contain or use certain open source or other third party software (“Third Party Software”). THIRD PARTY SOFTWARE IS (IN ADDITION TO THE TERMS AND CONDITIONS OF THIS AGREEMENT), SUBJECT TO AND GOVERNED BY (AND LICENSEE AGREES TO, AND WILL INDEMNIFY BLOCKBIT FOR NONCOMPLIANCE WITH) THE RESPECTIVE LICENSES FOR SUCH THIRD PARTY SOFTWARE. No rights or licenses are granted other than as expressly and unambiguously set forth herein.\n" +
    "4. Confidentiality. The Software in source code form remains a confidential trade secret of BLOCKBIT and/or its suppliers. The Software is protected by the copyright and other intellectual property laws of the United States and international treaties. Licensee acknowledges that, in the course of using the Software, Licensee may obtain or learn information relating to the Software, which may include, without limitation, information relating to the performance, reliability or stability of the Software, operation of the Software, know-how, techniques, processes, ideas, algorithms, and software design and architecture (“Proprietary Information”). As between the parties, such Proprietary Information shall belong solely to BLOCKBIT. During and after the term of this Agreement, Licensee shall hold in confidence and protect, and shall not use (except as expressly authorized by this Agreement) or disclose, Proprietary Information to any third party.\n" +
    "5. Termination. This Agreement is effective until terminated. Licensee may terminate this Agreement at any time by destroying all copies of the Software and related documentation. This Agreement will terminate automatically if Licensee fails to pay the full invoiced amount for the Software when due or fails to comply with any term or condition of this Agreement, including any attempt to transfer a copy of the Software to another party except as provided in this Agreement. Licensee agrees that upon such termination, Licensee will destroy all copies of the Software and related documentation. Except as otherwise expressly provided herein, the terms hereof shall survive any termination. Termination is not an exclusive remedy and all other remedies will be available whether or not termination occurs.\n" +
    "6. Limited Warranty and Disclaimer. LICENSEE ACKNOWLEDGES AND UNDERSTANDS THAT THE SOFTWARE LICENSED UNDER THIS AGREEMENT IS PROVIDED TO IT “AS IS” WITHOUT ANY WARRANTIES WHATSOEVER CONCERNING THE INSTALLATION, USE OR PERFORMANCE OF THE SOFTWARE. BLOCKBIT EXPRESSLY DISCLAIMS, AND LICENSEE HEREBY EXPRESSLY WAIVES ALL OTHER WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTIBILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, SYSTEM INTEGRATION, NON-INTERFERENCE, ACCURACY, RELIABILITY AND QUALITY OF THE SOFTWARE, INCLUDING AND WITHOUT DEROGATING FROM THE ABOVE, ANY WARRANTIES AND RIGHTS IMPLIED UNDER THE US UNIFORM COMMERCIAL CODE, UCITA (UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT) AND COMMON LAW. BLOCKBIT AND ITS SUPPLIERS DO NOT WARRANT THAT THE SOFTWARE WILL MEET LICENSEE’S REQUIREMENTS OR THAT THE OPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED OR ERROR-FREE. BLOCKBIT FURTHER DISCLAIMS, AND LICENSEE HEREBY EXPRESSLY WAIVES ALL WARRANTIES WITH RESPECT TO THE RESULTS, INFORMATION, DATA AND ANY ADVICE PROVIDED THROUGH THE SOFTWARE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO IT. BLOCKBIT shall have no responsibility to replace media if the failure of media results from accident, abuse or misuse of the media. THE SOFTWARE IS PROVIDED TO LICENSEE WITH NO WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.\n" +
    "7. Limitation of Liability. IN NO EVENT WILL BLOCKBIT OR ANYONE ELSE WHO HAS BEEN INVOLVED IN THE CREATION, PRODUCTION, OR DELIVERY OF THE SOFTWARE BE LIABLE FOR ANY INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES, INCLUDING WITHOUT LIMITATION, LOST PROFITS OR LOST DATA, EVEN IF THEY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.\n" +
    '8. Anticorruption Laws. Licensee acknowledges that it is familiar with and understands the provisions of the Lei Anticorrupção do Brasil nº 12.846/2013, U.S. Foreign Corrupt Practices Act (the "FCPA") and the U.K. Bribery Act of 2010 (“UKBA”) and agrees to comply with its terms as well as any provisions of local law or BLOCKBIT’s corporate policies and procedures related thereto. Licensee further understands the provisions relating to the Lei Anticorrupção do Brasil FCPA and UKBA’s prohibitions regarding the payment or giving of anything of value, including but not limited to payments, gifts, travel, entertainment and meals, either directly or indirectly, to an official of a foreign government or political party for the purpose of influencing an act or decision in his or her official capacity or inducing the official to use his or her party’s influence with that government, to obtain or retain business involving the Software. Licensee agrees to not violate or knowingly let anyone violate the Lei Anticorrupção do Brasil, FCPA or UKBA, and Licensee agrees that no payment it makes will constitute a bribe, influence payment, kickback, rebate, or other payment that violates the Lei Anticorrupção do Brasil, FCPA, the UKBA, or any other applicable anticorruption or antibribery law.\n' +
    "9. Evaluation. Notwithstanding anything to the contrary herein, if Licensee is using the Software for evaluation purposes then such use is subject to BLOCKBIT’s then current evaluation terms and conditions or other mutually agreed upon terms to govern such evaluation.\n" +
    "10. Miscellaneous. Neither this arrangement nor the licenses granted hereunder are assignable or transferable by Licensee (and any attempt to do so shall be void). BLOCKBIT may freely assign, delegate, license and/or transfer this Agreement, in whole or in part, without consent. This Agreement shall be deemed to have been made in, and shall be construed pursuant to the laws of the Brasil without regard to conflicts of laws provisions thereof, and without regard to the United Nations Convention on the International Sale of Goods or the Uniform Computer Information Transactions Act. Subject to the foregoing, the provisions hereof are for the benefit of the parties only and not for any other person or entity. Any notice, report, approval, authorization, agreement or consent required or permitted hereunder shall be in writing; notices shall be sent to the address the applicable party has or may provide by written notice or, if there is no such address, the most recent address the party giving notice can locate using reasonable efforts. No failure or delay in exercising any right hereunder will operate as a waiver thereof, nor will any partial exercise of any right or power hereunder preclude further exercise. If any provision shall be adjudged by any court of competent jurisdiction to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that this arrangement shall otherwise remain in full force and effect and enforceable. This is the complete and exclusive statement of the mutual understanding of the parties with respect to the license granted herein and supersedes and cancels all previous written and oral agreements and communications relating to such license and any waivers or amendments shall be effective only if executed in writing by BLOCKBIT; however, any pre-printed or standard terms of any purchase order, confirmation, or similar form, unless signed by BLOCKBIT after the effectiveness hereof, shall have no force or effect. The substantially prevailing party in any action to enforce this agreement will be entitled to recover its attorney’s fees and costs in connection with such action.\n",

  "update.runUpdateNow": "Update now",
  "update.version": "Version",
  "update.scheduled": "Scheduled",
  "update.running": "Update is running",

  "sessions.administration.modal.title": "Administrator Sessions",
  "sessions.administration.modal.label.start": "Session Start",
  "sessions.administration.modal.label.session": "Session",

  "sessions.idle": "Idle Timeout (minutes)",
  "sessions.login": "Login Attempts",
  "sessions.timeout": "Lock Timeout (minutes)",
  "sessions.active": "Active Sessions",
  "sessions.block_concurrent_changes": "Block concurrent changes",
  "system.sessions.activeModal.title": "Active Sessions",
  "system.sessions.datagrid.start": "Start",
  "system.sessions.datagrid.name": "Name",
  "system.sessions.datagrid.address": "Address",
  "system.sessions.datagrid.status": "Status",
  "system.sessions.datagrid.action": "Action",
  "system.sessions.datagrid.deleteTitle": "Delete Session",
  "system.sessions.datagrid.delete": "Delete",
  "system.sessions.datagrid.success": "Success removing session",
  "system.sessions.datagrid.error": "Error removing session",

  "system.highAvailability.listNos": "Interfaces List",
  "system.highAvailability.nodeList": "Node List",
  "system.highAvailability.interfaceFisica": "Physical Network Interface",
  "system.highAvailability.interfaceVirtual": "Virtual Network Interface",

  "sidebar.settings.system.mainNo": "Main Node",
  "settings.system.highAvailability.networkHeartbeat": "Heartbeat Interface",
  "settings.system.highAvailability.networkInterfaceRemoto": "Virtual Network Interface",
  "settings.system.highAvailability.networkInterfaceLocal": "Local Network Interface",
  "sidebar.settings.system.groupInterface": "Interface Group",
  "sidebar.settings.system.protocolUDP": "Use UDP protocol",
  "sidebar.settings.system.monitor": "Monitor",
  "sidebar.settings.system.on": "ON",
  "sidebar.settings.system.perfomance": "High performance",
  "system.highAvailability.create": "Create Interfaces",
  "system.highAvailability.remove": "Remove node",

  "system.highAvailability.operation_mode": "Operation Mode",
  "system.highAvailability.secret_key": "Secret Key",
  "system.highAvailability.local_key": "Local Key",
  "system.highAvailability.peer_ip1": "Peer IP #1",
  "system.highAvailability.peer_ip2": "Peer IP #2",
  "system.highAvailability.peer_ip3": "Peer IP #3",
  "system.highAvailability.peer_interface_1": "Peer Interface #1",
  "system.highAvailability.peer_interface_2": "Peer Interface #2",
  "system.highAvailability.peer_interface_3": "Peer Interface #3",
  "system.highAvailability.peer_key": "Peer Key",
  "system.highAvailability.heartbeat_interval": "Heartbeat Interval (seconds)",
  "system.highAvailability.sync_interval": "Sync Interval (minutes)",
  "system.highAvailability.failover_threshold": "Failover Threshold",
  "system.highAvailability.email_notifications": "E-mail Notifications",
  "system.highAvailability.auto_activation": "Auto Activation",
  "system.highAvailability.virtual_ip1": "Virtual IP",
  "system.highAvailability.netmask1": "Netmask",
  "system.highAvailability.virtual_mac1": "Virtual Mac",
  "system.highAvailability.add.actions.success":
    "successfully configured cluster",
  "system.highAvailability.verify":
    "Must not use this virtual interface while is a heartbeat interface",
  "system.highAvailability.sync": "Cluster synchronized successfully",
  "system.highAvailability.change.key": "Change Key",
  "system.highAvailability.change.copy": "Copy",
  "system.highAvailability.settings": "Cluster Settings",
  "system.highAvailability.interfaces": "Cluster Interfaces",
  "system.highAvailability.status": "Cluster Status",

  "system.highAvailability.local.state": "Local State",
  "system.highAvailability.active.uptime": "Active Uptime",
  "system.highAvailability.peer.connection": "Peer Connection",
  "system.highAvailability.peer.state": "Peer State",
  "system.highAvailability.syncronization.date": "Synchronization Date",
  "system.highAvailability.syncronization.status": "Synchronization Status",
  "system.highAvailability.primary.active": "Primary Active",
  "system.highAvailability.secondary.active": "Secondary Active",
  "system.highAvailability.standalone.active": "Standalone",
  "system.highAvailability.secondary.standby": "Secondary Standby",
  "system.highAvailability.primary.standby": "Primary Standby",
  "system.highAvailability.secondary.done": "Done",
  "system.highAvailability.sincronism": "Sync now",
  "system.highAvailability.sincronismCluster": "Update the information",
  "system.highAvailability.active": "Activate now",

  "clone.policy.packages": "Clone Policy Packages",
  "clone.policy.templates": "Clone Policy Templates",
  "clone.device.templates": "Clone Device Templates",
  "clone.confirm.message.policy.packages":
    "Select a version to clone Policy Packages:",
  "clone.confirm.message.policy.templates":
    "Select a version to clone Policy Templates:",
  "clone.confirm.message.device.templates":
    "Select a version to clone Device Templates:",

  "profile.application-control.title": "Application Control profile",

  "clone.profile.webfilter.title": "Web Filter Profile(s)",
  "clone.profile.application-control.title": "Application Control Profile(s)",
  "clone.profile.threat-protection.title": "Threat Protection Profile(s)",
  "clone.profile.intrusion-prevention.title": "Intrusion Prevention Profile(s)",
  "clone.profile.ssl.title": "SSL Inspection Profile(s)",
  "clone.profile.sd-wan.title": "SD-WAN Profile(s)",

  "clone.profile.webfilter": "Clone Web Filter Profile",
  "clone.profile.application-control": "Clone Application Control Profile",
  "clone.profile.threat-protection": "Clone Threat Protection Profile",
  "clone.profile.intrusion-prevention": "Clone Intrusion Prevention Profile",
  "clone.profile.ssl-inspection": "Clone SSL Inspection Profile",
  "clone.profile.sd-wan": "Clone SD-WAN Profile",

  "clone.confirm.message.profile.webfilter":
    "Select a version to clone Web Filter Profile:",
  "clone.confirm.message.profile.application-control":
    "Select a version to clone Application Control Profile:",
  "clone.confirm.message.profile.threat-protection":
    "Select a version to clone Threat Protection Profile:",
  "clone.confirm.message.profile.intrusion-prevention":
    "Select a version to clone Intrusion Prevention:",
  "clone.confirm.message.profile.ssl-inspection":
    "Select a version to clone SSL Inspection Profile:",
  "clone.confirm.message.profile.sd-wan":
    "Select a version to clone SD-WAN Profile:",

  "navbar.profile": "Profile",
  "navbar.logout": "Logout",
  "navbar.deploy": "deploy(s)",
  "navbar.deploy.accept": "accept",
  "navbar.deploy.running": "running",
  "navbar.deploy.pending": "pending",
  "navbar.deploy.withError": "with error",
  "navbar.deploy.deploysPanel": "Deploys Panel",
  "packages.title": "Install Package",
  "packages.what": "What",
  "packages.who": "Who",
  "packages.where": "Where",
  "packages.when": "When",
  "packages.packageType": "Package Type",
  "packages.installType": "Install Type",
  "packages.package": "Package",
  "packages.device": "Devices & Device group",
  "packages.dateTime": "Date and Time",
  "packages.assign": "Assign to",
  "packages.assign.tome": "Assign to me",
  "packages.comments": "Comments",
  "users.title": "Users",
  "users.tabs.users": "Users",
  "users.tabs.groups": "Groups",
  "users.groups.datagrid.name": "Name",
  "users.groups.datagrid.type": "Type",
  "users.groups.datagrid.deviceName": "Device Name",
  "users.groups.datagrid.used": "Used",
  "users.groups.datagrid.actions": "Actions",
  "users.groups.actions.create": "Create Group",
  "users.groups.actions.delete": "Delete Group",
  "users.groups.modal.title": "Create Group",
  "users.groups.modal.form.name": "Name",
  "users.groups.modal.form.description": "Description",
  "users.groups.modal.form.users": "Users",
  "users.groups.modal.form.error.name": "Name field is required",
  "users.groups.modal.form.error.name.exists": "This group name already exists",
  "users.groups.modal.form.error.description": "Description field is required",
  "users.groups.delete.title": "Confirm delete",
  "users.groups.delete.confirm": "Are you sure you want to delete the group",
  "users.groups.delete.confirmMult":
    "Are you sure you want to delete the following groups?",
  "users.groups.messages.saved": "Group saved successfully",
  "users.groups.messages.deleted": "Groups deleted successfully",
  "users.groups.messages.deleted.single": "Group deleted successfully",
  "users.users.datagrid.login": "Login",
  "users.users.datagrid.name": "Name",
  "users.users.datagrid.email": "E-mail",
  "users.users.datagrid.device": "Device",
  "users.users.datagrid.used": "Used",
  "users.users.datagrid.actions": "Actions",
  "users.users.actions.addToGroup": "Add to Group",
  "users.users.messages.success": "Users added successfully to group",
  "users.addUserGroup.title": "Add users to group",
  "users.addUserGroup.placeholder": "Select a group",
  "devices.title": "Devices",
  "devices.tabs.inventory": "Inventory",
  "devices.tabs.communities": "Communities",
  "devices.tabs.templates": "Templates",
  "devices.tabs.provisioning": "Provisioning",
  "devices.tabs.backups": "Backups",
  "devices.manager.action.automatic.sync.users": "User automatic sync",
  "devices.manager.action.automatic.tymeSync": "Synchronization time (hours)",
  "devices.manager.group.delete.success": "Group deleted successfully",
  "devices.manager.device.delete.success": "Device deleted successfully",
  "devices.manager.device.delete.error":
    "There was an error trying to delete the device",
  "devices.manager.device.resetStatus.error":
    "There was an error while trying to update the status of the devices",
  "devices.manager.device.sync.success": "Devices synchronized successfully",
  "devices.manager.device.sync.error":
    "There was an error while trying to synchronize the status of the devices",
  "devices.manager.device.update.error":
    "There was an error while trying to update the devices",
  "devices.manager.device.grid.connError": "CONNECTION ERROR",
  "devices.manager.device.grid.connOk": "CONNECTION ESTABLISHED",
  "devices.manager.device.grid.name": "Name",
  "devices.manager.device.grid.model": "Model",
  "devices.manager.device.grid.license_status": "License Status",
  "devices.manager.device.grid.version": "Version",
  "devices.manager.device.grid.template": "Template",
  "devices.manager.device.grid.policy_ipv4": "Policy IPv4",
  "devices.manager.device.grid.policy_ipv6": "Policy IPv6",
  "devices.manager.device.grid.actions": "Actions",
  "devices.manager.device.grid.actions.export.json": "Export to JSON",
  "devices.manager.device.grid.actions.export.csv": "Export to CSV",
  "devices.manager.device.grid.actions.createGroup": "Create Group",
  "devices.manager.device.grid.actions.deleteGroups": "Delete Groups",
  "devices.manager.device.grid.actions.managerGroups": "Manage Groups",
  "devices.manager.managerGroupsModal.title": "Manage Groups",
  "devices.manager.device.grid.actions.createDevice": "Create Device",
  "devices.manager.device.grid.actions.deleteDevices": "Delete Devices",
  "devices.manager.device.grid.actions.reloadStatus": "Reload Status",
  "devices.manager.device.grid.actions.synchronizeDevices":
    "Synchronize Devices",
  "devices.manager.device.grid.actions.updateDevices": "Update Devices",
  "devices.manager.updateModal.title": "Update/Sync Device",
  "devices.manager.updateModal.update": "Update Device",
  "devices.manager.updateModal.sync": "Synchronize Device",
  "devices.manager.groupModal.title.create": "Add Group",
  "devices.manager.groupModal.title.edit": "Edit Group",
  "devices.manager.groupModal.name": "Name",
  "devices.manager.groupModal.description": "Description",
  "devices.manager.groupModal.devices": "Devices",
  "devices.manager.groupModal.logger": "Logger",
  "devices.manager.groupModal.successCreate": "Group registered with success!",
  "devices.manager.groupModal.successUpdate": "Group updated with success!",
  "devices.manager.deviceModal.title.create": "Device",
  "devices.manager.deviceModal.sshkey": "Deploy Key",
  "devices.manager.deviceModal.apikey": "API Key",
  "devices.manager.deviceModal.useradmin": "User Admin",
  "devices.manager.deviceModal.adminpasswd": "Password",
  "devices.manager.deviceModal.group": "Device Group",
  "devices.manager.deviceModal.logger": "Logger",
  "devices.manager.deviceModal.name": "Name",
  "devices.manager.deviceModal.company": "Company",
  "devices.manager.deviceModal.description": "Description",
  "devices.manager.deviceModal.model": "Model",
  "devices.manager.deviceModal.successCreate":
    "Device registered with success!",
  "devices.manager.deviceModal.successUpdate": "Device updated with success!",
  "devices.manager.deviceModal.deviceNameAlready": "Device already exists",
  "devices.manager.deviceModal.error.errorExists": "Device already exists",
  "devices.manager.deviceModal.error.errorMax": "Error max (?)",
  "devices.manager.deviceModal.error.errorMaxDevices": "You have reached the maximum number of devices for your license.",
  "devices.manager.deviceModal.error.sshkey": "Deploy Key is required",
  "devices.manager.deviceModal.error.apikey": "API Key is required",
  "devices.manager.deviceModal.error.name": "Name is required",
  "devices.manager.deviceModal.error.company": "Company is required",
  "devices.manager.deviceModal.error.useradmin": "User Admin login is required",
  "devices.manager.deviceModal.error.ipexists":
    "It is not possible to register the same IP for an interface",
  "devices.manager.deviceModal.error.special.characters":
    "The password cannot contain the following special characters: \" & | ; > < ' ",
  "devices.manager.delete.group.title": "Delete group",
  "devices.manager.delete.group.message":
    "Are you sure you want to delete the group {name}?",
  "devices.manager.delete.device.title": "Delete device",
  "devices.manager.delete.device.message":
    "Are you sure you want to delete the device {name}?",
  "devices.manager.delete.group.title.mult": "Delete groups",
  "devices.manager.delete.group.message.mult":
    "Are you sure you want to delete the groups {name}?",
  "devices.manager.delete.device.title.mult": "Delete devices",
  "devices.manager.delete.device.message.mult":
    "Are you sure you want to delete the devices {name}?",

  "devices.community.modalAdd.title": "Create community",
  "devices.community.modalDelete.title": "Delete community",
  "devices.community.modalDelete.message":
    "Are you sure you want to delete the community: {name}?",
  "devices.community.modalDelete.message.plural":
    "Are you sure you want to delete the following communities?",
  "devices.community.create.title": "Create community",
  "devices.community.edit.title": "Edit community",
  "devices.community.delete.success": "Community deleted successfully",
  "devices.community.form.general": "General",
  "devices.community.form.general.name": "Name",
  "devices.community.form.general.description": "Description",
  "devices.community.form.general.ike_version": "IKE Version",
  "devices.community.form.general.exchange_mode": "Exchange Mode",
  "devices.community.form.general.exchange_mode.aggressive": "Aggressive",
  "devices.community.form.general.exchange_mode.main": "Main",
  "devices.community.form.general.topology": "Topology",
  "devices.community.form.general.shared_key": "Shared Key",
  "devices.community.form.card.settings": "Settings",
  "devices.community.form.save.error": "Device have not been saved",
  "devices.community.form.save.success": "Device added successfully",
  "devices.community.form.delete.device.success": "Device deleted successfully",
  "devices.community.form.error.role.already.exists":
    "This community already have one hub",
  "devices.community.form.error.required": "Please select at least two devices",

  "devices.community.device.grid.actions.addDevice": "Create device",
  "devices.community.device.grid.actions.removeDevice": "Delete device",
  "devices.community.device.modal.device": "Device",
  "devices.community.device.modal.listAdd": "Network",
  "devices.community.device.modal.host": "Local Host",
  "devices.community.device.modal.localId": "Local ID",
  "devices.community.device.modal.role": "Role",
  "devices.community.device.modal.dynamic": "Dynamic",

  "devices.community.form.success": "Community saved successfully",

  "devices.community.form.encryption": "Encryption",
  "devices.community.form.encryption.phase1": "Phase 1 (IKE)",
  "devices.community.form.encryption.phase2": "Phase 2 (ESP)",
  "devices.community.form.encryption.cryptography_algorithms": "Cryptography Algorithm",
  "devices.community.form.encryption.dh.group": "DH Group",
  "devices.community.form.encryption.pfs.group": "PFS Group",
  "devices.community.form.encryption.encryption_algorithms":
    "Encryption Algorithm",
  "devices.community.form.encryption.authentication_algorithms":
    "Authentication Algorithm",
  "devices.community.form.encryption.dh.group_algorithms": "DH Group",
  "devices.community.form.encryption.pfs.group_algorithms": "PFS Group",
  "devices.community.form.encryption.diffie_hellman":
    "Diffie-Hellman (DH) Group",
  "devices.community.form.encryption.esp_encryption_algorithms":
    "ESP Encryption Algorithms",
  "devices.community.form.encryption.esp_authentication_algorithms":
    "ESP Authentication Algorithms",
  "devices.community.form.encryption.perfect_forward":
    "Perfect Forward Secrecy (PFS) Group",

  "devices.community.form.advanced": "Advanced",
  "devices.community.form.advanced.ike_lifetime": "IKE lifetime (s) (seconds)",
  "devices.community.form.advanced.key_lifetime": "Key lifetime (s) (seconds)",
  "devices.community.form.advanced.keying_tries": "Keying Tries ",
  "devices.community.form.advanced.rekey_margin": "Rekey margin (s) (seconds)",
  "devices.community.form.advanced.dead_peer_action": "DPD Action",
  "devices.community.form.advanced.dead_peer_action.clear": "Clear",
  "devices.community.form.advanced.dead_peer_action.hold": "Hold",
  "devices.community.form.advanced.dead_peer_action.restart": "Restart",
  "devices.community.form.advanced.dead_peer_action.none": "None",
  "devices.community.form.advanced.dead_peer_delay": "DPD delay (s) (seconds)",
  "devices.community.form.advanced.dead_peer_timeout":
    "DPD timeout (s) (seconds)",
  "devices.community.form.advanced.reauth": "Re-Auth",
  "devices.community.form.advanced.fragmentation": "Fragmentation",
  "devices.community.form.advanced.compression": "Compression",
  "devices.community.form.advanced.natt": "NAT-T",

  "devices.community.form.general.name.error": "Name is required",
  "devices.community.form.general.shared_key.error": "Shared Key is required",
  "devices.community.form.advanced.ike_lifetime.error":
    "IKE lifetime is required",
  "devices.community.form.advanced.key_lifetime.error":
    "Key lifetime is required",
  "devices.community.form.advanced.keying_tries.error":
    "Keying Tries is required",
  "devices.community.form.advanced.rekey_margin.error":
    "Rekey margin is required",
  "devices.community.form.advanced.dead_peer_delay.error":
    "DPD delay is required",
  "devices.community.form.advanced.dead_peer_timeout.error":
    "DPD timeout is required",
  "devices.community.form.advanced.dead_peer_action.error":
    "DPD Action is required",

  "devices.template.title": "Device Template",
  "devices.template.datagrid.name": "Name",
  "devices.template.datagrid.description": "Description",
  "devices.template.datagrid.version": "Version",
  "devices.template.datagrid.actions": "Actions",
  "devices.template.actions.create": "Create Template",
  "devices.template.actions.delete": "Delete Template",
  "devices.template.actions.clone": "Clone Template",
  "devices.template.modal.form.title": "Create Template",
  "devices.template.modal.form.name": "Name",
  "devices.template.modal.form.version": "Version",
  "devices.template.modal.form.description": "Description",
  "devices.template.modal.delete.success": "Template deleted successfully!",
  "devices.template.modal.delete.error": "Group deleted error!",
  "devices.template.modal.clone.success": "Template cloned successfully!",
  "devices.template.modal.clone.error": "Template cloned error!",

  "devices.template.config.title": "Config Template",
  "devices.template.tabs.form.template": "Template",
  "devices.template.tabs.form.firewall": "Firewall",
  "devices.template.tabs.form.proxy": "Proxy",
  "devices.template.tabs.form.webcache": "Web Cache",
  "devices.template.tabs.form.webfilter": "Web Filter",
  "devices.template.tabs.form.antimalware": "Antimalware",
  "devices.template.tabs.form.dpi": "Deep Inspection",
  "devices.template.tabs.form.sdwan": "SD-WAN",
  "devices.template.tabs.form.dhcp": "DHCP",
  "devices.template.tabs.form.dns": "DNS",
  "devices.template.tabs.form.ddns": "DDNS",
  "devices.template.config.name": "Name",
  "devices.template.config.description": "Description",
  "devices.template.config.version": "Version",
  "devices.template.config.modules": "Modules",
  "devices.template.config.moduleSelect": "Select Module",

  "devices.template.firewall.form.services": "Services",
  "devices.template.firewall.form.securitysettings": "Security Settings",
  "devices.template.firewall.form.timeouts": "Timeouts",
  "devices.template.firewall.form.create.zone": "Zone Protection",
  "devices.template.firewall.actions.create": "Create Zone Protection",
  "devices.template.firewall.actions.delete": "Delete Zone Protection",
  "devices.template.firewall.form.zoneprotection": "New Zone Protection",
  "devices.template.firewall.form.addzone": "Zone added successfully",
  "devices.template.firewall.form.add.dos": "DoS Protection added successfully",
  "devices.template.firewall.form.add.ip.spoofing":
    "IP Spoofing added successfully",
  "devices.template.firewall.form.addservice": "Service added successfully",
  "devices.template.firewall.tab.policy": "Policy",
  "devices.template.firewall.tab.condition": "Condition",
  "devices.template.firewall.form.enabled": "Enabled",
  "devices.template.firewall.form.zone": "Zone",
  "devices.template.firewall.form.zones": "Zones",
  "devices.template.firewall.form.action": "Action",
  "devices.template.firewall.form.service": "Service",
  "devices.template.firewall.form.description": "Description",
  "devices.template.firewall.form.authenticated": "Authenticated",
  "devices.template.firewall.form.user": "User",
  "devices.template.firewall.form.group": "Group",
  "devices.template.firewall.form.ipv4src": "IPv4 Source IP",
  "devices.template.firewall.form.ipv4dest": "IPv4 Destination IP",
  "devices.template.firewall.form.ipv6src": "IPv6 Source IP",
  "devices.template.firewall.form.ipv6dest": "IPv6 Destination IP",
  "devices.template.firewall.form.hour": "Hour",
  "devices.template.firewall.form.dos.protection": "DoS Protection",
  "devices.template.firewall.form.syn.flood": "SYN flood",
  "devices.template.firewall.form.syn.flood.limit":
    "SYN flood limit (per second).",
  "devices.template.firewall.form.syn.flood.burst": "SYN flood burst",
  "devices.template.firewall.form.tcp.flood": "TCP flood",
  "devices.template.firewall.form.tcp.flood.limit":
    "TCP flood limit (per second).",
  "devices.template.firewall.form.tcp.flood.burst": "TCP flood burst",
  "devices.template.firewall.form.udp.flood": "UDP flood",
  "devices.template.firewall.form.udp.flood.limit":
    "UDP flood limit (per second).",
  "devices.template.firewall.form.udp.flood.burst": "UDP flood burst",
  "devices.template.firewall.form.icmp.flood": "ICMP flood",
  "devices.template.firewall.form.icmp.flood.limit":
    "ICMP flood limit (per second).",
  "devices.template.firewall.form.icmp.flood.burst": "ICMP flood burst",
  "devices.template.firewall.form.ip.spoofing": "IP Spoofing Protection",
  "devices.template.firewall.datagrid.description": "Description",
  "devices.template.firewall.datagrid.service": "Service",
  "devices.template.firewall.datagrid.action": "Action",
  "devices.template.firewall.datagrid.zone": "Zone",
  "devices.template.firewall.datagrid.auth": "Auth",
  "devices.template.firewall.form.lan": "LAN",
  "devices.template.firewall.form.wan": "WAN",
  "devices.template.firewall.form.dmz": "DMZ",
  "devices.template.firewall.form.both.http":
    "HTTP and HTTPS detected for the same port, or functional proxy service only in explicit mode.",
  "devices.template.firewall.form.options": "Options",
  "devices.template.firewall.all": "ALL",
  "devices.template.firewall.error.zone": "Select a zone",
  "devices.template.firewall.error.option": "Select an option",
  "devices.template.firewall.burst.rate": "Burst Rate (packets/second)",
  "devices.template.firewall.packet.rate": "Packet Rate (packets/second)",

  "devices.template.proxy.form.interface":
    "At least one interface ETH is required",
  "devices.template.proxy.form.sslexception": "SSL Exception",
  "devices.template.proxy.form.disablessl":
    " Disable SSL Inspection on Proxy service",
  "devices.template.proxy.form.required": "Is required",
  "devices.template.proxy.form.invalid": "Is invalid",
  "devices.template.proxy.form.port": "Port",
  "devices.template.proxy.form.ssl": "SSL",
  "devices.template.proxy.form.type": "Type",
  "devices.template.proxy.form.port21": "Port 21",
  "devices.template.proxy.form.port22": "Port 22",
  "devices.template.proxy.form.malwareScanning": "Malware Scanning",
  "devices.template.proxy.form.port25": "Port 25",
  "devices.template.proxy.form.port465": "Port 465",
  "devices.template.proxy.form.port587": "Port 587",
  "devices.template.proxy.form.addheader": "Add Header",
  "devices.template.proxy.form.port110": "Port 110",
  "devices.template.proxy.form.port995": "Port 995",
  "devices.template.proxy.form.spamassassin-active": "Spam filter (0~10)",
  "devices.template.proxy.form.spamassassin-value": "Between 0 and 10",
  "devices.template.proxy.form.emailSubject": "E-mail Subject",
  "devices.template.proxy.form.emailTemplate": "E-mail Template",
  "devices.template.proxy.form.explicit.proxy": "Explicit Proxy",
  "devices.template.proxy.form.explicit.proxy.warning":
    "For the Explicit Proxy functionality to work correctly, Zone Protection rules that may use the same Service must also be enabled",
  "devices.template.proxy.form.explicit.proxy.warning.message.part1": "The Zone Protection rule named ",
  "devices.template.proxy.form.explicit.proxy.warning.message.part2": " also uses the named ",
  "devices.template.proxy.form.explicit.proxy.warning.message.part3": " service and is disabled. Enable the rule mentioned for the correct operation of Explicit Proxy.",
  "devices.template.proxy.form.explicit.proxy.warning.message.part4": "The service selected for the Explicit Proxy is not used in any existing Zone Protection rule. For the Explicit Proxy to work correctly, a Zone Protection rule with the selected service must be created and enabled.",
  "devices.template.proxy.form.explicit.proxy.warning.message.part5": "Zone Protection rule associated:",
  "devices.template.proxy.form.authentication.mode": "Authentication Mode",
  "devices.template.proxy.form.authentication.mode.basic": "Basic",
  "devices.template.proxy.form.autentication.mode.captive": "Captive Portal",
  "devices.template.proxy.form.modal.error.rule.exists":
    "This rule already exists",

  "devices.template.antimalware.form.detect":
    "Detect potentially unwanted application",
  "devices.template.antimalware.form.block": "Block Encrypted Files",
  "devices.template.antimalware.form.heuristic": "Enable Behavioral and Dynamic Analysis",
  "devices.template.antimalware.form.passive": "Passive Mode",
  "devices.template.antimalware.form.filesize": "File size maximum",
  "devices.template.antimalware.form.quarantine": "Quarantine size",
  "devices.template.antimalware.form.dayin": "Days in quarantine",

  "devices.template.webfilter.form.custom": "Customize Blocking Page",
  "devices.template.webfilter.form.blocking.message":
    "Access control configuration prevents your request from being allowed at this time. Please contact your service provider if you feel this is incorrect.",
  "devices.template.webfilter.form.customnewlogo": "New Logo",
  "devices.template.webfilter.form.customblock": "Blocking message",
  "devices.template.webfilter.form.customredirect": "Redirect to external page",
  "devices.template.webfilter.form.hostname": "Hostname",
  "devices.template.webfilter.form.googledomains": " Google domains",
  "devices.template.webfilter.form.googleenabled": "Enabled",
  "devices.template.webfilter.form.googleaddress": "IP Address",
  "devices.template.webfilter.form.googlegroups": "Groups",
  "devices.template.webfilter.form.googleusers": "Users",
  "devices.template.webfilter.form.safe": " Safe search",
  "devices.template.webfilter.form.safeenabled": " Enabled",
  "devices.template.webfilter.form.safeaddress": "IP Address",
  "devices.template.webfilter.form.safegroups": "Groups",
  "devices.template.webfilter.form.safeusers": "Users",

  "devices.template.webcache.form.size": "Size of the cache in memory",
  "devices.template.webcache.form.maximum":
    "Maximum size of the object in memory",
  "devices.template.webcache.form.disk": "Disk cache size",
  "devices.template.webcache.form.minimum": "Minimum object size on disk",
  "devices.template.webcache.form.dynamic": "Dynamic content cache",
  "devices.template.webcache.form.exception": "Exception cache",

  "devices.template.dns.form.configuration": "Configuration",
  "devices.template.dns.form.dnsservers": "DNS Servers",
  "devices.template.dns.form.interfaces": "Interfaces",
  "devices.template.dns.form.dnscache": "DNS Cache",
  "devices.template.dns.form.security": "Security",
  "devices.template.dns.form.rebind": "Rebind Protection",
  "devices.template.dns.form.allowlocal": "Allow Local",
  "devices.template.dns.form.allowdomains": "Allowed Domains",
  "devices.template.dns.form.redirection": "Redirection",
  "devices.template.dns.modal.title": "New Redirection",
  "devices.template.dns.modal.server": "DNS Server",
  "devices.template.dns.modal.redirect": "Redirect address",
  "devices.template.dns.datagrid.server": "DNS Server",
  "devices.template.dns.save.success": "Server added successfully",
  "devices.template.dns.actions.create": "Create Server",
  "devices.template.dns.actions.delete": "Delete Server",

  "devices.template.dpi.modal.titleProfile": "DPI Profile",
  "devices.template.dpi.modal.titleWhite": "Allowed Addresses",
  "devices.template.dpi.modal.titleBlack": "Blocked Addresses",
  "devices.template.dpi.modal.error.delete.profile":
    "Cant delete {name}. Profile in use on Zone Protection.",
  "devices.template.dpi.modal.form.error.name.exists":
    "A profile with this name already exists.",
  "devices.template.dpi.delete.success": "Profile deleted successfully",
  "devices.template.dpi.delete.error": "Profile deleted error!",
  "devices.template.dpi.delete.error.inUse":
    "Can't delete profile! Profile in use",
  "devices.template.dpi.datagrid.profiles": "Profiles",
  "devices.template.dpi.datagrid.name": "Name",
  "devices.template.dpi.datagrid.type": "Type",
  "devices.template.dpi.datagrid.whitelist": "Allowed Addresses",
  "devices.template.dpi.datagrid.blacklist": "Blocked Addresses",
  "devices.template.dpi.datagrid.actions": "Actions",
  "devices.template.dpi.datagrid.status": "Status",
  "devices.template.dpi.datagrid.block": "Block",
  "devices.template.dpi.datagrid.risk": "Risk",
  "devices.template.dpi.datagrid.quarantine": "Quarantine",
  "devices.template.dpi.datagrid.signature": "Signature",
  "devices.template.dpi.datagrid.ip.address": "IP Address",
  "devices.template.dpi.datagrid.direction": "Direction",
  "devices.template.dpi.datagrid.category": "Category",
  "devices.template.dpi.datagrid.hight": "Hight",
  "devices.template.dpi.datagrid.medium": "Medium",
  "devices.template.dpi.datagrid.low": "Low",
  "devices.template.dpi.datagrid.required.fields": "All fields are required",
  "devices.template.dpi.datagrid.already.exists": "Exception already exists",
  "devices.template.dpi.profile.name": "Name",
  "devices.template.dpi.profile.description": "Description",
  "devices.template.dpi.profile.type": "Type",
  "devices.template.dpi.profile.process": "Process",
  "devices.template.dpi.profile.devin": "Input Interface",
  "devices.template.dpi.profile.devout": "Output Interface",
  "devices.template.dpi.profile.intrusionPrevention": "Intrusion Prevention",
  "devices.template.dpi.profile.advancedProtection":
    "Advanced Threat Protection",
  "devices.template.dpi.profile.applicationControl": "Application Control",
  "devices.template.dpi.profile.automaticRules":
    "Enable automatic rules update",
  "devices.template.dpi.profile.allPorts": "Inspect all ports",
  "devices.template.dpi.list.ipmask": "IP/MASK",

  "devices.template.sdwan.modal.title": "SD-WAN Profile",
  "devices.template.sdwan.tab.interface": "Interfaces",
  "devices.template.sdwan.tab.monitor": "Monitor",
  "devices.template.sdwan.actions.createProfile": "Create Profile",
  "devices.template.sdwan.actions.deleteProfile": "Delete Profile",
  "devices.template.sdwan.save.successProfile": "Profile saved successfully",
  "devices.template.sdwan.save.errorProfile": "Profile have not been saved",
  "devices.template.sdwan.modal.form.error.name.exists":
    "A profile with this name already exists.",
  "devices.template.sdwan.delete.success": "Profile deleted successfully",
  "devices.template.sdwan.delete.error": "Profile deleted error!",
  "devices.template.sdwan.delete.error.inUse":
    "Can't delete profile! Profile in use",
  "devices.template.sdwan.datagrid.profiles": "Profiles",
  "devices.template.sdwan.datagrid.name": "Name",
  "devices.template.sdwan.datagrid.description": "Description",
  "devices.template.sdwan.datagrid.version": "Version",
  "devices.template.sdwan.datagrid.type": "Type",
  "devices.template.sdwan.datagrid.interfaces": "Interfaces",
  "devices.template.sdwan.datagrid.actions": "Actions",
  "devices.template.sdwan.form.name": "Name",
  "devices.template.sdwan.form.version": "Version",
  "devices.template.sdwan.form.description": "Description",
  "devices.template.sdwan.form.type": "Type",
  "devices.template.sdwan.form.interfaces": "Interfaces",
  "devices.template.sdwan.form.monitorInterval": "Monitoring Interval (sec)",
  "devices.template.sdwan.form.balancingInterval": "Balancing Interval (min)",
  "devices.template.sdwan.form.failRatio": "Fail ratio (1 - 100%)",
  "devices.template.sdwan.form.bandwidth": "Bandwidth (Mbps)",
  "devices.template.sdwan.form.qualityCriteria": "Quality criteria (Mbps)",
  "devices.template.sdwan.form.persistentConn": "Persistent connection",
  "devices.template.sdwan.form.persistenceTimeout":
    "Persistence timeout 1-1440 minutes",
  "devices.template.sdwan.form.persistenceTimeoutReduce":
    "Persistence timeout 1-1440 min",
  "devices.template.sdwan.form.device-description": "Device Description",
  "devices.template.sdwan.form.packet-duplication": "Packet Duplication",
  "devices.template.sdwan.form.load-balance": "Load Balance",
  "devices.template.sdwan.form.loadbalance": "Load Balance",
  "devices.template.sdwan.form.valueJitter": "Jitter",
  "devices.template.sdwan.form.valueLatency": "Latency",
  "devices.template.sdwan.form.valuePacketLoss": "Packet Loss",
  "devices.template.sdwan.form.valueBandwidth": "Bandwidth",
  "devices.template.sdwan.form.address": "Address",
  "devices.template.sdwan.form.protocol": "Protocol",
  "devices.template.sdwan.form.attempts": "Attempts",
  "devices.template.sdwan.form.timeout": "Timeout",
  "devices.template.sdwan.form.performance": "Performance Indicators",
  "devices.template.sdwan.form.monitoring": "Monitoring Targets",
  "devices.template.sdwan.form.error.loadbalance.invalid":
    "Total loadbalance invalid",
  "devices.template.sdwan.form.error.interface.invalid":
    "Please select one interface",
  "devices.template.sdwan.form.error.address": "Invalid Address",
  "devices.template.sdwan.form.modal.error.rule.exists":
    "This address already exists",
  "devices.template.sdwan.form.failback": "Failback",

  "devices.template.ssl.modal.title": "SSL Profile",
  "devices.template.ssl.form.name": "Name",
  "devices.template.ssl.form.settings.workers": "Number of Workers",
  "devices.template.ssl.form.limit": "Number of availables CPUs excedeed",
  "devices.template.ssl.form.min": "The mininum number of workers is 1",
  "devices.template.ssl.form.version": "Version",
  "devices.template.ssl.form.description": "Description",
  "devices.template.ssl.form.mode": "Mode",
  "devices.template.ssl.form.protocols": "Protocols",
  "devices.template.ssl.form.exception": "Inspection Exception",
  "devices.template.ssl.form.dictionary": "Dictionary",
  "devices.template.ssl.datagrid.name": "Name",
  "devices.template.ssl.datagrid.description": "Description",
  "devices.template.ssl.datagrid.version": "Version",
  "devices.template.ssl.datagrid.mode": "Mode",
  "devices.template.ssl.datagrid.actions": "Actions",
  "devices.template.ssl.save.successProfile": "Profile saved successfully",
  "devices.template.ssl.save.errorProfile": "Profile have not been saved",
  "devices.template.ssl.delete.success": "Profile deleted successfully",
  "devices.template.ssl.delete.error": "Profile deleted error",
  "devices.template.ssl.delete.error.inUse":
    "Can't delete profile! Profile in use",

  "devices.template.sdwan.modal.titleService": "SD-WAN Service",
  "devices.template.sdwan.actions.createService": "Create Service",
  "devices.template.sdwan.actions.deleteService": "Delete Service",
  "devices.template.sdwan.save.successService": "Service added successfully",
  "devices.template.sdwan.form.enable": "Enable",
  "devices.template.sdwan.form.service": "Service",
  "devices.template.sdwan.form.dstAddress": "Destination IP Address",
  "devices.template.sdwan.form.profile": "Profile",
  "devices.template.sdwan.actions.delete.service":
    "Are you sure you want to delete",

  "devices.template.dhcp.datagrid.servers": "Servers",
  "devices.template.dhcp.datagrid.interface": "Interface",
  "devices.template.dhcp.datagrid.type": "Type",
  "devices.template.dhcp.datagrid.range": "Range",
  "devices.template.dhcp.datagrid.relay": "Relay",
  "devices.template.dhcp.datagrid.actions": "Actions",
  "devices.template.dhcp.modal.titleServer": "DHCP Server",
  "devices.template.dhcp.modal.titleRange": "DHCP Range",
  "devices.template.dhcp.modal.titleRelay": "DHCP Relay",

  "devices.template.dhcp.modal.interface": "Interface",
  "devices.template.dhcp.modal.description": "Description",
  "devices.template.dhcp.modal.type": "Type",
  "devices.template.dhcp.modal.gateway": "Gateway",
  "devices.template.dhcp.modal.dnsSufix": "DNS Sufix",
  "devices.template.dhcp.modal.renewaltime": "Renewal time (seconds)",
  "devices.template.dhcp.modal.dns": "DNS",
  "devices.template.dhcp.modal.wins": "WINS",
  "devices.template.dhcp.modal.tftp": "TFTP Server (option 150)",
  "devices.template.dhcp.modal.rangeini": "Range init",
  "devices.template.dhcp.modal.rangeend": "Range end",
  "devices.template.dhcp.modal.macfilter": "MAC Filter",
  "devices.template.dhcp.modal.ipv4server": "IPV4 Server",
  "devices.template.dhcp.modal.ipv6server": "IPV6 Server",
  "devices.template.dhcp.modal.enableDhcp": "Enable DHCP",
  "devices.template.dhcp.modal.renewaltime.invalid": "Invalid renewal time!",

  "devices.template.dhcp.actions.createServer": "Create Server",
  "devices.template.dhcp.actions.deleteServer": "Delete Server",
  "devices.template.dhcp.actions.createRange": "Create Range",
  "devices.template.dhcp.actions.deleteRange": "Delete Range",
  "devices.template.dhcp.actions.createRelay": "Create Relay",
  "devices.template.dhcp.actions.deleteRelay": "Delete Relay",
  "devices.template.dhcp.actions.remove.text": "Are you sure you want to delete",

  "devices.service.dhcp.settings.authentication.radius": "RADIUS Authentication",
  "devices.service.dhcp.settings.adress.static": "Static addresses",
  "devices.service.dhcp.settings.import.static.title": "Import Static Addresses",
  "devices.service.dhcp.settings.import.static.add": "Add Host",
  "devices.service.dhcp.settings.import.static.edit": "Edit Host",
  "devices.service.dhcp.settings.range.edit": "Edit Range",
  "devices.service.dhcp.settings.range.add": "Add Range",
  "devices.service.dhcp.settings.range.settings": "Range setting",
  "devices.service.dhcp.settings.win.primary": "WINS Primary",
  "devices.service.dhcp.settings.win.secudary": "WINS Secondary",
  "devices.service.dhcp.settings.tftp.primary": "TFTP Primary",
  "devices.service.dhcp.settings.tftp.secudary": "TFTP Secondary",
  "devices.service.dhcp.add.server.noDevice": "No interface available, check Network Settings.",
  "devices.service.dhcp.add.server.select.interface": "Please select your interface!",
  "devices.service.dhcp.add.server.select.type": "Type IP",
  "devices.service.dhcp.add.Relay.title.add": "Add Relay",
  "devices.service.dhcp.add.Relay.title.edit": "Edit Relay",
  "devices.service.dhcp.add.Relay.server.ipv6": "IPv6 Servers",
  "devices.service.dhcp.add.Relay.server.ipv4": "IPv4 Servers",
  "devices.service.dhcp.lease.remove": "Are you sure you want to delete the following Lease?",
  "devices.service.dhcp.datagrid.options.title": "Additional DHCP Options",
  "devices.service.dhcp.modal.options.title.add": "Create New DHCP Options",
  "devices.service.dhcp.modal.options.title.edit": "Edit DHCP Options",
  "devices.service.dhcp.modal.options.label.code": "Option Code",
  "devices.service.dhcp.modal.options.placeholder.value": "Enter the Value",
  "devices.service.dhcp.modal.options.code": "Code",
  "devices.service.dhcp.modal.options.info.redirect": "*When applying the queue the DHCP service will be restarted, to check its status click here.",

  "devices.service.dhcp.message.relay.setting": "Configured DHCP Relay!",
  "devices.service.dhcp.message.no.range": "Range not configured! Set a range before saving.",
  "devices.service.dhcp.message.value.integer": "The time value for lease must be integer!",
  "devices.service.dhcp.message.ipRadius.required": "Radius IP field is required!",
  "devices.service.dhcp.message.secret.Radius.required": "Radius Secret Field is required!",
  "devices.service.dhcp.message.range.delete.sucess": "Range deleted successfully!",
  "devices.service.dhcp.message.object.interface": "Error! Cannot edit interface address.",
  "devices.service.dhcp.message.invalid.range": "Invalid range! The final Range must be greater than the initial one!",
  "devices.service.dhcp.message.invalid.ranges": "Invalid ranges!",
  "devices.service.dhcp.message.invalid.ranges.out": "Interface IP address not found within selected range!",
  "devices.service.dhcp.message.invalid.ranges.AlreadyExists": "Range contained in another registered!",
  "devices.service.dhcp.message.invalid.ranges.out.interface": "Incorrect gateway: out of interface range!",
  "devices.service.dhcp.message.invalid.ranges.broadcast": "Bad gateway: network or broadcast address!",
  "devices.service.dhcp.message.invalid.mac": "Mac error reported!",
  "devices.service.dhcp.message.range.save.sucess": "Range Saved successfully!",
  "devices.service.dhcp.message.static.Already.used": "Host is already being used on static addresses!",
  "devices.service.dhcp.message.static.ip.Already.used": "IP is already being used on static addresses!",
  "devices.service.dhcp.message.static.mac.Already.used": "Mac is already being used on static addresses!",
  "devices.service.dhcp.message.static.not.subnet": "IP address does not belong to subnet!",
  "devices.service.dhcp.message.import.empty": "import cancelled! Empty file!",
  "devices.service.dhcp.message.fields": "import cancelled! error in fields: ",
  "devices.service.dhcp.message.fields.host": "Import cancelled! Hostname Duplication: ",
  "devices.service.dhcp.message.fields.ip": "Import cancelled! IP duplication: ",
  "devices.service.dhcp.message.fields.mac": "Import cancelled! Mac Addess Duplication: ",
  "devices.service.dhcp.message.import.sucess": " records successfully imported!",
  "devices.service.dhcp.message.line": "at line: ",
  "devices.service.dhcp.message.used.radius": " Changing the DHCP server can cause an IP conflict.",

  "devices.template.ddns.form.dynamicDNS": "Dynamic DNS",
  "devices.template.ddns.modal.title": "New Host",
  "devices.template.ddns.actions.create": "Create Host",
  "devices.template.ddns.actions.delete": "Delete Host",
  "devices.template.ddns.datagrid.service": "Service",
  "devices.template.ddns.datagrid.host": "Host",
  "devices.template.ddns.datagrid.interface": "Interface",
  "devices.template.ddns.datagrid.user": "User",
  "devices.template.ddns.datagrid.password": "Password",
  "devices.template.ddns.datagrid.actions": "Action",
  "devices.template.ddns.save.success": "Host added successfully",

  "devices.template.custom.branding": "Custom Branding",
  "devices.template.custom.custom": "Custom",
  "devices.template.custom.title": "Page Title",
  "devices.template.custom.favicon": "Favicon",
  "devices.template.custom.favicon.recommended": "Recommended PNG or ICO 32x32",
  "devices.template.custom.logo": "Logotipo",
  "devices.template.custom.logo.recommended": "Recommended SVG 300x65",
  "devices.template.custom.background": "Background",
  "devices.template.custom.background.recommended":
    "Recommended PNG ou JPG 1920x1080",
  "devices.template.custom.upload": "Click to upload",
  "devices.template.custom.preview": "Preview",
  "devices.template.custom.restore": "Restore Default",
  "devices.template.custom.restore.confirm":
    "Do you confirm the restore default?",
  "devices.template.custom.color": "Color",
  "devices.template.custom.upload.error.size": "File must smaller than 2MB",
  "devices.template.custom.upload.error.dimension":
    "The dimensions of the image are not following the recommended.",
  "devices.template.custom.color.menu_section_bg_color": "Section",
  "devices.template.custom.color.menu_section_color": "Section Font",
  "devices.template.custom.color.menu_selected_bg_color": " Selected",
  "devices.template.custom.color.menu_selected_color": "Selected Font",
  "devices.template.custom.color.menu_open_bg_color": "Open",
  "devices.template.custom.color.menu_open_color": "Open Font",
  "devices.template.custom.color.menu_open_hover_color": "Open F Hover",
  "devices.template.custom.color.menu_bg_color": "Menu",
  "devices.template.custom.color.menu_color": "Menu Font",
  "devices.template.custom.color.menu_base_bg_color": "Base",

  "devices.profiles.intrusion.prevention.form.name": "Name",
  "devices.profiles.intrusion.prevention.form.version": "Version",
  "devices.profiles.intrusion.prevention.form.description": "Description",
  "profiles.intrusionprevention.error.processes.limit": "Process limit reached",

  "devices.template.provisioning": "Template Provisioning",
  "devices.template.provisioning.add.batch": "Batch Provisioning",
  "devices.template.provisioning.file": "File",
  "devices.template.provisioning.line": "Line",
  "devices.template.provisioning.view.uuid": "View UUID Error",
  "devices.template.provisioning.name.and.uuid": "Name and UUID",
  "devices.template.provisioning.import.file": "Import file",
  "devices.template.provisioning.download.file": "Download model",
  "devices.import-rule.error.file": "File is not valid",
  "devices.template.provisioning.return": "Back",
  "devices.template.provisioning.import.success":
    "{number} item(s) imported successfully",
  "devices.template.provisioning.import.error": "Error import batch",
  "devices.template.provisioning.import.error.check.file":
    "Error import batch. Check your import file.",
  "devices.template.provisioning.batch.import.error":
    "Batch could not be imported",
  "devices.template.provisioning.delete.batch": "Delete batch",
  "devices.template.provisioning.delete.unique": "Delete",
  "devices.template.provisioning.error.duplicate.eth": "Duplicate ETH",
  "devices.template.provisioning.error.duplicate.name": "Duplicate name",
  "devices.template.provisioning.error.duplicate.uuid": "Duplicate UUID",
  "devices.template.provisioning.error.errorexists":
    "Name or UUID already registered",
  "devices.template.provisioning.error.validate.error": "Invalid fields",
  "devices.backups.status.partial": "Partial",
  "devices.template.provisioning.error.field": "Empty field",
  "devices.template.provisioning.status.costumer": "Customer ID error",
  "devices.template.provisioning.status.used": "License in use",
  "devices.template.provisioning.status.expired": "Expiration date",
  "devices.template.provisioning.status.found": "License not found",
  "devices.template.provisioning.status.inactive": "Inactive license",
  "devices.template.provisioning.error.file.csv":
    "You can only upload CSV file",

  "devices.backups.create": "Create backup",
  "devices.backups.delete": "Delete backup",
  "devices.backups.last.backup": "Last backup",
  "devices.backups.last.status": "Last status",
  "devices.backups.next.backup": "Next backup",
  "devices.backups.backup.details": "Backups details",
  "devices.backups.backup.history": "Backups history",
  "devices.backups.status.error.disk": "Error Storage",
  "devices.backups.status.error.disk.full": "Storage full",
  "devices.backups.backup.system": "System",
  "devices.backups.backup.snapshot": "Snapshot",
  "devices.backups.backup.remote.storage": "Remote Storage",
  "devices.backups.backup.retention.backup": "Number of Backup Retention",
  "devices.backups.backup.retention.percent": "Percent Usage Retention",
  "devices.backups.backup.schedule": "Schedule",
  "devices.backups.backup.select.type": "Select a type",
  "devices.backups.backup.select.device": "Select a device",
  "devices.backups.backup.select.device.group": "Select a group",
  "devices.backups.backup.devices": "Devices",
  "devices.backups.backup.devices.group": "Devices Group",
  "devices.backups.schedule.disabled": "Disabled",
  "devices.backups.schedule.oneshot": "Oneshot",
  "devices.backups.schedule.daily": "Daily",
  "devices.backups.schedule.weekly": "Weekly",
  "devices.backups.schedule.monthly": "Monthly",
  "devices.backups.schedule.month.day": "Month day",
  "devices.backups.schedule.week.day": "Week day",
  "devices.backups.schedule.date.time": "Date and time",
  "devices.backups.action.save.success": "Backup saved successfully",
  "devices.backups.action.running.success": "Backup is running",
  "devices.backups.action.save.error": "Backup saved error",
  "devices.backups.action.delete.success": "Backup(s) deleted successfully",
  "devices.backups.action.delete.error": "Backup(s) deleted error",
  "devices.backups.action.delete.storage.error":
    "Backup(s) deleted error. Storage unavailable.",
  "devices.backups.action.restore.success":
    "Wait. Your backup is in the process of being restored.",
  "devices.backups.action.restore.success.manager":
    "Backup restored successfully",
  "devices.backups.action.restore.already.exists":
    "Wait. There is a backup in process of restoration",
  "devices.backups.action.restore.error.encryption.key":
    "Backup restored error. Invalid secret.",
  "devices.backups.action.restore.error": "Backup restored error",
  "devices.backups.action.disabled.success": "Backup disabled successfully",
  "devices.backups.action.disabled.error": "Backup disabled error",
  "devices.backups.action.enabled.success": "Backup enabled successfully",
  "devices.backups.action.enabled.error": "Backup enabled error",
  "devices.backups.action.stop.success": "Backup stopped successfully",
  "devices.backups.action.stop.error": "Backup stopped error",
  "devices.backups.action.duplicate.error": "Duplicate field",
  "devices.backups.action.already.exists": "Backup name already created",
  "devices.backups.action.disabled": "Disabled backup",
  "devices.backups.action.enabled": "Enabled backup",
  "devices.backups.status.success": "Success",
  "devices.backups.status.stopped": "Stopped",
  "devices.backups.status.waiting": "Waiting",
  "devices.backups.status.restoring": "Restoring",
  "devices.backups.status.waiting.schedule":
    "Waiting for finalization of the schedule",
  "devices.backups.status.running": "Running",
  "devices.backups.status.downloading": "Downloading",
  "devices.backups.status.pending": "Pending",
  "devices.backups.status.error": "Error",
  "devices.backups.status.deploy.running": "Deploy Running",
  "devices.backups.status.cancelled": "Cancelled",
  "devices.backups.backup.not.done": "Not done",
  "devices.backups.backup.not.scheduled": "Unscheduled",
  "devices.backups.backup.download": "Download",
  "devices.backups.backup.restore": "Restore",
  "devices.backups.backup.stop": "Stop",
  "devices.backups.backup.view.details": "View details",
  "devices.backups.backup.download.start":
    "Your download will start in a few seconds",
  "devices.backups.backup.download.error": "Download error",
  "devices.backups.backup.encryption.key": "Secret",

  "policies.header": "Policies",
  "policies.tab.package.title": "Policy Packages",
  "policies.tab.template.title": "Policy Templates",

  "policies.package.title": "Policy Package",
  "policies.package.grid.policies": "Policies",
  "policies.package.bulk.create": "Create Package",
  "policies.package.bulk.delete": "Delete Package",
  "policies.package.bulk.clone": "Clone Package",
  "policies.package.saved": "Package created successfully",
  "policies.package.edited": "Package edited successfully",
  "policies.package.cloned": "Package cloned successfully",
  "policies.package.deleted": "Package deleted successfully",
  "policies.package.error": "Network Error!",

  "policies.templates.title": "Policy Template",
  "policies.templates.bulk.create": "Create Template",
  "policies.templates.bulk.delete": "Delete Template",
  "policies.templates.bulk.clone": "Clone Template",
  "policies.templates.saved": "Package created successfully",
  "policies.templates.edited": "Package edited successfully",
  "policies.templates.cloned": "Package cloned successfully",
  "policies.templates.deleted": "Package deleted successfully",
  "policies.templates.error": "Error!",

  "policy.manager.title": "Policy Manager",
  "policy.manager.readonly": "(read only)",
  "policy.manager.position.header": "Pre Rules",
  "policy.manager.position.footer": "Post Rules",
  "policy.manager.position.local": "Local Rules",
  "policy.manager.group.create": "Create Group",
  "policy.manager.group.delete": "Delete Groups",
  "policy.manager.group.created": "Group created successfully",
  "policy.manager.group.edited": "Group edited successfully",
  "policy.manager.group.deleted": "Group deleted successfully",
  "policy.manager.order.changed": "Order changed successfully",
  "policy.manager.policy.saved": "Policy saved successfully",
  "policy.manager.policy.enabled": "Policy enabled",
  "policy.manager.policy.disabled": "Policy disabled",
  "policy.manager.policy.deleted": "Policy deleted successfully",
  "policy.manager.policy.create": "Create Policy",
  "policy.manager.policy.delete": "Delete Policies",
  "policy.manager.policy.import": "Import Template",
  "policy.manager.policy.save": "Save Template",
  "policy.manager.policy.action.allow": "Allow",
  "policy.manager.policy.action.reject": "Reject",
  "policy.manager.policy.action.deny": "Deny",

  "policy.manager.policy.validation.modal.conclicted_with":
    "Conflicted with policy id",
  "policy.manager.policy.validation.modal.type": "Conflict type",
  "policy.manager.policy.validation.modal.type.1": "Overlay",
  "policy.manager.policy.validation.modal.type.2":
    "Identical params but different actions",
  "policy.manager.policy.validation.modal.type.3": "Duplicate",
  "policy.manager.policy.validation.modal.verified": "Verified at",
  "policy.manager.policy.validation.modal.description": "Description",

  "policy.manager.group.valid_polices": "Validate all policies",
  "policy.manager.group.header.rule": "rule",
  "policy.manager.group.header.source": "source",
  "policy.manager.group.header.destination": "destination",
  "policy.manager.group.header.schedule": "schedule",
  "policy.manager.group.header.services": "services",
  "policy.manager.group.header.tags": "tags",
  "policy.manager.group.header.modules": "modules",
  "policy.manager.group.header.action": "action",
  "policy.manager.group.expand_all": "Expand All",
  "policy.manager.group.collapse_all": "Collapse All",
  "policy.manager.notags": "no tags",
  "policy.manager.network_zone": "Network Zone: {zone}",
  "policy.manager.network_interface": "Network Interface: {interface}",
  "policy.manager.network_macaddress": "Mac Address: {mac}",
  "policy.manager.filter.changed": "Filter changed",
  "policy.manager.error": "Error!",
  "policy.manager.invalid": "Invalid operation!",
  "policy.manager.template.imported": "Template imported successfully",
  "policy.manager.template.saved": "Template saved successfully",
  "policy.manager.policy.cloned": "Rule cloned with success",
  "policy.manager.policy.clone": "Clone",
  "policy.manager.policy.clone.title": "Confirm to clone",
  "policy.manager.policy.clone.confirm":
    "Are you sure you want to clone the rule {ruleName}?",

  "policy.modal.form.error.name.exists": "This policy name already exists",

  "policy.form.properties": "Properties",
  "policy.form.properties.general": "General",
  "policy.form.properties.name": "Name",
  "policy.form.properties.name.required": "Please input the name!",
  "policy.form.properties.description": "Description",
  "policy.form.properties.description.required":
    "Please input the description!",
  "policy.form.properties.action": "Action",
  "policy.form.properties.action.required": "Please select one action!",
  "policy.form.properties.tags": "Tags",
  "policy.form.properties.policy.group": "Policy Group",
  "policy.form.properties.policy.group.required": "Please select one group!",
  "policy.form.properties.traffic.monitor": "Traffic Monitor",
  "policy.form.properties.traffic.logging": "Traffic Logging",
  "policy.form.properties.schedule": "Schedule",
  "policy.form.properties.time": "Time",
  "policy.form.properties.time.required": "Please select one time schedule!",
  "policy.form.properties.period.date": "Schedule",
  "policy.form.properties.period.date.required":
    "Please select one date schedule!",
  "policy.form.properties.traffic.monitor.modal":
    "By disabling this function, you will no longer be able to monitor this policy's data in Dashboard and Live Sessions",
  "policy.form.properties.traffic.monitor.modal.title": "Heads up!",
  "policy.form.properties.traffic.monitor.modal.button.ok": "Ok",
  "policy.form.properties.traffic.monitor.modal.button.cancel": "Cancel",

  "policy.form.connection": "Connection",
  "policy.form.connection.item": "Item",
  "policy.form.connection.source": "Source",
  "policy.form.connection.source.required": "Please select one source!",
  "policy.form.connection.source.network.zone": "Network Zone",
  "policy.form.connection.source.network.zone.required":
    "Please select one source network zone!",
  "policy.form.connection.source.network.interface": "Network Interface",
  "policy.form.connection.source.network.interface.required":
    "Please select one source network interface!",
  "policy.form.connection.source.ip.address": "IP Address",
  "policy.form.connection.source.ip.address.required":
    "Please select some source ip address!",
  "policy.form.connection.source.mac.address": "MAC Address",
  "policy.form.connection.source.mac.address.required":
    "Please select some source mac address!",
  "policy.form.connection.destination": "Destination",
  "policy.form.connection.destination.ip.address": "IP Address",
  "policy.form.connection.destination.ip.address.required":
    "Please select some destination ip address!",
  "policy.form.connection.destination.service": "Service",
  "policy.form.connection.destination.service.required":
    "Please select some destination service!",
  "policy.form.connection.identification": "Identification",
  "policy.form.connection.authenticated": "Authenticated",
  "policy.form.connection.users": "Users",
  "policy.form.connection.users.required": "Please select some user!",
  "policy.form.connection.groups": "Groups",
  "policy.form.connection.groups.required": "Please select some group!",

  "policy.form.content.web.proxy": "Web Proxy",
  "policy.form.content.ftp": "FTP",
  "policy.form.content.https": "HTTPS",
  "policy.form.content.validate.ssl.certificate": "Validate SSL Certificate",
  "policy.form.content.http": "HTTP",
  "policy.form.content.ssl.inspection": "SSL Inspection",
  "policy.form.content.explicit.proxy": "Explicit Proxy",
  "policy.form.content.ssl.common.name": "SSL Common Name",
  "policy.form.content.ssl.common.name.required":
    "Please select some ssl common name!",
  "policy.form.content.malware.scanning": "Malware Scanning",
  "policy.form.content.malware.scanning.required":
    "Please select some malware scanning!",
  "policy.form.content.web.filter": "Web Filter",
  "policy.form.content.web.categories": "Web Categories",
  "policy.form.content.web.categories.required": "Please select some category!",
  "policy.form.content.applications": "Applications",
  "policy.form.content.applications.required":
    "Please select some application!",
  "policy.form.content.url.filter": "URL Filter",
  "policy.form.content.url.filter.required": "Please select some url!",
  "policy.form.content.browsers": "Browsers",
  "policy.form.content.browsers.required": "Please select some browser!",
  "policy.form.content.http.method": "HTTP Method",
  "policy.form.content.http.method.required": "Please select some http method!",
  "policy.form.content.smtp": "SMTP",
  "policy.form.content.pop3": "POP3",

  "policy.form.content.inspection.ssl": "Select a profile for SSL Inspection.",
  "policy.form.content.inspection.intrusion.prevention": "Select a profile for Intrusion Prevention.",
  "policy.form.content.inspection.threat.protection": "Select a profile for Threat Protection.",
  "policy.form.content.inspection.application.control": "Select a profile for Application Control.",
  "policy.form.content.inspection.web.filter": "Select a profile for Web Filter.",

  "policy.form.inspection": "Inspection",
  "policy.form.control.surfing.control": "Surfing Control",
  "policy.form.control.content.type.filter": "Content-Type Filter",
  "policy.form.control.content.type.filter.required":
    "Please select some content-type!",
  "policy.form.control.http.filter.header": "HTTP Filter Header",
  "policy.form.control.http.filter.header.required": "Invalid Value!",
  "policy.form.control.maximum.time": "Maximum Time",
  "policy.form.control.maximum.time.required": "Invalid Value!",
  "policy.form.control.maximum.time.select.one": "Select one!",
  "policy.form.control.maximum.time.opt.min": "Minutes per day",
  "policy.form.control.maximum.time.opt.hour": "Hours per day",
  "policy.form.control.maximum.traffic": "Maximum Traffic",
  "policy.form.control.maximum.traffic.required": "Invalid Value!",
  "policy.form.control.maximum.traffic.select.one": "Select one!",
  "policy.form.control.maximum.traffic.opt.day": "MB per day",
  "policy.form.control.maximum.download.size": "Maximum Download Size",
  "policy.form.control.maximum.download.size.required": "Invalid Value!",
  "policy.form.control.maximum.download.size.select.one": "Select one!",
  "policy.form.control.maximum.upload.size": "Maximum Upload Size",
  "policy.form.control.maximum.upload.size.required": "Invalid Value!",
  "policy.form.control.maximum.upload.size.select.one": "Select one!",

  "policy.form.security.deep.inspection": "Deep Inspection",
  "policy.form.security.sensor": "Sensor",
  "policy.form.security.device.template": "Device Template",
  "policy.form.security.device.template.select.one": "Select one!",
  "policy.form.security.profile.dpi": "Profile DPI",
  "policy.form.security.profile.dpi.select.one": "Select one!",
  "policy.form.security.threat.blocking": "Threat Blocking",
  "policy.form.security.compromised.addresses": "Compromised Addresses",
  "policy.form.security.compromised.addresses.required":
    "Please select some compromised address!",
  "policy.form.security.geolocation": "Geolocation",
  "policy.form.security.geolocation.select.one": "Select one!",
  "policy.form.security.packet.filter": "Packet Filter",
  "policy.form.security.ttl": "TTL",
  "policy.form.security.ttl.select.one": "Select one!",
  "policy.form.security.ttl.required": "Invalid value!",
  "policy.form.security.package.type": "Package Type",
  "policy.form.security.package.type.select.one": "Select one!",
  "policy.form.security.packet.content": "Packet Content",
  "policy.form.security.packet.content.select.one": "Select one!",
  "policy.form.security.tcp.mss": "TCP MSS",
  "policy.form.security.tcp.mss.required": "Invalid value!",

  "policy.form.routing": "Routing",
  "policy.form.routing.gateway": "Gateway",
  "policy.form.routing.nat": "NAT",
  "policy.form.routing.cgnat": "CGNAT",
  "policy.form.routing.cgnat.empty": "This is required",
  "policy.form.routing.cgnat.enable": "Enable CGNAT",
  "policy.form.routing.snat.default": "Default Gateway (Masked)",
  "policy.form.routing.sdwan": "SD-WAN",
  "policy.form.routing.device.template": "Device Template",
  "policy.form.routing.device.template.select.one": "Select one!",
  "policy.form.routing.profile.sdwan": "Profile SD-WAN",
  "policy.form.routing.profiles.sdwan": "SD-WAN Profile(s)",
  "policy.form.routing.profile.sdwan.select.one": "Select one!",
  "policy.form.routing.qos": "QoS",
  "policy.form.routing.options": "QoS e Traffic Shaping",
  "policy.form.routing.traffic.shaping": "Traffic Shaping",
  "policy.form.routing.traffic.shaping.select.one": "Select one!",
  "policy.form.routing.flag.packets.tos": "Flag Packets (TOS)",
  "policy.form.routing.flag.packets.tos.select.one": "Select one!",
  "policy.form.routing.flag.packets.dscp": "Flag Packets (DSCP)",
  "policy.form.routing.flag.packets.dscp.select.one": "Select one!",
  "policy.form.routing.approuting": "Application Routing",
  "policy.form.routing.webapp": "Applications",

  "policy.form.advanced": "Advanced",
  "policy.form.advanced.dosProtection": "DoS Protection",
  "policy.form.advanced.packetRate": "Packet Rate (packets/seconds)",
  "policy.form.advanced.burstRate": "Burst Rate",
  "policy.form.advanced.options": "Options",
  "policy.form.advanced.tcpmss": "tcp mss",
  "policy.form.advanced.save": "save",

  "objects.mapping.modal.title": "Object Mapping",
  "objects.mapping.modal.usedin": "Used",
  "objects.mapping.modal.name": "Name",
  "objects.mapping.modal.interface": "Interface",
  "objects.title": "Objects",
  "objects.tabs.address": "Addresses",
  "objects.tabs.service": "Services",
  "objects.tabs.time": "Time",
  "objects.tabs.schedule": "Schedules",
  "objects.tabs.dicionarie": "Dictionaries",
  "objects.tabs.content": "Content",

  "objects.actions.create": "Create Object",
  "objects.actions.group.create": "Create Group",
  "objects.actions.delete": "Delete Object",
  "objects.modal.title": " {object} Object",
  "objects.modal.group.title": " {object} Group Object",
  "objects.modal.group.title.address": "Address Group Object",

  "objects.addressGroup.modal.object": "Objects",
  "objects.addressGroup.modal.title": "Create Group Address Object",
  "objects.addressGroup.modal.select.type": "Select a type",
  "objects.actions.create.success": "Object successfully created!",
  "objects.actions.create.error": "Object have not been saved!",
  "objects.actions.create.error.dns": "Host address not resolved!",
  "objects.actions.delete.success": "Object deleted successfully!",
  "objects.actions.delete.error": "Object deleting error!",
  "objects.actions.delete.error.total":
    "{number} item(s) have not been deleted. Object in use.",

  "objects.address.datagrid.name": "Name",
  "objects.address.datagrid.description": "Description",
  "objects.address.datagrid.type": "Type",
  "objects.address.datagrid.used": "Used",
  "objects.address.datagrid.actions": "Actions",
  "objects.address.actions.create": "Create Object",
  "objects.address.actions.delete": "Delete Object",
  "objects.address.actions.delete.success": "Object deleted successfully!",
  "objects.address.modal.title": "Address Object",
  "objects.address.modal.form.name": "Name",
  "objects.address.modal.form.item": "Address",
  "objects.address.modal.form.list": "List",
  "objects.address.modal.form.type": "Type",
  "objects.address.modal.form.description": "Description",
  "objects.address.modal.form.ip": "IPv4 Address",
  "objects.address.modal.form.ipv6": "IPv6 Address",
  "objects.address.modal.form.mac": "MAC Address",
  "objects.address.modal.form.fqdn": "FQDN Address",
  "objects.address.modal.form.unique.ip": "Unique",
  "objects.address.modal.form.mask": "Mask",
  "objects.address.modal.form.prefix": "Prefix",
  "objects.address.modal.form.invalid": "Invalid fields",
  "objects.address.modal.form.error.name": "Name field is required",
  "objects.address.modal.form.error.type": "Type Address field is required",
  "objects.address.modal.form.error.list": "List Address field is required",
  "objects.address.modal.form.error.description":
    "Description field is required",
  "objects.address.modal.form.name.exists":
    "An address with this name already exists",
  "objects.address.modal.form.error.unique":
    "IP only object cannot contain more than one IP/network",
  "objects.address.modal.save.success": "Settings successfully changed!",
  "objects.address.modal.import.success":
    "{number} item(s) imported successfully",
  "objects.address.modal.import.error":
    "{number} item(s) have not been imported successfully",
  "objects.address.modal.import.warning":
    "The import file must contain one item per line",
  "objects.address.modal.error.file.bigger": "File must smaller than 2Mb",
  "objects.address.modal.error.file.txt": "You can only upload TXT file",
  "objects.address.modal.save.error": "Settings have not been saved!",
  "objects.address.delete.title": "Confirm delete",
  "objects.address.delete.confirm":
    "Are you sure you want to delete the object address",
  "objects.address.delete.confirmMult":
    "Are you sure you want to delete the following objects address?",

  "objects.services.datagrid.name": "Name",
  "objects.services.datagrid.description": "Description",
  "objects.services.datagrid.type": "Type",
  "objects.services.datagrid.used": "Used",
  "objects.services.datagrid.actions": "Actions",
  "objects.services.actions.create": "Create Object",
  "objects.services.actions.delete": "Delete Object",
  "objects.services.modal.title": "Create Service Object",
  "objects.services.modal.form.name": "Name",
  "objects.services.modal.form.type": "Protocol Type",
  "objects.services.modal.form.item": "Types",
  "objects.services.modal.form.list": "List",
  "objects.services.modal.form.description": "Description",
  "objects.services.modal.form.tcp": "TCP",
  "objects.services.modal.form.udp": "UDP",
  "objects.services.modal.form.ip": "IP",
  "objects.services.modal.form.icmp": "ICMP V4",
  "objects.services.modal.form.icmpv6": "ICMP V6",
  "objects.services.modal.form.portType": "Port Type",
  "objects.services.modal.form.port": "Port",
  "objects.services.modal.form.protocol": "Protocol",
  "objects.services.modal.form.types": "Types",
  "objects.services.modal.form.source.port": "Source port",
  "objects.services.modal.form.destination.port": "Destination port",
  "objects.services.modal.form.initial.port": "Initial port",
  "objects.services.modal.form.end.port": "End port",
  "objects.services.modal.form.save.success": "Object saved successfully",
  "objects.services.modal.form.save.error": "Object have not been saved",
  "objects.services.modal.form.invalid": "Invalid fields",
  "objects.services.modal.form.name.exists":
    "An object with this name already exists",

  "objects.services.modal.form.error.name": "Name field is required",
  "objects.services.modal.form.error.type": "Type Protocol field is required",
  "objects.services.modal.form.error.list": "List Protocol field is required",
  "objects.services.modal.form.error.description":
    "Description field is required",
  "objects.services.delete.title": "Confirm delete",
  "objects.services.delete.confirm":
    "Are you sure you want to delete the object service",
  "objects.services.delete.confirmMult":
    "Are you sure you want to delete the following objects services?",

  "objects.times.datagrid.name": "Name",
  "objects.times.datagrid.description": "Description",
  "objects.times.datagrid.type": "Type",
  "objects.times.datagrid.used": "Used",
  "objects.times.datagrid.actions": "Actions",
  "objects.times.actions.create": "Create Object",
  "objects.times.actions.delete": "Delete Object",
  "objects.times.modal.title": "Create Time Object",
  "objects.times.modal.form.name": "Name",
  "objects.times.modal.form.type": "Weekday",
  "objects.times.modal.form.item": "Start / End time",
  "objects.times.modal.form.start.time": "Start time",
  "objects.times.modal.form.start.datetime": "Start date time",
  "objects.times.modal.form.end.time": "End time",
  "objects.times.modal.form.end.datetime": "End date time",
  "objects.times.modal.form.list": "List",
  "objects.times.modal.form.description": "Description",
  "objects.times.modal.form.tcp": "TCP",
  "objects.times.modal.form.udp": "UDP",
  "objects.times.modal.form.ip": "IP",
  "objects.times.modal.form.icmp": "ICMP V4",
  "objects.times.modal.form.icmpv6": "ICMP V6",
  "objects.times.modal.form.sunday": "Sunday",
  "objects.times.modal.form.monday": "Monday",
  "objects.times.modal.form.tuesday": "Tuesday",
  "objects.times.modal.form.wednesday": "Wednesday",
  "objects.times.modal.form.thursday": "Thursday",
  "objects.times.modal.form.friday": "Friday",
  "objects.times.modal.form.saturday": "Saturday",
  "objects.times.modal.form.invalid": "Invalid fields",
  "objects.times.modal.form.name.exists":
    "An object with this name already exists",
  "objects.times.modal.form.error.name": "Name field is required",
  "objects.times.modal.form.error.type": "Type Protocol field is required",
  "objects.times.modal.form.error.list": "List Protocol field is required",
  "objects.times.modal.form.error.description": "Description field is required",
  "objects.times.modal.form.error.equal.period":
    "Final period must be greater than the initial period",
  "objects.times.delete.title": "Confirm delete",
  "objects.times.delete.confirm":
    "Are you sure you want to delete the object time",
  "objects.times.delete.confirmMult":
    "Are you sure you want to delete the following objects time?",

  "objects.schedules.datagrid.name": "Name",
  "objects.schedules.datagrid.description": "Description",
  "objects.schedules.datagrid.type": "Type",
  "objects.schedules.datagrid.used": "Used",
  "objects.schedules.datagrid.actions": "Actions",
  "objects.schedules.actions.create": "Create Object",
  "objects.schedules.actions.delete": "Delete Object",
  "objects.schedules.modal.title": "Create Schedules Object",
  "objects.schedules.modal.form.name": "Name",
  "objects.schedules.modal.form.item": "Start / End date",
  "objects.schedules.modal.form.list": "List",
  "objects.schedules.modal.form.description": "Description",
  "objects.schedules.modal.form.error.name": "Name field is required",
  "objects.schedules.modal.form.error.list": "List Protocol field is required",
  "objects.schedules.modal.form.error.description":
    "Description field is required",
  "objects.schedules.delete.title": "Confirm delete",
  "objects.schedules.delete.confirm":
    "Are you sure you want to delete the object schedule",
  "objects.schedules.delete.confirmMult":
    "Are you sure you want to delete the following objects schedules?",

  "objects.dictionaries.datagrid.name": "Name",
  "objects.dictionaries.datagrid.description": "Description",
  "objects.dictionaries.datagrid.type": "Type",
  "objects.dictionaries.datagrid.used": "Used",
  "objects.dictionaries.datagrid.actions": "Actions",
  "objects.dictionaries.actions.create": "Create Object",
  "objects.dictionaries.actions.delete": "Delete Object",
  "objects.dictionaries.modal.title": "Create dictionary Object",
  "objects.dictionaries.modal.form.name": "Name",
  "objects.dictionaries.modal.form.type": "Protocol Type",
  "objects.dictionaries.modal.form.list": "List",
  "objects.dictionaries.modal.form.expressions": "Expressions",
  "objects.dictionaries.modal.form.word": "Word",
  "objects.dictionaries.modal.form.description": "Description",
  "objects.dictionaries.modal.form.tcp": "TCP",
  "objects.dictionaries.modal.form.udp": "UDP",
  "objects.dictionaries.modal.form.ip": "IP",
  "objects.dictionaries.modal.form.icmp": "ICMP V4",
  "objects.dictionaries.modal.form.icmpv6": "ICMP V6",
  "objects.dictionaries.modal.form.invalid": "Invalid fields",
  "objects.dictionaries.modal.form.error.name": "Name field is required",
  "objects.dictionaries.modal.form.error.type":
    "Type Protocol field is required",
  "objects.dictionaries.modal.form.error.list":
    "List Protocol field is required",
  "objects.dictionaries.modal.form.error.description":
    "Description field is required",
  "objects.dictionaries.modal.form.name.exists":
    "A dictionary with this name already exists",
  "objects.dictionaries.delete.title": "Confirm delete",
  "objects.dictionaries.delete.confirm":
    "Are you sure you want to delete the object dictionaries",
  "objects.dictionaries.delete.confirmMult":
    "Are you sure you want to delete the following objects dictionaries?",
  "objects.dictionaries.modal.import.success":
    "{number} item(s) imported successfully",
  "objects.dictionaries.modal.import.warning":
    "The import file must contain one item per line",
  "objects.dictionaries.modal.import.error":
    "{number} item(s) have not been imported successfully",
  "objects.dictionaries.modal.error.file.bigger": "File must smaller than 2Mb",
  "objects.dictionaries.modal.error.file.txt": "You can only upload TXT file",

  "objects.contents.datagrid.name": "Name",
  "objects.contents.datagrid.description": "Description",
  "objects.contents.datagrid.type": "Type",
  "objects.contents.datagrid.used": "Used",
  "objects.contents.datagrid.actions": "Actions",
  "objects.contents.actions.create": "Create Object",
  "objects.contents.actions.delete": "Delete Object",
  "objects.contents.modal.title": "Create Schedules Object",
  "objects.contents.modal.form.name": "Name",
  "objects.contents.modal.form.type": "Protocol Type",
  "objects.contents.modal.form.list": "List",
  "objects.contents.modal.form.listMime": "List Mime-Types",
  "objects.contents.modal.form.listExt": "List Extensions",
  "objects.contents.modal.form.description": "Description",
  "objects.contents.modal.form.tcp": "TCP",
  "objects.contents.modal.form.udp": "UDP",
  "objects.contents.modal.form.ip": "IP",
  "objects.contents.modal.form.icmp": "ICMP V4",
  "objects.contents.modal.form.icmpv6": "ICMP V6",
  "objects.contents.modal.form.error.name": "Name field is required",
  "objects.contents.modal.form.error.type": "Type Protocol field is required",
  "objects.contents.modal.form.error.list": "List Protocol field is required",
  "objects.contents.modal.form.error.description":
    "Description field is required",
  "objects.contents.modal.form.name.exists":
    "An object with this name already exists",
  "objects.contents.modal.form.invalid": "Invalid fields",
  "objects.contents.delete.title": "Confirm delete",
  "objects.contents.delete.confirm":
    "Are you sure you want to delete the object contents",
  "objects.contents.delete.confirmMult":
    "Are you sure you want to delete the following objects contents?",

  "deploys.title": "Deploys",
  "deploys.task.information": "Task Information",
  "deploys.task.view": "Task View",
  "deploys.filter.status.success": "Success",
  "deploys.filter.status.accept": "Accept",
  "deploys.filter.status.running": "Running",
  "deploys.filter.status.pending": "Pending",
  "deploys.filter.status.error": "Error",
  "deploys.filter.status.cancelled": "Cancelled",
  "deploys.filter.taskType.policyPack": "Policy Pack",
  "deploys.filter.taskType.deviceTemp": "Device Template",
  "deploys.filter.taskType.deviceComm": "Device Community",
  "deploys.datagrid.package": "Package",
  "deploys.datagrid.assignee": "Auditor",
  "deploys.datagrid.owner": "Owner",
  "deploys.datagrid.scheduled": "Scheduled",
  "deploys.datagrid.device": "Device",
  "deploys.datagrid.progress": "Progress",
  "deploys.datagrid.status": "Status",
  "deploys.datagrid.message": "Message",
  "deploys.datagrid.profile.limit": "Profile's limit reached",
  "deploys.datagrid.worker.limit": "Workers' limit reached",
  "deploys.datagrid.invalid.user": "Invalid User(s)",
  "deploys.datagrid.invalid.group": "Invalid Group(s)",
  "deploys.datagrid.invalid.interface": "Invalid Interface(s)",
  "deploys.datagrid.invalid.zone": "Invalid Zone(s)",
  "deploys.datagrid.invalid.package.empty": "Invalid policy package: empty",
  "deploys.filter.scheduled": "Scheduled",
  "deploys.filter.owner": "Owner",
  "deploys.filter.auditor": "Auditor",
  "deploys.filter.status": "Status",
  "deploys.filter.package": "Package",
  "deploys.delete.success": "Deploy deleted successfully",
  "deploys.create.success": "Deploy created successfully!",
  "deploys.create.error": "Deploy cannot be created!",
  "deploys.modal.monitor.title": "Device Monitor",
  "deploys.modal.activity.title": "Task Activity",
  "deploys.modal.justify.title": "Justify Action",
  "deploys.modal.justify.comment": "Comment",
  "deploys.modal.error.comment": "Active backup process.",

  // =========== ATP =========== //

  "profiles.atp.tab.application": "Applications",
  "profiles.atp.tab.malware.scanning": "Malware Scanning",
  "profiles.atp.tab.threat.blocking": "Threat Blocking",

  "profiles.atp.tab.quarantine.query.editor": "Query Editor",
  "profiles.atp.tab.quarantine.query.save": "Save Query",
  "profiles.atp.tab.quarantine.action.remove": "Remove Items",
  "profiles.atp.tab.quarantine.tabpane.create": "Create Query",
  "profiles.atp.tab.quarantine.tabpane.load": "Load Query",
  "profiles.atp.tab.quarantine.tabpane.create.new": "New Query",
  "profiles.atp.tab.quarantine.tabpane.create.edit": "Edit Query",
  "profiles.atp.tab.quarantine.tabpane.create.filter": "Filter",
  "profiles.atp.tab.quarantine.tabpane.create.value": "Value",
  "profiles.atp.tab.quarantine.tabpane.create.filterString": "Filter String",
  "profiles.atp.tab.quarantine.tabpane.create.filterString.result":
    "Filter string results",
  "profiles.atp.tab.quarantine.tabpane.create.name.exists":
    "A query with this name already exists.",
  "profiles.atp.tab.quarantine.action.remove.text":
    "Are you sure you want to delete",
  "profiles.atp.tab.quarantine.action.remove.success": "Delete success.",
  "profiles.atp.tab.quarantine.action.remove.error": "Delete error.",

  "profiles.atp.tab.quarantine.action.download.success": "Download success.",
  "profiles.atp.tab.quarantine.action.download.error": "Download error.",
  "profiles.atp.tab.quarantine.action.download.allow": "Download allowed.",
  "profiles.atp.tab.quarantine.action.download.denied": "Download denied.",
  "profiles.atp.tab.quarantine.action.download.allow.tooltip":
    "Allow download.",
  "profiles.atp.tab.quarantine.action.download.denied.tooltip":
    "Deny download.",
  "profiles.atp.tab.quarantine.action.download.error.sizelimit": "Unable to download, limit exceeded.",
  "profiles.atp.tab.quarantine.action.download.error.dontanalyze": "Unable to download, file not parsed.",

  "profiles.atp.tab.quarantine.queries.action.remove.success":
    "Query deleting success!",
  "profiles.atp.tab.quarantine.queries.action.remove.error":
    "Query deleting error!",
  "profiles.atp.tab.quarantine.queries.filter.user": "User",
  "profiles.atp.tab.quarantine.queries.filter.src": "Source",
  "profiles.atp.tab.quarantine.queries.filter.spt": "Source port",
  "profiles.atp.tab.quarantine.queries.filter.dst": "Destination",
  "profiles.atp.tab.quarantine.queries.filter.dpt": "Destination port",
  "profiles.atp.tab.quarantine.queries.filter.file": "File",
  "profiles.atp.tab.quarantine.queries.filter.url": "Url",
  "profiles.atp.tab.quarantine.queries.filter.mime": "Mime-type",

  "profiles.atp.tab.quarantine.queries.filter.status": "Status",
  "profiles.atp.tab.quarantine.queries.filter.date": "Scheduled",
  "profiles.atp.tab.quarantine.queries.filter.analyze": "Scanning",
  "profiles.atp.tab.quarantine.queries.filter.dontanalyze": "Not analyzed",
  "profiles.atp.tab.quarantine.queries.filter.infected": "Infected",
  "profiles.atp.tab.quarantine.queries.filter.clean": "Clean",
  "profiles.atp.tab.quarantine.queries.filter.download": "Download",
  "profiles.atp.tab.quarantine.queries.filter.sizelimit": "Size limit",
  "profiles.atp.tab.quarantine.queries.filter.notfound": "Not found",
  "profiles.atp.tab.quarantine.tabpane.create.name": "Custom new query name",
  "profiles.atp.tab.quarantine.tabpane.create.select.field": "Select a Field",

  "atp.custom.error.in.using": "Could not delete signature. Custom signature is in use!",

  "atp.custom.signature.input.regex": "Enter your Regex",

  // =========== Dashboard ======== //

  "monitor.system-status": "System Status",
  "monitor.system-status.information": "System Information",
  "monitor.system-status.resources": "System Resources",
  "monitor.system-status.services": "System Services",
  "monitor.system-status.license": "License Information",
  "monitor.system-status.subscriptions": "Subscriptions",
  "monitor.system-status.subscriptions.last.modify": "Last Modify",
  "monitor.system-status.last.update": "Last Update",
  "monitor.system-status.last.backup": "Last Backup",
  "monitor.system-status.high.availability": "High Availability",

  "monitor.system-status.service.running": "Service is running.",
  "monitor.system-status.service.stopped": "Service is stopped.",
  "monitor.system-status.service.disabled": "Service is disabled.",
  "monitor.system-status.service.action.start": "Starting service.",
  "monitor.system-status.service.action.stopped": "Stopping service.",

  "monitor.dashboard.lastMinute": "Last 5 minutes",
  "monitor.dashboard.lastHour": "Last hour",
  "monitor.dashboard.networkTraffic": "Network Traffic",
  "monitor.dashboard.liveUsers": "Live Users",
  "monitor.dashboard.webActivity": "Web Activity",
  "monitor.dashboard.networkAttacks": "Network Attacks",
  "monitor.dashboard.malwareDetections": "Malware Detections",
  "monitor.dashboard.threatBlocking": "Threat Blocking",
  "monitor.dashboard.conectionsMap": "Connections Map",
  "monitor.dashboard.trafficMonitor": "Traffic Monitor",
  "monitor.dashboard.topUsers": "Top Users",
  "monitor.dashboard.topSources": "Top Sources",
  "monitor.dashboard.topServices": "Top Services",
  "monitor.dashboard.topPolicies": "Top Policies",
  "monitor.dashboard.topCategories": "Top Categories",
  "monitor.dashboard.topApplications": "Top Applications",
  "monitor.dashboard.topAttacks": "Top Attacks",
  "monitor.dashboard.topThreats": "Top Threats",

  "monitor.trafficMonitor.interfaces.error":
    "Select at least 1 interface and up to 4",
  "monitor.trafficMonitor.in": "IN",
  "monitor.trafficMonitor.out": "OUT",
  "monitor.trafficMonitor.sdwan.error": "Select a profile",
  "monitor.trafficMonitor.throughput": "Throughput",
  "monitor.trafficMonitor.bandwidth": "Bandwidth",

  "monitor.diagnostics.packetCapture": "Packet Capture",
  "monitor.diagnostics.categoryLookup": "Category Lookup",
  "monitor.diagnostics.categoryLookup.notFound": "Address not classified.",
  "monitor.diagnostics.packetCapture.error":
    "Enter an address, port, or protocol.",
  "monitor.diagnostics.packetCapture.confirm.title":
    "Do you want to remove the file?",
  "monitor.diagnostics.packetCapture.cancel.title":
    "Do you want to cancel the capture?",
  "monitor.diagnostics.packetCapture.ok": "Proceed",
  "monitor.diagnostics.packetCapture.protocol": "Protocol",
  "monitor.diagnostics.packetCapture.size": "Size",
  "monitor.diagnostics.packetCapture.tooltip": "Set up capture",
  "monitor.diagnostics.packetCapture.DraggableModal.title": "Capture Settings",
  "monitor.diagnostics.packetCapture.form.minute": "minute",
  "monitor.diagnostics.packetCapture.form.outhers": "Others",
  "monitor.diagnostics.packetCapture.maxSize": "Maximum file size",
  "monitor.diagnostics.packetCapture.bpf": "Berkeley Packet Filter (BPF)",

  "monitor.liveSession.confirm": "Do you want to remove the user's session?",
  "monitor.liveSession.vpn.network": "IP/Network",
  "monitor.liveSession.vpn.tunnel": "Site-to-Site",
  "monitor.liveSession.vpn.ras": "Remote access",
  "monitor.liveSession.vpn.confirm": "Do you want to interrupt the connection?",
  "monitor.liveSession.vpn.success": "Connection interrupted successfully",
  "monitor.liveSession.vpn.error": "Error interrupting connection",
  "monitor.liveSession.vpn.error.disabled.server": "Error saving. Please check if VPN NG is active and try again.",
  "monitor.liveSession.vpn.connectionDate": "Connection date",
  "monitor.liveSession.network.confirm":
    "Do you want to delete this connection?",
  "monitor.liveSession.network.success": "Connection deleted successfully",
  "monitor.liveSession.network.error": "Error deleting the connection",
  "monitor.liveSession.network.connections.info":
    "Total connections established",
  "monitor.liveSession.network.logsessions.disable":
    "Session logging has been disabled",
  "monitor.liveSession.waiting": "Wait while the connection established",

  // =========== IPS =========== //

  "profiles.tab.ips.smart": "Smart IPS (Automatically enable subscriptions)",
  "profiles.tab.ips.smart.enable": "Smart IPS",
  "profiles.intrusionprevention.settings.riskLow": "Low risk",
  "profiles.intrusionprevention.settings.riskMedium": "Medium risk",
  "profiles.intrusionprevention.settings.riskHigh": "High risk",
  "profiles.intrusionprevention.settings.info.devices": "The listed interfaces are those that are enabled and without IP and Mask configuration.",

  "profiles.tab.ips.whitelist": "Allowed Addresses",
  "profiles.tab.ips.blacklist": "Blocked Addresses",
  "profiles.tab.ips.quarantine": "Quarantine",
  "profiles.tab.ips.whitelist.create": "Create",
  "profiles.tab.ips.whitelist.delete": "Delete",
  "profiles.tab.ips.whitelist.address": "Address",

  "profiles.tab.ips.whitelist.customization": "Custom Signatures",
  "profiles.tab.ips.action.add.customization":
    "Custom Signatures successfully inserted",
  "profiles.tab.ips.error.duplicated-sid":
    "Custom Signatures error, duplicated SID",
  "profiles.tab.ips.action.remove.sucess.customization":
    "Custom Signatures successfully remove",

  "profiles.tab.ips.blacklist.create": "Create",
  "profiles.tab.ips.blacklist.delete": "Delete",
  "profiles.tab.ips.blacklist.address": "Address",
  "profiles.tab.ips.action.add.sucess": "Address added successfully",
  "profiles.tab.ips.error.loading": "Error loading page",
  "profiles.tab.ips.action.remove.sucess": "Address removed successfully",
  "profiles.tab.ips.action.remove.text": "Are you sure you want to delete",
  "profiles.tab.ips.quarantine.action.whitelist":
    "Mover para Allowed Addresses",
  "profiles.tab.ips.quarantine.action.blacklist":
    "Mover para Blocked Addresses",
  "profiles.tab.ips.quarantine.action.move.success":
    "Address moved successfully.",
  "profiles.tab.ips.quarantine.action.move.error": "Error moving address.",
  "profiles.tab.ips.quarantine.action.remove": "Remover",
  "profiles.tab.ips.quarantine.action.move.title.whitelist":
    "Allowed Addresses",
  "profiles.tab.ips.quarantine.action.move.title.blacklist":
    "Blocked Addresses",
  "profiles.tab.ips.quarantine.action.timeout": "Timeout",
  "profiles.tab.ips.quarantine.action.move.text.whitelist":
    "Want realy move to Allowed Addresses these IPs",
  "profiles.tab.ips.quarantine.action.move.text.blacklist":
    "Want realy move to Blocked Addresses these IPs",
  "profiles.tab.ips.modal.form.error.time": "Time field is required",
  "profiles.tab.ips.modal.form.timeout.hour": "Hour",
  "profiles.tab.ips.modal.form.timeout.min": "Minutes",
  "profiles.tab.ips.modal.error.file.bigger": "File must smaller than 2Mb",
  "profiles.tab.ips.modal.error.file.txt": "You can only upload TXT file",
  "profiles.tab.ips.modal.import.success":
    "{number} item(s) imported successfully",
  "profiles.tab.ips.modal.form.ip": "IPv4 Address",
  "profiles.tab.ips.modal.form.ipv6": "IPv6 Address",
  "profiles.tab.ips.modal.form.item": "Address",
  "profiles.tab.ips.modal.form.mask": "Mask",
  "profiles.tab.ips.modal.form.prefix": "Prefix",

  "profiles.tab.ips.modal.form.column-rule": "Rule",
  "profiles.tab.ips.modal.form.column-reason": "Reason",
  "profiles.tab.proxy.settings.invalid": "",

  "quarantine.actions.delete.success": "IP in quarantine deleted successfully!",
  "quarantine.actions.delete.error.total":
    "{number} item(s) have not been deleted. IP in use.",
  "quarantine.delete.title": "Confirm delete",
  "quarantine.delete.confirm":
    "Are you sure you want to deleted  from quarantine the IP address",
  "quarantine.delete.confirmMult":
    "Are you sure you want to deleted the following IP address from quarantine?",

  // =========== Webfilter =========== //

  "profiles.tab.webfilter.settings": "Settings",

  "profiles.webFilter.modal.form.error.name": "Name field is required",
  "profiles.webFilter.modal.form.error.name.exists":
    "A profile with this name already exists.",
  "profiles.webFilter.modal.form.error.type": "Type Address field is required",
  "profiles.webFilter.modal.form.error.list": "List Address field is required",
  "profiles.webFilter.modal.form.error.description":
    "Description field is required",
  "profiles.webFilter.surfingQuotas": "Surfing Quotas",
  "profiles.webFilter.error.filter": "Please select some file filter",
  "profiles.webFilter.error.category": "Please select some category",

  "profiles.title": "Profiles",
  "profiles.title.webfilter": "Web Filter",
  "profiles.title.ips": "Intrusion Prevention",
  "profiles.title.atp": "Threat Protection",
  "profiles.title.sdwan": "SD-WAN",
  "profiles.title.ssl": "Proxy",
  "profiles.title.appControl": "Application Control",

  "profiles.tab": "Profiles",
  "profiles.tab.webfilter": "Web Filter",
  "profiles.tab.ips": "Intrusion Prevention",
  "profiles.tab.sdwan": "SD-WAN",
  "profiles.tab.ssl": "SSL Inspection",
  "profiles.tab.appControl": "Application Control",

  "profiles.tab.atp.settings": "Settings",
  "profiles.tab.atp.quarantine": "Quarantine",
  "profiles.tab.atp.sandbox": "Sandbox",
  "profiles.tab.atp.quarantine.threat": "Threat Quarantine",
  "profiles.tab.ssl.inspection": "SSL Inspection",
  "profiles.tab.ssl.services": "Proxy Services",
  "profiles.tab.sdwan.settings": "Settings",
  "profiles.tab.appControl.settings": "Settings",

  "profiles.tab.ssl.inspection.limit.reached": "Profiles limit reached!",
  "profiles.tab.ssl.workers.limit.reached": "Workers limit reached!",

  "profiles.webFilter.addCategory": "Custom Categories",
  "profiles.webFilter.MaxUpSize": "Maximum Upload Size",
  "profiles.webFilter.MaxDownSize": "Maximum Download Size",
  "profiles.webFilter.MBPerDay": "MB per day",
  "profiles.webFilter.MaxTrafic": "Maximum Traffic",
  "profiles.webFilter.HoursPerDay": "Hours per day",
  "profiles.webFilter.MinPerDay": "Minutes per day",
  "profiles.webFilter.webCategories": "Web categories",
  "profiles.webFilter.modalTree.permitions.Allow": "Allow",
  "profiles.webFilter.modalTree.permitions.Deny": "Deny",
  "profiles.webFilter.modalTree.permitions.Warning": "Warning",
  "profiles.webFilter.FileFilter": "File Filter",
  "profiles.webFilter.BlockFilter": "Block Filter",
  "profiles.webFilter.MaxTime": "Maximum Time",
  "profiles.webFilter.datagrid.profile": "Profile",
  "profiles.webFilter.datagrid.actions": "Actions",
  "profiles.webFilter.actions.create": "Create Profile",
  "profiles.webFilter.actions.delete": "Delete Profile",
  "profiles.webFilter.actions.clone": "Clone Profile",
  "profiles.webfilter.action.remove.text": "Are you sure you want to delete",

  "profiles.webFilter.modal.category": "Category",
  "profiles.webFilter.modal.title": " Profile",
  "profiles.webFilter.modal.name": "Name",
  "profiles.webFilter.modal.devices": "Devices",
  "profiles.webFilter.modal.devicesGroups": "Device Groups",

  "profiles.webFilter.datagrid.name": "Name",
  "profiles.webFilter.datagrid.description": "Description",
  "profiles.webFilter.datagrid.safeSearch": "Safe search",
  "profiles.webFilter.datagrid.safeSearch-detail":
    "Enforce Safe Search for Google, Bing, Yahoo",
  "profiles.webFilter.datagrid.googleApps": "Google apps",
  "profiles.webFilter.datagrid.googleApps-detail":
    "Restrict login domains for Google Apps",

  "profiles.webFilter.datagrid.used": "Used",
  "profiles.webFilter.actions.delete.success": "Profile deleted successfully!",
  "profiles.webFilter.actions.add.success": "Profile added successfully",
  "profiles.webFilter.actions.updated.success": "Profile updated successfully",
  "profiles.webfilter.actions.add.error": "Profile have not been save!",

  "profiles.actions.clone.success": "Profile(s) cloned successfully",
  "profiles.actions.clone.error": "The profile(s) has not been cloned!",
  "profiles.actions.clone-partial.error":
    "The profiles have been partially cloned!",

  "profiles.webFilter.modal.form.name": "Name",
  "profiles.webFilter.modal.form.item": "Address",
  "profiles.webFilter.modal.form.list": "List",
  "profiles.webFilter.modal.form.type": "Type",
  "profiles.webFilter.modal.form.description": "Description",
  "profiles.webFilter.modal.form.version": "Version",
  "profiles.webFilter.modal.form.ip": "IPv4 Address",
  "profiles.webFilter.modal.form.ipv6": "IPv6 Address",
  "profiles.webFilter.modal.form.mac": "MAC Address",
  "profiles.webFilter.modal.form.fqdn": "FQDN Address",
  "profiles.webFilter.modal.save.success": "Settings successfully changed!",
  "profiles.webFilter.modal.save.error": "Settings have not been saved!",
  "profiles.webFilter.delete.title": "Confirm delete",
  "profiles.webFilter.delete.confirm":
    "Are you sure you want to delete the object address",
  "profiles.webFilter.delete.confirmMult":
    "Are you sure you want to delete the following objects address?",

  "profiles.intrusionprevention.resetMotal.confirm":
    "Do you really want to restore the profile to default?",
  "profiles.intrusionprevention.profile.create": "Create Profile",
  "profiles.intrusionprevention.profile.create.success": "Profile created.",
  "profiles.intrusionprevention.profile.create.error":
    "Error creating profile.",
  "profiles.intrusionprevention.profile.delete": "Delete Profile",
  "profiles.intrusionprevention.profile.deleted.single":
    "Profile removed successfully.",
  "profiles.intrusionprevention.profile.deleted":
    "Profiles successfully removed.",
  "profiles.intrusionprevention.profile.deleted.inUse":
    "Can't delete profile! Profile in use",
  "profiles.intrusionprevention.profile.delete.confirm.general":
    "Are you sure you want to delete:",
  "profiles.intrusionprevention.profile.delete.confirm":
    "Are you sure you want to delete the profiles:",
  "profiles.intrusionprevention.profile.delete.confirm.single":
    "Are you sure you want to delete the profile:",
  "profiles.intrusionprevention.profile.restore.error":
    "Error restoring profile.",
  "profiles.intrusionprevention.profile.restore.success": "Profile restored.",
  "profiles.intrusionprevention.error.profile.exists":
    "A profile with this name already exists.",
  "profiles.intrusionprevention.settings.device.same":
    "Devices cannot be the same.",
  "profiles.intrusionprevention.settings.definitions": "Definitions",
  "profiles.intrusionprevention.settings.clientRecommended":
    "Enable client recommended rules",
  "profiles.intrusionprevention.settings.serverRecommended":
    "Enable server recommended rules",
  "profiles.intrusionprevention.settings.inspect": "Inspect all ports",
  "profiles.intrusionprevention.alert": "You are activating more than 10 thousand records. It can cause slowdowns and reduce performance.",
  "profiles.intrusionprevention.risk.low": "Low",
  "profiles.intrusionprevention.risk.medium": "Medium",
  "profiles.intrusionprevention.risk.high": "High",
  "profiles.intrusionprevention.reason-invalid-rule-duplicated_rule":
    "Duplicated Rule",
  "profiles.intrusionprevention.reason-invalid-rule-invalid_rule":
    "Invalid Rule",
  "profiles.intrusionprevention.reason-invalid-rule-not_match": "Invalid Rule",
  "profiles.intrusionprevention.reason-invalid-rule-duplicate_rule": "High",
  "profiles.intrusionprevention.signatures": "Signatures",
  "profiles.intrusionprevention.threats": "Threats",
  "profiles.intrusionprevention.apps": "Applications",

  "profiles.tab.threatProtection": "Threat Protection",
  "profile.threatProtection.name": "Name",
  "profile.threatProtection.description": "Description",
  "profile.threatProtection.version": "Version",
  "profile.threatProtection.actions.add.success": "Profile added successfully",
  "profile.threatProtection.actions.add.error": "Profile have not been saved",
  "profile.threatProtection.actions.delete.success":
    "Profile removed successfully",
  "profile.threatProtection.actions.delete.error.inUse":
    "Can't delete profile! Profile in use",
  "profiles.threatProtection.error.profile.exists":
    "A profile with this name already exists.",
  "profiles.threatProtection.action.remove.text":
    "Are you sure you want to delete",
  "profile.threatProtection.malwareScanning": "Malware Scanning",
  "profile.threatProtection.threatBlocking": "Threat Blocking",
  "profile.threatProtection.threatProtection": "Threat Protection",
  "profile.threatProtection.threatProtectionProfile":
    "Threat Protection Profile",
  "profile.threatProtection.malwareScanning.required":
    "Please select some Malware Scanning.",
  "profile.threatProtection.threatBlocking.required":
    "Please select some Threat Blocking.",
  "profile.threatProtection.required.threatProtection":
    "Please select some Threat Protection.",

  "profile.appcontrol.createProfile": "Create Profile",
  "profile.appcontrol.deleteProfile": "Delete Profile",
  "profile.appcontrol.actions.clone": "Clone Profile",
  "profile.appcontrol.save.errorProfile": "Profile have not been saved",
  "profile.appcontrol.delete.sucess": "Profile removed successfully",
  "profile.appcontrol.delete.error.inUse":
    "Can't delete profile! Profile in use",
  "profile.appcontrol.filter.invalid": "Filter invalid",
  "profile.appcontrol.applications.required": "Please select some application!",
  "profile.appcontrol.item": "Item",
  "profile.appcontrol.form.applications": "Applications",
  "profile.appcontrol.form.error.name": "The field name is required",
  "profile.appcontrol.form.error.workers": "The workers field is required",
  "profile.appcontrol.action.remove.text": "Are you sure you want to delete",
  "profile.appcontrol.form.profileid.undefined": "Profile must be saved before creating category groups",
  "profile.appcontrol.form.name.exists": "A profile with this name already exists.",
  "profile.appcontrol.form.error.name.pattern": "Only letters, numbers, spaces, dashes, and underscores are allowed.",

  "profiles.proxy.action.remove.text": "Are you sure you want to delete",
  "profiles.proxy.action.remove.profiles.text":
    "Are you sure you want to delete the profiles",

  "profiles.sdwan.action.remove.text": "Are you sure you want to delete",
  "profiles.sdwan.action.remove.profiles.text":
    "Are you sure you want to delete the profiles",
  "profiles.sdwan.deleteProfile": "Delete Profile",
  "profiles.sdwan.deleteService": "Delete Service",

  "profiles.ssl.blockCert": "Block invalid certificates",
  "loggers.title": "Loggers",
  "loggers.actions.create": "Create Logger",
  "loggers.actions.create.loggerDevice": "Create Logger Device",
  "loggers.actions.edit.loggerDevice": "Edit Logger Device",
  "loggers.actions.delete": "Delete Logger",
  "loggers.actions": "Actions",
  "loggers.name": "Name",
  "loggers.mode": "Mode",
  "loggers.cpu.usage": "CPU Usage",
  "loggers.memory.usage": "Memory Usage",
  "loggers.disk.usage": "Disk Usage",
  "loggers.storage.usage": "Storage Usage",
  "loggers.address": "Address",
  "loggers.secretkey": "Secret Key",
  "loggers.description": "Description",
  "loggers.devices": "Devices & Devices Group",
  "loggers.save.success": "Loggers saved successfully",
  "loggers.save.error": "Loggers have not been saved",
  "loggers.save.error.ha.enabled.logger.integrated":
    "Can not create a Integreted Logger because High Availability is enabled",
  "loggers.delete.success": "Loggers deleted successfully",
  "loggers.delete.error": "Loggers deleted error",
  "loggers.backups.retention.backup": "Number of backup retention",
  "loggers.backups.retention.percent": "% Disk usage retention",
  "loggers.backups.delete.backups": "Delete Backups",
  "loggers.backups.restore.backups": "Restore Backups",
  "loggers.backups.restore.last.date": "Last Modified",
  "loggers.storage.logRotation": "Log Rotation",
  "loggers.storage.logRotation.enable": "Enable Log Rotation",
  "loggers.storage.logRotation.retention.byDisk":
    "% Log Retention by Disk Space",
  "loggers.storage.logRotation.retention.byPeriod": "Log Retention by Period",
  "loggers.storage.logRotation.maintenance.interval": "Maintenance Interval",
  "loggers.clusters.cluster": "Cluster",
  "loggers.clusters.create.cluster": "Create Cluster",
  "loggers.clusters.delete.cluster": "Delete Cluster",
  "loggers.clusters.active.primary": "Activate Primary Logger",
  "loggers.clusters.active.replica": "Activate Replica Logger",
  "loggers.clusters.active.logger": "Activate Logger",
  "loggers.clusters.sync.progress": "Sync Progress",
  "loggers.clusters.sync.unavailable": "Unavailable",
  "loggers.clusters.primary": "Primary Logger",
  "loggers.clusters.secondary": "Replica Logger",
  "loggers.clusters.primary.active": "Primary Active",
  "loggers.clusters.secondary.active": "Replica Active",
  "loggers.clusters.virtual.ip": "Virtual IP",
  "loggers.clusters.secret.key": "Secret Key",
  "loggers.clusters.netmask": "Netmask",
  "loggers.clusters.heartbeat.interval": "Heartbeat Interval (seconds)",
  "loggers.clusters.interface.info": "Interface used in logger-config",
  "loggers.clusters.email.info":
    "SMTP configuration required in Settings > Network > E-mail",
  "loggers.clusters.ip.info": "IP used in logger-config",
  "loggers.clusters.failover.threshold": "Failover Threshold",
  "loggers.clusters.auto.activation": "Auto Activation Replica",
  "loggers.clusters.notifications.email": "Notifications to e-mail",
  "loggers.clusters.action.duplicate.error": "Duplicate field",
  "loggers.clusters.action.already.exists": "Cluster name already exists",
  "loggers.clusters.action.activated.success":
    "Logger activated successfully. Wait the synchronization to finish in a few minutes.",
  "loggers.clusters.action.primary.activated":
    "Are you sure you want to activate a primary logger? A replica logger will go into standby.",
  "loggers.clusters.action.replica.activated":
    "Are you sure you want to activate the replica logger? The primary logger will go into standby.",
  "loggers.clusters.action.activated.error": "Logger activated error",
  "loggers.clusters.action.save.success": "Cluster saved successfully",
  "loggers.clusters.action.delete.success": "Cluster deleted successfully",
  "loggers.clusters.action.delete.error": "Cluster(s) deleted error",
  "loggers.clusters.error.equal": "{name1} is equal {name2}",
  "loggers.clusters.error.limit": "Only 125 clusters are allowed",
  "loggers.cluster.verify":
    "It is not possible to delete one (or more) Logger (s) configured in Cluster.",
  "loggers.clusters.heartbeat.ip.verify":
    "Heartbeat IP configured on another cluster",
  "loggers.clusters.virtual.ip.verify":
    "Virtual IP configured on another cluster",

  "events.authentication.reason.src": "Remote Address",
  "events.authentication.reason.time": "Time",
  "events.authentication.reason.date": "Date",
  "events.authentication.reason.user_agent": "User Agent",
  "events.authentication.reason.zone": "Network Zone",
  "events.authentication.reason.no_policy": "No policies found",
  "events.authentication.reason.user_blocked": "Blocked user",
  "events.authentication.reason.timeout": "Session time",
  "events.authentication.reason.policy": "Policy",
  "events.authentication.reason.auth": "Authentication",
  "events.authentication.reason.user": "User/Group",
  "events.authentication.reason.internal_error": "Internal Error",
  "events.authentication.reason.max_session": "Number of sessions exceeded",
  "events.authentication.reason.session override": "Session override",
  "events.authentication.reason.updated": "Session updated",

  "events.title": "Events",
  "events.new.query": "New Query",
  "events.edit.query": "Edit Query",
  "events.save.query": "Save Query",
  "events.create.query": "Create Query",
  "events.custom.query": "Custom new query name",
  "events.load.query": "Load query",
  "events.date.range": "Date range",
  "events.filter": "Filter",
  "events.contain": "Contain",
  "events.not.contain": "Not contain",
  "events.not.equals": "Not equals",
  "events.equals": "Equals",
  "events.value": "Value",
  "events.filter.string": "Filter string",
  "events.filter.string.results": "Filter string results",
  "events.query.editor": "Query Editor",
  "events.information": "Event Information",
  "events.view": "Event View",
  "events.select.field": "Select a field",
  "events.log.analysis": "Log Analysis",
  "events.history": "History Hits",
  "events.error.filter.string": "Please enter a filter string",
  "events.error.name": "Please enter a name",
  "events.delete.all.selected": "Delete all selected",
  "events.search": "Search",
  "events.today": "Today",
  "events.yesterday": "Yesterday",
  "events.last_10m": "Last 10 minutes",
  "events.last_6h": "Last 6 hours",
  "events.last_12h": "Last 12 hours",
  "events.last_18h": "Last 18 hours",
  "events.last_7": "Last 7 days",
  "events.last_30": "Last 30 days",
  "events.this_month": "This month",
  "events.last_month": "Last month",
  "events.date": "By Date",
  "events.range": "By Period",
  "events.start.date": "Start date",
  "events.end.date": "End date",
  "events.select.date": "Select date",
  "events.records": "records",

  "analyzer.title": "Analyzer",
  "analyzer.reports.NetworkTraffic": "Network Traffic",
  "analyzer.reports.WebFilter": "Web Filter",
  "analyzer.reports.ApplicationControl": "Application Control",
  "analyzer.reports.IntrusionPrevention": "Intrusion Prevention",
  "analyzer.reports.ThreatProtection": "Threat Protection",
  "analyzer.reports.UserBehaviour": "User Behaviour",
  "analyzer.reports.Hits": "Hits",
  "analyzer.reports.Traffic": "Traffic",
  "analyzer.reports.AllowedApplication": "Allowed Applications",
  "analyzer.reports.DeniedApplication": "Denied Applications",
  "analyzer.reports.History": "History",
  "analyzer.reports.TotalTraffic": "Total Traffic",
  "analyzer.reports.TopAllowedCategories": "Top Allowed Categories",
  "analyzer.reports.TopDeniedCategories": "Top Denied Categories",
  "analyzer.reports.TopAllowedApplications": "Top Allowed Applications",
  "analyzer.reports.TopDeniedApplications": "Top Denied Applications",
  "analyzer.reports.ThreatBlocking": "Threat",
  "analyzer.reports.MalwareScanning": "Malware",
  "analyzer.reports.Geolocation": "Geolocation",
  "analyzer.reports.ZoneTraffic": "Zone Traffic",
  "analyzer.reports.UsageTraffic": "Traffic Usage",
  "analyzer.reports.TopUsers": "Top Users",
  "analyzer.reports.Top.SiteToSite": "Top Site-To-Site Connections",
  "analyzer.reports.Top.RemoteUsers": "Top Remote Users",
  "analyzer.reports.RemoteUsers": "Remote Users",
  "analyzer.reports.TopServices": "Top Services",
  "analyzer.reports.TopSources": "Top Sources",
  "analyzer.reports.TopProfiles": "Top Profiles",
  "analyzer.reports.TopPolicies": "Top Policies",
  "analyzer.reports.TopDestinations": "Top Destinations",
  "analyzer.reports.TopCategories": "Top Categories",
  "analyzer.reports.TopSites": "Top Domains",
  "analyzer.reports.TopSitesByTime": "Top Domains - Time",
  "analyzer.reports.TopContentType": "Top Content Type",
  "analyzer.reports.TopClasstypes": "Top Classtypes",
  "analyzer.reports.TopMalwares": "Top Malwares",
  "analyzer.reports.TopInfectedDomains": "Top Infected Domains",
  "analyzer.reports.TopThreatsByAddress": "Top Threats by Address",
  "analyzer.reports.TopThreatsByUsers": "Top Threats by Users",
  "analyzer.reports.TopAttacks": "Top Attacks",
  "analyzer.reports.TopThreats": "Top Threats",
  "analyzer.reports.TopApplications": "Top Applications",
  "analyzer.reports.SelectDevice": "Select a Device/Group",
  "analyzer.reports.SelectUser": "Select a User",
  "analyzer.reports.HistoryTotalTraffic": "History Total Traffic",
  "analyzer.reports.DeniedDomains": "Denied Domains",
  "analyzer.reports.AllowedDomains": "Allowed Domains",
  "analyzer.reports.HistoryDeniedDomains": "History Denied Domains",
  "analyzer.reports.HistoryAllowedDomains": "History Allowed Domains",
  "analyzer.reports.HistoryUsers": "History Users",
  "analyzer.reports.HistoryPolicies": "History Profiles",
  "analyzer.reports.HistoryCategories": "History Categories",
  "analyzer.reports.HistorySites": "History Domains",
  "analyzer.reports.HistoryContentType": "History Content Type",
  "analyzer.reports.User": "User",
  "analyzer.reports.Service": "Service",
  "analyzer.reports.Source": "Source",
  "analyzer.reports.Destination": "Destination",
  "analyzer.reports.Profile": "Profile",
  "analyzer.reports.Policy": "Policy",
  "analyzer.reports.Domain": "Domain",
  "analyzer.reports.Application": "Application",
  "analyzer.reports.ContentType": "ContentType",
  "analyzer.reports.Category": "Category",
  "analyzer.reports.Classtype": "Classtype",
  "analyzer.reports.Malware": "Malware",
  "analyzer.reports.Address": "Ip",
  "analyzer.reports.Attack": "Attack",
  "analyzer.reports.Threat": "Threat",
  "analyzer.reports.Alerted": "Alerted",
  "analyzer.reports.Blocked": "Blocked",
  "analyzer.reports.Low": "Low",
  "analyzer.reports.Medium": "Medium",
  "analyzer.reports.High": "High",
  "analyzer.reports.RiskHigh": "Risk - High",
  "analyzer.reports.RiskMedium": "Risk - Medium",
  "analyzer.reports.RiskLow": "Risk - Low",
  "analyzer.reports.totalApplication": "Applications",
  "analyzer.reports.StartDownload": "Your Download will start in a few seconds",

  "analyzer.reports.common.selectDevice": "Select a device",
  "analyzer.reports.policy.globalTags": "Global Tags",
  "analyzer.reports.panel": "Analysis Panel",
  "analyzer.reports.component.footer.totalTraffic": "Total Traffic",
  "analyzer.reports.component.footer.totalHits": "Total Hits",

  "report.actions.add.success": "Report added successfully",

  "analytics.reports.schedule.unique": "Unique",
  "analytics.reports.schedule.daily": "Daily",
  "analytics.reports.schedule.weekly": "Weekly",
  "analytics.reports.schedule.monthly": "Monthly",
  "analytics.reports.scheduled": "Scheduled",
  "analytics.reports.owner": "Owner",
  "analytics.reports.period": "Period",
  "analytics.reports.status": "Status",
  "analytics.reports.reports": "Reports",
  "analytics.reports.download": "Download",
  "analytics.reports.visualize": "Visualize",
  "analytics.reports.pending": "Pending",
  "analytics.reports.running": "Running",
  "analytics.reports.modal.title": " Report ",
  "analytics.reports.modal.type": " Type ",
  "analytics.reports.modal.recurrence": "Recurrence",
  "analytics.reports.modal.analysis": " Analyzer ",
  "analytics.reports.modal.customQueries": "Custom queries",
  "analytics.reports.modal.footerText": "Footer Text",
  "analytics.reports.modal.customizeLogo": "Customize Logo",
  "analytics.reports.changeSchedule": "Change Schedule",
  "analytics.reports.changeSchedule.dateAndTime": "Date And Time",
  "analytics.reports.changeSchedule.sucess": "Schedule updated successfully",
  "analytics.reports.changeSchedule.error": "Schedule have not been save!",
  "analytics.reports.upload.errorSize": "File must smaller than 2MB!",
  "analytics.reports.upload.errorType": "Invalid image format!",
  "analytics.reports.actions.delete.success": "Reports deleted successfully!",
  "analytics.reports.actions.add.error": "Report have not been save!",
  "analytics.reports.logo.extension": "Invalid extension!",
  "analytics.reports.logo.size.archive": "Larger than expected file size!",
  "analytics.reports.logo.size.image": "Larger than expected image size!",
  "webCategory.uncategorized": "Uncategorized Sites",
  "webCategory.abortion": "Abortion",
  "webCategory.pro-life": "Pro-life",
  "webCategory.pro-choice": "Pro-Choice",
  "webCategory.activism-groups": "Activism Groups",
  "webCategory.adult-material": "Adult Material",
  "webCategory.adult-content": "Adult Content",
  "webCategory.nudity": "Nudity",
  "webCategory.sex": "Sex",
  "webCategory.sex-education": "Sex Education",
  "webCategory.lingerie-and-swimsuit": "Lingerie and Swimsuit",
  "webCategory.business-and-economy": "Business and Economy",
  "webCategory.financial-data-and-services": "Financial Data and Services",
  "webCategory.drugs": "Drugs",
  "webCategory.abused-drugs": "Abused Drugs",
  "webCategory.prescribed-medications": "Prescribed Medications",
  "webCategory.supplements-and-unregulated-compounds":
    "Supplements and Unregulated Compounds",
  "webCategory.marijuana": "Marijuana",
  "webCategory.education": "Education",
  "webCategory.educational-institutions": "Educational Institutions",
  "webCategory.cultural-institutions": "Cultural Institutions",
  "webCategory.educational-materials": "Educational Materials",
  "webCategory.reference-materials": "Reference Materials",
  "webCategory.entertainment": "Entertainment",
  "webCategory.mp3-and-audio-download-services":
    "MP3 and Audio Download Services",
  "webCategory.gambling": "Gambling",
  "webCategory.games": "Games",
  "webCategory.government": "Government",
  "webCategory.military": "Military",
  "webCategory.political-organizations": "Political Organizations",
  "webCategory.health": "Health",
  "webCategory.illegal-or-questionable": "Illegal or Questionable",
  "webCategory.pedophilia": "Pedophilia",
  "webCategory.information-technology": "Information Technology",
  "webCategory.hacking": "Hacking",
  "webCategory.proxy-avoidance": "Proxy Avoidance",
  "webCategory.search-engines-and-portals": "Search Engines and Portals",
  "webCategory.web-hosting": "Web Hosting",
  "webCategory.url-translation-sites": "URL Translation Sites",
  "webCategory.computer-security": "Computer Security",
  "webCategory.internet-communication": "Internet Communication",
  "webCategory.web-chat": "Web Chat",
  "webCategory.web-mail": "Web Mail",
  "webCategory.job-search": "Job Search",
  "webCategory.militancy-and-extremist": "Militancy and Extremist",
  "webCategory.news-and-media": "News and Media",
  "webCategory.alternative-journals": "Alternative Journals",
  "webCategory.productivity-categories": "Productivity Categories",
  "webCategory.advertisements": "Advertisements",
  "webCategory.freeware-and-software-download":
    "Freeware and Software Download",
  "webCategory.instant-messaging": "Instant Messaging",
  "webCategory.message-boards-and-forums": "Message Boards and Forums",
  "webCategory.online brokerage and trading": "Online Brokerage and Trading",
  "webCategory.pay-to-surf": "Pay-to-Surf",
  "webCategory.bandwidth-categories": "Bandwidth Categories",
  "webCategory.internet-radio-and-tv": "Internet Radio and TV",
  "webCategory.streaming-media": "Streaming Media",
  "webCategory.peer-to-peer-file-sharing": "Peer-to-Peer File Sharing",
  "webCategory.personal-network-storage-and-backup":
    "Personal Network Storage and Backup",
  "webCategory.internet-telephony": "Internet Telephony",
  "webCategory.potentially-unwanted-software": "Potentially Unwanted Software",
  "webCategory.malicious-web-sites": "Malicious Web sites",
  "webCategory.spyware": "Spyware",
  "webCategory.racism-and-hate": "Racism and Hate",
  "webCategory.religion": "Religion",
  "webCategory.non-traditional-religions-and-occult-and-folklore":
    "Non-Traditional Religions and Occult and Folklore",
  "webCategory.traditional-religions": "Traditional Religions",
  "webCategory.shopping": "Shopping",
  "webCategory.internet-auctions": "Internet Auctions",
  "webCategory.real-estate": "Real Estate",
  "webCategory.social-organizations": "Social Organizations",
  "webCategory.professional-and-worker-organizations":
    "Professional and Worker Organizations",
  "webCategory.service-and-philanthropic-organizations":
    "Service and Philanthropic Organizations",
  "webCategory.social-and-affiliation-organizations":
    "Social and Affiliation Organizations",
  "webCategory.society-and-lifestyles": "Society and Lifestyles",
  "webCategory.alcohol-and-tobacco": "Alcohol and Tobacco",
  "webCategory.gay-or-lesbian-or-bisexual-interest":
    "Gay or Lesbian or Bisexual Interest",
  "webCategory.personals-and-dating": "Personals and Dating",
  "webCategory.restaurants-and-dining": "Restaurants and Dining",
  "webCategory.hobbies": "Hobbies",
  "webCategory.social-networking-and-personal-sites":
    "Social Networking and Personal Sites",
  "webCategory.special-events": "Special Events",
  "webCategory.sports": "Sports",
  "webCategory.sport-hunting-and-gun-clubs": "Sport Hunting and Gun Clubs",
  "webCategory.tasteless": "Tasteless",
  "webCategory.travel": "Travel",
  "webCategory.vehicles": "Vehicles",
  "webCategory.violence": "Violence",
  "webCategory.weapons": "Weapons",

  "webCategoryDescription.uncategorized": "",
  "webCategoryDescription.abortion":
    "Sites with neutral or balanced presentation of the issue.",
  "webCategoryDescription.pro-life":
    "Sites that provide information about or are sponsored by organizations that support legal abortion or that offer support or encouragement to those seeking the procedure.",
  "webCategoryDescription.pro-choice":
    "Sites that provide information about or are sponsored by organizations that oppose legal abortion or that seek increased restriction of abortion.",
  "webCategoryDescription.activism-groups": "",
  "webCategoryDescription.adult-material": "",
  "webCategoryDescription.adult-content":
    "Sites that display full or partial nudity in a sexual context, but not sexual activity; erotica; sexual paraphernalia; sex-oriented businesses as clubs, nightclubs, escort services; and sites supporting the online purchase of such goods and services.",
  "webCategoryDescription.nudity":
    "Sites that offer depictions of nude or seminude human forms, singly or in groups, not overtly sexual in intent or effect.",
  "webCategoryDescription.sex":
    "Sites that depict or graphically describe sexual acts or activity, including exhibitionism; also, sites offering direct links to such sites.",
  "webCategoryDescription.sex-education":
    "Sites that offer information about sex and sexuality, with no pornographic intent.",
  "webCategoryDescription.lingerie-and-swimsuit":
    "Sites that offer images of models in suggestive but not lewd costume, with semi nudity permitted. Includes classic 'cheese-cake', calendar, and pinup art and photography. Includes also sites offering lingerie or swimwear for sale.",
  "webCategoryDescription.business-and-economy":
    "Sites sponsored by or devoted to business firms, business associations, industry groups, or business in general.",
  "webCategoryDescription.financial-data-and-services":
    "Sites that offer news and quotations on stocks, bonds, and other investment vehicles, investment advice, but not online trading. Includes banks, credit unions, credit cards, and insurance.",
  "webCategoryDescription.drugs": "",
  "webCategoryDescription.abused-drugs":
    "Sites that promote or provide information about the use of prohibited drugs, except marijuana, or the abuse or unsanctioned use of controlled or regulated drugs; also, paraphernalia associated with such use or abuse.",
  "webCategoryDescription.prescribed-medications":
    "Sites that provide information about approved drugs and their medical use.",
  "webCategoryDescription.supplements-and-unregulated-compounds":
    "Sites that provide information about or promote the sale or use of chemicals not regulated by the FDA (such as naturally occurring compounds).",
  "webCategoryDescription.marijuana":
    "Sites that provide information about or promote the cultivation, preparation, or use of marijuana.",
  "webCategoryDescription.education": "",
  "webCategoryDescription.educational-institutions":
    "Sites sponsored by schools and other educational facilities, by non-academic research institutions, or that relate to educational events and activities.",
  "webCategoryDescription.cultural-institutions":
    "Sites sponsored by museums, galleries, theatres (but not movie theatres), libraries, and similar institutions; also, sites whose purpose is the display of artworks.",
  "webCategoryDescription.educational-materials":
    "Sites that provide information about or that sell or provide curriculum materials or direct instruction; also, learned journals and similar publications.",
  "webCategoryDescription.reference-materials":
    "Sites that offer reference-shelf content such as atlases, dictionaries, encyclopedias, formularies, white and yellow pages, and public statistical data.",
  "webCategoryDescription.entertainment":
    "Sites that provide information about or promote motion pictures, non-news radio and television, books, humor, and magazines.",
  "webCategoryDescription.mp3-and-audio-download-services":
    "Sites that support downloading of MP3 or other sound files or that serve as directories of such sites.",
  "webCategoryDescription.gambling":
    "Sites that provide information about or promote gambling or support online gambling, involving a risk of losing money.",
  "webCategoryDescription.games":
    "Sites that provide information about or promote electronic games, video games, computer games, role-playing games, or online games. Includes sweepstakes and giveaways.",
  "webCategoryDescription.government":
    "Sites sponsored by branches, bureaus, or agencies of any level of government, except for the armed forces.",
  "webCategoryDescription.military":
    "Sites sponsored by branches or agencies of the armed services.",
  "webCategoryDescription.political-organizations":
    "Sites sponsored by or providing information about political parties and interest groups focused on elections or legislation.",
  "webCategoryDescription.health":
    "Sites that provide information or advice on personal health or medical services, procedures, or devices, but not drugs. Includes self-help groups.",
  "webCategoryDescription.illegal-or-questionable":
    "Sites that provide instruction in or promote nonviolent crime or unethical or dishonest behavior or the avoidance of prosecution.",
  "webCategoryDescription.pedophilia":
    "Sites that encourage pedophilia or that provide images or texts with pedophile content.",
  "webCategoryDescription.information-technology":
    "Sites sponsored by or providing information about computers, software, the Internet, and related business firms, including sites supporting the sale of hardware, software, peripherals, and services.",
  "webCategoryDescription.hacking":
    "Sites that provide information about or promote illegal or questionable access to or use of computer or communication equipment, software, or databases.",
  "webCategoryDescription.proxy-avoidance":
    "Sites that provide information about how to bypass proxy server features or to gain access to URLs in any way that bypasses the proxy server.",
  "webCategoryDescription.search-engines-and-portals":
    "Sites that support searching the Web, news groups, or indices or directories thereof.",
  "webCategoryDescription.web-hosting":
    "Sites of organizations that provide hosting services, or top-level domain pages of Web communities.",
  "webCategoryDescription.url-translation-sites":
    "Sites that offer online translation of URLs. These sites access the URL to be translated in a way that bypasses the proxy server, potentially allowing unauthorized access.",
  "webCategoryDescription.computer-security":
    "Sites that provide information about or free downloadable tools for computer security.",
  "webCategoryDescription.internet-communication": "",
  "webCategoryDescription.web-chat":
    "Sites that host Web chat services or that support or provide information about chat via HTTP or IRC.",
  "webCategoryDescription.web-mail":
    "Sites that provide email services open to general use.",
  "webCategoryDescription.job-search":
    "Sites that offer information about or support the seeking of employment or employees.",
  "webCategoryDescription.militancy-and-extremist":
    "Sites that offer information about or promote or are sponsored by groups advocating antigovernment beliefs or action.",
  "webCategoryDescription.news-and-media":
    "Sites that offer current news and opinion, including those sponsored by newspapers, general-circulation magazines, or other media.",
  "webCategoryDescription.alternative-journals":
    "Online equivalents to supermarket tabloids and other fringe publications.",
  "webCategoryDescription.productivity-categories": "",
  "webCategoryDescription.advertisements":
    "Sites that provide advertising graphics or other ad content files.",
  "webCategoryDescription.freeware-and-software-download":
    "Sites whose primary function is to provide freeware and software downloads.",
  "webCategoryDescription.instant-messaging":
    "Sites that enable instant messaging.",
  "webCategoryDescription.message-boards-and-forums":
    "Sites that host message boards, bulletin boards, and other unaffiliated discussion forums.",
  "webCategoryDescription.online brokerage and trading":
    "Sites that support active trading of securities and management of investments.",
  "webCategoryDescription.pay-to-surf":
    "Sites that reward users for Internet activity such as viewing Web Sites, advertisements, or email.",
  "webCategoryDescription.bandwidth-categories": "",
  "webCategoryDescription.internet-radio-and-tv":
    "Sites whose primary purpose is to provide radio or TV programming on the Internet.",
  "webCategoryDescription.streaming-media":
    "Sites that primarily provide streaming media content, such as movie trailers.",
  "webCategoryDescription.peer-to-peer-file-sharing":
    "Sites that provide client software to enable peer-to-peer file sharing and transfer.",
  "webCategoryDescription.personal-network-storage-and-backup":
    "Sites that store personal files on Internet servers for backup or exchange.",
  "webCategoryDescription.internet-telephony":
    "Sites that enable users to make telephone calls via the Internet or to obtain information or software for that purpose.",
  "webCategoryDescription.potentially-unwanted-software":
    "Sites that use technologies that alter the operation of the user's hardware, software, or network in ways that diminish control over the user experience, privacy, or the collection and distribution of personal information.",
  "webCategoryDescription.malicious-web-sites":
    "Sites that contain code that may intentionally modify end-user systems without their consent and cause harm.",
  "webCategoryDescription.spyware":
    "Sites or pages that download software that, without the user's knowledge, generate HTTP traffic (other than simple user identification and validation).",
  "webCategoryDescription.racism-and-hate":
    "Sites that promote the identification of racial groups, the denigration or subjection of groups, or the superiority of any group.",
  "webCategoryDescription.religion": "",
  "webCategoryDescription.non-traditional-religions-and-occult-and-folklore":
    "Sites that provide information about or promote religions not specified in Traditional Religions or other unconventional, cultic, or folkloric beliefs and practices.",
  "webCategoryDescription.traditional-religions":
    "Sites that provide information about or promote Bahai, Buddhism, Christian Science, Christianity, Hinduism, Islam, Judaism, Mormonism, Shinto, and Sikhism, as well as atheism.",
  "webCategoryDescription.shopping":
    "Sites that support the online purchase of consumer goods and services except: sexual materials, lingerie, swimwear, investments, medications, educational materials, computer software or hardware, alcohol, tobacco, travel, vehicles and parts, weapons.",
  "webCategoryDescription.internet-auctions":
    "Sites that support the offering and purchasing of goods between individuals.",
  "webCategoryDescription.real-estate":
    "Sites that provide information about renting, buying, selling, or financing residential real estate.",
  "webCategoryDescription.social-organizations": "",
  "webCategoryDescription.professional-and-worker-organizations":
    "Sites sponsored by or that support or offer information about organizations devoted to professional advancement or workers' interests.",
  "webCategoryDescription.service-and-philanthropic-organizations":
    "Sites sponsored by or that support or offer information about organizations devoted to doing good as their primary activity.",
  "webCategoryDescription.social-and-affiliation-organizations":
    "Sites sponsored by or that support or offer information about organizations devoted chiefly to socializing or common interests other than philanthropy or professional advancement.",
  "webCategoryDescription.society-and-lifestyles":
    "Sites that provide information about matters of daily life, excluding entertainment, health, hobbies, jobs, sex, and sports.",
  "webCategoryDescription.alcohol-and-tobacco":
    "Sites that provide information about, promote, or support the sale of alcoholic beverages or tobacco products or associated paraphernalia.",
  "webCategoryDescription.gay-or-lesbian-or-bisexual-interest":
    "Sites that provide information about or cater to gay, lesbian, or bisexual lifestyles, including those that support online shopping, but excluding those that are sexually or issue-oriented.",
  "webCategoryDescription.personals-and-dating":
    "Sites that assist users in establishing interpersonal relationships, excluding those intended to arrange for sexual encounters and excluding those of exclusively gay or lesbian or bisexual interest.",
  "webCategoryDescription.restaurants-and-dining":
    "Sites that list, review, advertise, or promote food, dining, or catering services.",
  "webCategoryDescription.hobbies":
    "Sites that provide information about or promote private and largely sedentary pastimes, but not electronic, video, or online games.",
  "webCategoryDescription.social-networking-and-personal-sites":
    "Sites chiefly devoted to personal expression by individuals (as in diaries or personal blogs) or small groups, often but not necessarily involving multiple links to similar sites.",
  "webCategoryDescription.special-events":
    "Sites devoted to a current event that requires separate categorization.",
  "webCategoryDescription.sports":
    "Sites that provide information about or promote sports, active games, and recreation.",
  "webCategoryDescription.sport-hunting-and-gun-clubs":
    "Sites that provide information about or directories of gun clubs and similar groups, including war-game and paintball facilities.",
  "webCategoryDescription.tasteless":
    "Sites with content that is gratuitously offensive or shocking, but not violent or frightening. Includes sites devoted in part or whole to scatology and similar topics or to improper language, humor, or behavior.",
  "webCategoryDescription.travel":
    "Sites that provide information about or promote travel-related services and destinations.",
  "webCategoryDescription.vehicles":
    "Sites that provide information about or promote vehicles, including those that support online purchase of vehicles or parts.",
  "webCategoryDescription.violence":
    "Sites that feature or promote violence or bodily harm, including self-inflicted harm; or that gratuitously display images of death, gore, or injury; or that feature images or descriptions that are grotesque or frightening and of no redeeming value.",
  "webCategoryDescription.weapons":
    "Sites that provide information about, promote, or support the sale of weapons and related items.",

  "sidebar.management": "Management",
  "sidebar.manager": "Manager",
  "sidebar.management.devices": "Devices",
  "sidebar.management.devices.inventory": "Inventory",
  "sidebar.management.devices.community": "Communities",
  "sidebar.management.devices.templates": "Templates",
  "sidebar.management.devices.provisioning": "Provisioning",
  "sidebar.management.devices.backups": "Backups",
  "sidebar.management.policies": "Policies",
  "sidebar.management.policies.packages": "Packages",
  "sidebar.management.policies.templates": "Templates",
  "sidebar.management.profiles": "Profiles",
  "sidebar.management.profiles.webfilter": "Web Filter",
  "sidebar.management.profiles.threat.protection": "Threat Protection",
  "sidebar.management.profiles.application.control": "Application Control",
  "sidebar.management.profiles.intrusion.prevention": "Intrusion Prevention",
  "sidebar.management.profiles.ssl.inspection": "SSL Inspection",
  "sidebar.management.profiles.sdwan": "SD-WAN",
  "sidebar.management.objects": "Objects",
  "sidebar.management.objects.address": "Address",
  "sidebar.management.objects.services": "Services",
  "sidebar.management.objects.times": "Times",
  "sidebar.management.objects.schedules": "Schedules",
  "sidebar.management.objects.dictionaries": "Dictionaries",
  "sidebar.management.objects.contents": "Contents Types",
  "sidebar.management.users": "Users",
  "sidebar.management.groups": "Groups",

  "sidebar.analytics": "Analytics",
  "sidebar.analytics.dashboard": "Dashboard",
  "sidebar.analytics.analyzer": "Analyzer",
  "sidebar.analytics.firewall": "Firewall",
  "sidebar.analytics.networkTraffic": "Network Traffic",
  "sidebar.analytics.policyUsage": "Policy Usage",
  "sidebar.analytics.webFilter": "Web Filter",
  "sidebar.analytics.applicationControl": "Application Control",
  "sidebar.analytics.intrusionPrevention": "Intrusion Prevention",
  "sidebar.analytics.threatProtection": "Threat Protection",
  "sidebar.analytics.userBehavior": "User Behavior",
  "sidebar.analytics.reports": "Reports",
  "sidebar.analytics.events": "Events",
  "sidebar.analytics.alerts": "Alerts",
  "sidebar.analytics.loggers": "Loggers",
  "sidebar.analytics.kibana": "Custom Report",
  "settings.notifications.vpn.monitor": "VPN Monitor",
  "sidebar.settings": "Settings",
  "sidebar.settings.system": "System",
  "sidebar.settings.system.general": "General",
  "sidebar.settings.system.license": "License",
  "sidebar.settings.system.update": "Update",
  "sidebar.settings.system.storage": "Storage",
  "sidebar.settings.system.backups": "Backups",
  "sidebar.settings.system.sessions": "Sessions",
  "sidebar.settings.system.services": "Services",
  "sidebar.settings.system.ha": "High Availability (Active-Passive)",
  "sidebar.settings.system.ha_sync": "High Availability (Active-Active)",
  "sidebar.settings.system.certificate": "Certificates",
  "sidebar.settings.system.custom.branding": "Custom Branding",
  "sidebar.settings.network": "Network",
  "sidebar.settings.network.general": "General",
  "sidebar.settings.network.interfaces": "Interfaces",
  "sidebar.settings.network.email": "E-mail",
  "sidebar.settings.administration": "Administration",
  "sidebar.settings.administration.users": "Users",
  "sidebar.settings.administration.profiles": "Profiles",
  "sidebar.settings.administration.audit": "Audit",
  "sidebar.settings.administration.servers": "Servers",
  "sidebar.settings.administration.provider": "Identity Provider",
  "sidebar.settings.administration.control": "Access Control",
  "sidebar.settings.deploys": "Deploys",
  "sidebar.settings.deploys.panel": "Deploys Panel",

  "sidebar.networkTraffic": "Network Traffic",
  "sidebar.contentFiltering": "Content Filtering",
  "sidebar.applicationControl": "Application Control",
  "sidebar.intrusionPrevetion": "Intrusion Prevention",
  "sidebar.threatProtection": "Threat Protection",
  "sidebar.emailProtection": "E-mail Protection",
  "sidebar.userBehavior": "User Behavior",

  "policy.title": "Policies",
  "policy.manager.group.delete.error": "Can't delete a group that has rules.",
  "policy.manager.group.delete.title": "Confirm delete group",
  "policy.manager.group.header.user": "user",
  "policy.manager.group.header.group": "group",
  "policy.form.title": "Policy Form",
  "policy.form.tabs.properties": "Properties",
  "policy.form.tabs.conditions": "Conditions",
  "policy.form.tabs.inspection": "Inspection",
  "policy.form.tabs.routing": "Routing",
  "policy.form.properties.policyGroup": "Policy Group",
  "policy.form.properties.loggingOptions": "Traffic Logging",
  "policy.form.connection.geolocation": "Country",
  "policy.form.connection.destination.mac.address": "MAC Address",
  "policy.form.inspection.sslInspection": "SSL Inspection",
  "policy.form.inspection.proxyServices": "Proxy Services",
  "policy.form.inspection.intrusionPrevention": "Intrusion Prevention",
  "policy.form.inspection.threatProtection": "Threat Protection",
  "policy.form.inspection.applicationControl": "Application Control",
  "policy.form.inspection.webFilter": "Web Filter",

  "settings.auth.platform": "Platform",
  "settings.auth.remoteAddr": "Remote Address",
  "settings.auth.concurrentSessions": "Concurrent Sessions",
  "settings.auth.loginAttempts": "Login Attempts",
  "settings.auth.lockoutTimeout": "Lockout Timeout (min)",
  "settings.auth.sessionTimeout": "Session Time (min)",
  "settings.auth.minutes": "minutes",
  "settings.auth.conditions.error": "Please, select at least one item.",

  "settings.auth.keySsh": "SSH key",
  "settings.auth.keySsh.copySuccess": "Successfully copied ssh key",
  "settings.auth.keySsh.copy": "Copy SSH key",
  "settings.auth.filial.settings": "Subsidiary settings",
  "settings.auth.master.ip": "Master IP",
  "settings.auth.filial.tymeSync": "Synchronization time (seconds)",
  "settings.auth.action.import": "Import subsidiaries",
  "settings.auth.name.import": "Subsidiaries File",
  "settings.auth.action.copySSH": "Copy SSH key",
  "settings.auth.action.enabledFilial": "Enable Subsidiary",

  "settings.auth.keySsh.disable.confirm":
    "Are you sure you want to disable the following subsidiaries?",
  "settings.auth.change.confirm":
    "Are you sure you want to change the synchronization mode?",

  "settings.system.logging.logRotationBySize": "Log rotation by size",
  "settings.system.logging.logRotationBySize.error":
    "Log rotation by size is a maximum of 90% and a minimum of 20%.",
  "settings.system.logging.logRotationByAge": "Log rotation by time",
  "settings.system.logging.logRotationBySession": "Log limit by session",
  "settings.system.logging.rotation": "Rotation",
  "settings.system.logging.persistency": "Persistency",
  "settings.system.logging.logForwarding": "Forwarding",
  "settings.system.logging.remoteSyslog": "Syslog",
  "settings.system.logging.warning":
    "Do you want to change the settings?\nFirewall services will be restarted.",

  "settings.system.logging.netflow.serverIP": "Netflow Server IP",
  "settings.system.logging.netflow.serverPort": "Netflow Server Port",
  "settings.system.logging.netflow.server.exists":
    "That combination already exists.",

  "settings.system.logging.syslog.mode.auth": "Auth mode",
  "settings.system.logging.syslog.cert.service": "Remote CS",
  "settings.system.logging.syslog.certificate": "Remote CA",
  "settings.system.logging.syslog.cert.invalid": "Invalid remote CA",


  "settings.system.highAvailability.limitHA": "Limit Heartbeat",
  "settings.system.highAvailability.removeAll": "Remove all settings",
  "highAvailability.warning":
    "Secondary device active, any change in the interface may compromise the return of the primary server",
  "settings.system.highAvailability.idKey": "Identification key",
  "settings.system.highAvailability.monitoredInterfaces":
    "Monitored Interfaces",
  "settings.system.highAvailability.secondaryDevice": "Secondary device",
  "settings.system.highAvailability.networkInterface": "Network interface",
  "settings.system.highAvailability.lastSyncDate": "Last synchronism date",
  "settings.system.highAvailability.secondaryServerAddr":
    "Secondary server address",
  "settings.system.highAvailability.filesTransferred": "Files Transferred",
  "settings.system.highAvailability.primaryServerStatus":
    "Primary server status",
  "settings.system.highAvailability.errors": "errors",
  "settings.system.highAvailability.editSecondaryServer":
    "Edit secondary server",
  "settings.system.highAvailability.slaveWarning":
    "Secondary device active, saving this interface will make it a primary device.",
  "settings.system.highAvailability.waiting":
    "Wait, the servers are being synchronized.",
  "settings.system.highAvailability.error.logger.integrated":
    "High Availability can not be configured because Integreted Logger is enabled",

  "wizard.title": "Installation Wizard",
  "wizard.tabs.license": "Accept License",
  "wizard.tabs.system": "System Settings",
  "wizard.tabs.network": "Network Settings",
  "wizard.tabs.admin": "Administration",
  "wizard.license.accepted": "Accept terms of use",
  "wizard.system.hostname": "Hostname",
  "wizard.system.domain": "Domain",
  "wizard.system.timezone": "Timezone",
  "wizard.system.language": "Language",
  "wizard.network.deviceKey": "Interface",
  "wizard.network.ip": "IP Address",
  "wizard.network.mask": "Netmask",
  "wizard.network.gateway": "Gateway",
  "wizard.network.dns": "DNS Server ",
  "wizard.network.ntp": "NTP Server ",
  "wizard.admin.name": "Name",
  "wizard.admin.email": "E-mail",
  "wizard.admin.pass": "Password",
  "wizard.admin.repass": "Confirm Password",
  "wizard.license.accepted.error":
    "To continue the terms of use must be accepted",
  "wizard.system.hostname.error": "Hostname is required",
  "wizard.system.domain.error": "Domain is required",
  "wizard.system.timezone.error": "Timezone is required",
  "wizard.system.language.error": "Language is required",
  "wizard.network.deviceKey.error": "Interface is required",
  "wizard.network.ip.error": "IP Address is required",
  "wizard.network.mask.error": "Netmask is required",
  "wizard.network.gateway.error": "Gateway is required",
  "wizard.network.dns.error": "DNS Server  is required",
  "wizard.network.ntp.error": "NTP Server  is required",
  "wizard.admin.name.error": "Name is required",
  "wizard.admin.email.error": "E-mail is required",
  "wizard.admin.email.invalid": "Invalid E-mail address",
  "wizard.admin.pass.error": "Password is required",
  "wizard.admin.repass.error": "Confirm Password is required",
  "wizard.admin.repass.mismatch": "Password confirmation does not matches",
  "wizard.progress.step1": "Create Databese",

  "wizard.agreement": `BLOCKBIT

END USER LICENSE AGREEMENT

BY CLICKING "CONTINUE", YOU OR THE ENTITY THAT YOU REPRESENT ("LICENSEE") ARE UNCONDITIONALLY CONSENTING TO BE BOUND BY AND ARE BECOMING A PARTY TO THIS END USER LICENSE AGREEMENT ("AGREEMENT") WITH BLOCKBIT TECNOLOGIA LTDA.(“BLOCKBIT”). IF THESE TERMS ARE CONSIDERED AN OFFER, ACCEPTANCE IS EXPRESSLY LIMITED TO SUCH TERMS. IF LICENSEE DOES NOT UNCONDITIONALLY AGREE TO THE FOREGOING, CLICK THE "CANCEL" BUTTON AND THE INSTALLATION PROCESS WILL NOT CONTINUE. IF YOU CLICK THE “ACCEPT” BUTTON TO CONTINUE WITH INSTALLATON YOU ARE REPRESENTING AND WARRANTING THAT YOU ARE AUTHORIZED TO BIND LICENSEE.


1. Grant of License and Restrictions. Subject to the terms hereof, payment of all fees, and any applicable user/use limitations, BLOCKBIT grants Licensee a personal, non-sublicensable, nonexclusive, right to use the software that is directly accessible through this installation process, but only: (i) in object code form only (“Software”); (ii) on a specifically authorized machine located at a Licensee site authorized by BLOCKBIT; and (iii) in accordance with BLOCKBIT’s price list. BLOCKBIT retains ownership of the Software and Licensee will maintain the copyright notice and any other notices that appear on the Software or on any media containing the Software.
2. Updates, Content and Support Services. Updates, content and/or support services are not necessarily provided with the Software, and may require additional payment or include additional terms and conditions. However, to the extent that an update to the Software and/or content is provided, such update/content shall be deemed “Software” provided subject to this Agreement, and shall be licensed for use only on the specific machine for which it is licensed. If content/support services are provided, BLOCKBIT reserves the right to change the scope or duration of such services at any time, and to access, freely use and distribute data collected from Licensee through such services. If such services are made available, Licensee may be required to pay fees or other charges for use or access to some or all such services, which fees and terms will be specified in the invoice or order form for such service.
3. Restrictions. Licensee will not (and will not allow any third party to): (i) reverse engineer or attempt to discover any source code or underlying ideas or algorithms of the Software; (ii) provide, lease, lend, disclose, use for timesharing or service bureau purposes, or otherwise use or allow others to use for the benefit of any third party, the Software (except as expressly and specifically authorized by BLOCKBIT); (iii) without the express prior written consent of BLOCKBIT, conduct any benchmarking or comparative study or analysis involving the Software (“Benchmarking”) for any reason or purpose except, to the limited extent absolutely necessary, to determine the suitability of the Software to interoperate with Licensee’s internal computer systems; (iv) disclose to any third party any Benchmarking or any other information related thereto; (v) use the Software or any Benchmarking in connection with the development of products that compete with the Software; or (vi) reproduce, alter or modify the Software. Prior to disposing of any media or apparatus containing any part of the Software, Licensee shall completely destroy the Software contained therein. All the limitations and restrictions on Software in this Agreement also apply to documentation, reports and screens. Further, Software licensed without charge or for a nominal charge will be deemed a free evaluation license and only may be used for purposes of evaluating whether to obtain a paid license, and not for any productive use. LICENSEE ACKNOWLEDGES THAT THE SOFTWARE MAY INCLUDE FEATURES TO PREVENT USE AFTER THE APPLICABLE LICENSE PERIOD AND/OR USE INCONSISTENT HEREWITH. Licensee acknowledges that Software may be distributed alongside or contain or use certain open source or other third party software (“Third Party Software”). THIRD PARTY SOFTWARE IS (IN ADDITION TO THE TERMS AND CONDITIONS OF THIS AGREEMENT), SUBJECT TO AND GOVERNED BY (AND LICENSEE AGREES TO, AND WILL INDEMNIFY BLOCKBIT FOR NONCOMPLIANCE WITH) THE RESPECTIVE LICENSES FOR SUCH THIRD PARTY SOFTWARE. No rights or licenses are granted other than as expressly and unambiguously set forth herein.
4. Confidentiality. The Software in source code form remains a confidential trade secret of BLOCKBIT and/or its suppliers. The Software is protected by the copyright and other intellectual property laws of the United States and international treaties. Licensee acknowledges that, in the course of using the Software, Licensee may obtain or learn information relating to the Software, which may include, without limitation, information relating to the performance, reliability or stability of the Software, operation of the Software, know-how, techniques, processes, ideas, algorithms, and software design and architecture (“Proprietary Information”). As between the parties, such Proprietary Information shall belong solely to BLOCKBIT. During and after the term of this Agreement, Licensee shall hold in confidence and protect, and shall not use (except as expressly authorized by this Agreement) or disclose, Proprietary Information to any third party.
5. Termination. This Agreement is effective until terminated. Licensee may terminate this Agreement at any time by destroying all copies of the Software and related documentation. This Agreement will terminate automatically if Licensee fails to pay the full invoiced amount for the Software when due or fails to comply with any term or condition of this Agreement, including any attempt to transfer a copy of the Software to another party except as provided in this Agreement. Licensee agrees that upon such termination, Licensee will destroy all copies of the Software and related documentation. Except as otherwise expressly provided herein, the terms hereof shall survive any termination. Termination is not an exclusive remedy and all other remedies will be available whether or not termination occurs.
6. Limited Warranty and Disclaimer. LICENSEE ACKNOWLEDGES AND UNDERSTANDS THAT THE SOFTWARE LICENSED UNDER THIS AGREEMENT IS PROVIDED TO IT “AS IS” WITHOUT ANY WARRANTIES WHATSOEVER CONCERNING THE INSTALLATION, USE OR PERFORMANCE OF THE SOFTWARE. BLOCKBIT EXPRESSLY DISCLAIMS, AND LICENSEE HEREBY EXPRESSLY WAIVES ALL OTHER WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTIBILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, SYSTEM INTEGRATION, NON-INTERFERENCE, ACCURACY, RELIABILITY AND QUALITY OF THE SOFTWARE, INCLUDING AND WITHOUT DEROGATING FROM THE ABOVE, ANY WARRANTIES AND RIGHTS IMPLIED UNDER THE US UNIFORM COMMERCIAL CODE, UCITA (UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT) AND COMMON LAW. BLOCKBIT AND ITS SUPPLIERS DO NOT WARRANT THAT THE SOFTWARE WILL MEET LICENSEE’S REQUIREMENTS OR THAT THE OPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED OR ERROR-FREE. BLOCKBIT FURTHER DISCLAIMS, AND LICENSEE HEREBY EXPRESSLY WAIVES ALL WARRANTIES WITH RESPECT TO THE RESULTS, INFORMATION, DATA AND ANY ADVICE PROVIDED THROUGH THE SOFTWARE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO IT. BLOCKBIT shall have no responsibility to replace media if the failure of media results from accident, abuse or misuse of the media. THE SOFTWARE IS PROVIDED TO LICENSEE WITH NO WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
7. Limitation of Liability. IN NO EVENT WILL BLOCKBIT OR ANYONE ELSE WHO HAS BEEN INVOLVED IN THE CREATION, PRODUCTION, OR DELIVERY OF THE SOFTWARE BE LIABLE FOR ANY INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES, INCLUDING WITHOUT LIMITATION, LOST PROFITS OR LOST DATA, EVEN IF THEY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
8. Anticorruption Laws. Licensee acknowledges that it is familiar with and understands the provisions of the Lei Anticorrupção do Brasil nº 12.846/2013, U.S. Foreign Corrupt Practices Act (the "FCPA") and the U.K. Bribery Act of 2010 (“UKBA”) and agrees to comply with its terms as well as any provisions of local law or BLOCKBIT’s corporate policies and procedures related thereto. Licensee further understands the provisions relating to the Lei Anticorrupção do Brasil FCPA and UKBA’s prohibitions regarding the payment or giving of anything of value, including but not limited to payments, gifts, travel, entertainment and meals, either directly or indirectly, to an official of a foreign government or political party for the purpose of influencing an act or decision in his or her official capacity or inducing the official to use his or her party’s influence with that government, to obtain or retain business involving the Software. Licensee agrees to not violate or knowingly let anyone violate the Lei Anticorrupção do Brasil, FCPA or UKBA, and Licensee agrees that no payment it makes will constitute a bribe, influence payment, kickback, rebate, or other payment that violates the Lei Anticorrupção do Brasil, FCPA, the UKBA, or any other applicable anticorruption or antibribery law.
9. Evaluation. Notwithstanding anything to the contrary herein, if Licensee is using the Software for evaluation purposes then such use is subject to BLOCKBIT’s then current evaluation terms and conditions or other mutually agreed upon terms to govern such evaluation.
10. Miscellaneous. Neither this arrangement nor the licenses granted hereunder are assignable or transferable by Licensee (and any attempt to do so shall be void). BLOCKBIT may freely assign, delegate, license and/or transfer this Agreement, in whole or in part, without consent. This Agreement shall be deemed to have been made in, and shall be construed pursuant to the laws of the Brasil without regard to conflicts of laws provisions thereof, and without regard to the United Nations Convention on the International Sale of Goods or the Uniform Computer Information Transactions Act. Subject to the foregoing, the provisions hereof are for the benefit of the parties only and not for any other person or entity. Any notice, report, approval, authorization, agreement or consent required or permitted hereunder shall be in writing; notices shall be sent to the address the applicable party has or may provide by written notice or, if there is no such address, the most recent address the party giving notice can locate using reasonable efforts. No failure or delay in exercising any right hereunder will operate as a waiver thereof, nor will any partial exercise of any right or power hereunder preclude further exercise. If any provision shall be adjudged by any court of competent jurisdiction to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that this arrangement shall otherwise remain in full force and effect and enforceable. This is the complete and exclusive statement of the mutual understanding of the parties with respect to the license granted herein and supersedes and cancels all previous written and oral agreements and communications relating to such license and any waivers or amendments shall be effective only if executed in writing by BLOCKBIT; however, any pre-printed or standard terms of any purchase order, confirmation, or similar form, unless signed by BLOCKBIT after the effectiveness hereof, shall have no force or effect. The substantially prevailing party in any action to enforce this agreement will be entitled to recover its attorney’s fees and costs in connection with such action.`,

  "settings.license": "License",
  "settings.license.save": "Edit License",
  "settings.license.data": "Data License",
  "settings.license.signatures": "Signatures",
  "settings.license.serial.number": "Serial Number",
  "settings.license.update": "License Update",
  "settings.license.number": "License Number",
  "settings.license.status": "License Status",
  "settings.license.registration.date": "Registration Date",
  "settings.license.expiration.date": "Expiration Date",
  "settings.license.start.date": "Start Date",
  "settings.license.end.date": "End Date",
  "settings.license.terms": "Terms",

  "settings.backups.settings": "Settings",
  "settings.backups.execute": "Execute Backup",
  "settings.backups.save.settings": "Save Settings",
  "settings.backups.system.now": "Create backup file",
  "settings.backups.device.backups": "Device Backups",
  "settings.backups.storage": "Storage",
  "settings.backups.system.backup": "System Backup",
  "settings.backups.period": "Period",
  "settings.backups.period.weekly": "Weekly",
  "settings.backups.period.daily": "Daily",
  "settings.backups.weekday": "Weekday",
  "settings.backups.hour": "Hour",
  "settings.backups.automatic.cleanup": "Automatic cleanup",
  "settings.backups.automatic.cleanup.info": "Number of backups on storage",
  "settings.backups.snapshot": "Snapshot",
  "settings.backups.log.export": "Log Export",
  "settings.backups.error.storage":
    "Configure the storage to execute the backup.",
  "settings.backups.remove": "Remove Backup",
  "settings.backups.remove.snapshot": "Remove Snapshot",
  "settings.backups.remove.confirm": "Are you sure you want to remove?",
  "settings.backups.remove.success": "Remove successfully",
  "settings.backups.view.size": "View Size Backup",
  "settings.backups.view.size.snapshot": "View Size Snapshot",
  "settings.backups.restore": "Restore Backup",
  "settings.backups.restore.snapshot": "Restore Snapshot",
  "settings.backups.restore.success": "Restore successfully",
  "settings.backups.restore.error": "Restore error",
  "settings.backups.restore.error.server": "Invalid server!",
  "settings.backups.restore.error.backup": "Invalid backup!",
  "settings.backups.restore.snapshot.success": "Snapshot restore successfully!",
  "settings.backups.restore.snapshot.error": "Snapshot restore error!",
  "settings.backups.restore.sys.warning": `The device enters the recovery state, all services will be terminated.
        After the restore, the device will be restarted. It is recommended that System Backup be applied only in identical or similar environments.`,
  "settings.backups.restore.device.warning": "The device will enter recovery mode. After the restoration, the system will restart.",
  "settings.backups.restore.snapshot.warning":
    "Are you sure you want to restore Snapshot?",
  "settings.backups.restore.log.warning":
    "Are you sure you want to restore log backup?",
  "settings.backups.restore.snapshot.invalid": "Invalid Snapshot!",
  "settings.backups.restore.snapshot.invalid.version":
    "Invalid Snapshot version!",
  "settings.backups.import": "Import",
  "settings.backups.import.configuration": "Import Configuration",
  "settings.backups.import.success": "Import successfully",
  "settings.backups.import.error": "Import error",
  "settings.backups.import.error-duplicated-sids":
    "Import error duplicated SIDS: ",
  "settings.backups.import.error-invalid-rules": "Import error invalid rules",
  "settings.backups.import.error-rules-not-found":
    "Import error rules not found",
  "settings.backups.import.error-file-not-found": "Import error file not found",
  "settings.backups.import.upload": "Click to upload",
  "settings.backups.import.loading": "Loading...",
  "settings.backups.import.in.progress": "Apply Settings",
  "settings.backups.import.wait": "Wait while settings are applied",
  "settings.backups.file.configuration": "Configuration File",
  "settings.backups.run": "Run Backup",
  "settings.backups.run.execute": "Execute",
  "settings.backups.run.confirm.backup":
    "Want to run the backup of system now?",
  "settings.backups.run.confirm.snapshot": "Want to run the snapshot now?",
  "settings.backups.run.confirm.logs": "Want to run the logs export now?",
  "settings.backups.run.success": "Execute successfully",
  "settings.backups.select.time": "Select time",
  "settings.backups.confirm.delete": "Do you confirm to delete backup(s) now?",
  "settings.backups.confirm.stop": "Do you confirm to stop backup now?",
  "settings.backups.confirm.restore":
    "Do you confirm to restore backup(s) now?",

  "settings.notifications": "Notifications",
  "settings.notifications.system.notifications": "System Notifications",
  "settings.notifications.security.notifications": "Security Notifications",
  "settings.notifications.notifications.email": "Notifications to Email",
  "settings.notifications.notifications.snmp": "Notifications to SNMP",
  "settings.notifications.synchronism": "Synchronism",
  "settings.notifications.gsm.analyzer": "GSM Analyzer",
  "settings.notifications.activities.policy": "Policy Activities",
  "settings.notifications.activities.intrusion":
    "Intrusion Detection Activities",
  "settings.notifications.activities.application": "Application Activities",
  "settings.notifications.activities.webcategories":
    "Web Categories Activities",
  "settings.notifications.activities.malware": "Malware Activities",
  "settings.notifications.secure.connection": "Secure connection",
  "settings.notifications.dont.use": "Don't use",
  "settings.notifications.from.email": "From email",
  "settings.notifications.recipient": "Recipient",
  "settings.notifications.communities": "Communities",
  "settings.notifications.authentication.protocol": "Authentication Protocol",
  "settings.notifications.engine.id": "Engine ID",
  "settings.notifications.level.security": "Security Level",
  "settings.notifications.encryption.algorithm": "Encryption Algorithm",
  "settings.notifications.private.password": "Private Password",

  "services.firewall.generalSettings": "General Settings",
  "services.firewall.generalSettings.security.settings": "Security Settings",
  "services.firewall.generalSettings.timeout": "Timeout",
  "services.firewall.generalSettings.dos.protection": "DoS Protection",
  "services.firewall.generalSettings.ipSpoofing.protection":
    "IP Spoofing Protection",
  "services.firewall.generalSettings.portScan.protection":
    "PortScan Protection",
  "services.firewall.generalSettings.invalidPacket.protection":
    "Invalid Packet Protection",
  "services.firewall.generalSettings.allow.ping": "Allow Ping",
  "services.firewall.generalSettings.allow.imcpRedirect":
    "Allows ICMP Redirect",
  "services.firewall.generalSettings.ignore.icmp.broadcast":
    "Ignore ICMP Broadcast",
  "services.firewall.generalSettings.source.routing": "Source Routing",
  "services.firewall.generalSettings.checksum": "Checksum",
  "services.firewall.generalSettings.fec": "Forward error correction",
  "services.firewall.generalSettings.invalid.log": "Invalid Log",
  "services.firewall.generalSettings.generic.timeout": "Generic timeout",
  "services.firewall.generalSettings.icmp.timeout": "ICMP timeout",
  "services.firewall.generalSettings.tcp.loose": "TCP Loose",
  "services.firewall.generalSettings.tcp.max.retrans": "TCP Max Retrans",
  "services.firewall.generalSettings.tcp.timeout.close": "TCP timeout close",
  "services.firewall.generalSettings.tcp.timeout.close.wait":
    "TCP timeout close wait",
  "services.firewall.generalSettings.tcp.timeout.established":
    "TCP timeout established",
  "services.firewall.generalSettings.timeout.tcp.fin.wait":
    "Timeout TCP FIN wait",
  "services.firewall.generalSettings.tcp.timeout.last.ack":
    "TCP timeout last ACK",
  "services.firewall.generalSettings.timeout.max.retrans":
    "TCP timeout Max Retrans",
  "services.firewall.generalSettings.timeout.tcp.syn.recv":
    "TCP timeout SYN Recv",
  "services.firewall.generalSettings.timeout.tcp.syn.sent":
    "TCP timeout SYN Sent",
  "services.firewall.generalSettings.timeout.tcp.time.wait":
    "TCP timeout time wait",
  "services.firewall.generalSettings.udp.timeout": "UDP Timeout",
  "services.firewall.generalSettings.udp.timeout.stream": "UDP Timeout Stream",
  "services.firewall.generalSettings.confirm.message":
    "It will not be possible to use the SD-WAN service in the selected network zones. Do you wish to continue?",
  "services.firewall.generalSettings.success.message":
    "Firewall General Settings updated successfully",

  "services.firewall.zoneProtection.delete": "Delete Zone Protection",
  "services.firewall.zoneProtection.delete.success": "Successfully removed",
  "services.firewall.zoneProtection.delete.confirm":
    "Are you sure you want to delete the following items?",
  "services.firewall.zoneProtection.delete.selected": "Remove selected",

  "services.firewall.zoneProtection.clone": "Clone Zone Protection",
  "services.firewall.zoneProtection.clone.confirm":
    "Are you sure you want to clone the following items?",
  "services.firewall.zoneProtection.clone.selected": "Clone selected",
  "services.firewall.zoneProtection.clone.success":
    "Zone Protection cloned successfully",
  "services.firewall.zoneProtection.clone.error": "Zone Protection clone error",

  "services.firewall.zoneProtection.create": "Create Zone Protection",
  "services.firewall.zoneProtection.ipAddress": "IP{version} Address",
  "services.firewall.zoneProtection.warning": "You are disabling a Zone Protection rule that contains a service that is used to configure the operation of the Explicit Proxy. For it to work correctly, this rule must be enabled.",

  "services.firewall.portForwarding": "Port Forwarding",
  "services.firewall.portForwarding.add": "Create Port Forwarding",
  "services.firewall.portForwarding.del": "Remove Port Forwarding",
  "services.firewall.portForwarding.clone.confirm":
    "Are you sure you want to clone the following item?",
  "services.firewall.portForwarding.clone.success":
    "Port Forwarding cloned successfully",
  "services.firewall.portForwarding.clone.error": "Port Forwarding clone error",
  "services.firewall.portForwarding.modal.policy": "Policy",
  "services.firewall.portForwarding.modal.conditions": "Conditions",
  "services.firewall.portForwarding.modal.inspection": "Inspection",
  "services.firewall.portForwarding.modal.advanced": "Advanced",
  "services.firewall.portForwarding.modal.policy.typeport": "Port Type",
  "services.firewall.portForwarding.modal.policy.portrange": "Port / Range",
  "services.firewall.portForwarding.modal.policy.redirect": "Redirect To",
  "services.firewall.portForwarding.modal.policy.snat": "SNAT",
  "services.firewall.portForwarding.modal.policy.snat.default":
    "Default Gateway (Masked)",
  "services.firewall.portForwarding.modal.policy.jump": "Port Forwarding between Network Domains",
  "services.firewall.portForwarding.modal.condition.src.allowed": "Allowed",
  "services.firewall.portForwarding.modal.condition.src.blocked": "Blocked",
  "services.firewall.portForwarding.modal.condition.schedule": "Schedule",
  "services.firewall.portForwarding.modal.inspection.ssl": "SSL Inspection",
  "services.firewall.portForwarding.modal.inspection.atp": "Threat Blocking",
  "services.firewall.portForwarding.modal.inspection.ips":
    "Intrusion Prevention",
  "services.firewall.portForwarding.modal.dosProtection": "DoS Protection",
  "services.firewall.portForwarding.modal.packetRate":
    "Packet Rate (Packets/Seconds)",
  "services.firewall.portForwarding.modal.burstRate": "Burst Rate",
  "services.firewall.portForwarding.modal.error.interface.and.protocol":
    "It is not allowed to redirect everything from the interface being used to access the server",
  "services.firewall.portForwarding.modal.error.equal.redirect":
    "There is a redirect with these characteristics",
  "services.firewall.portForwarding.ssl.warning":
    "Port forwarding rules with SSL Inspection will only work for services supported by security protocols",

  //VPN NG
  "services.vpnng.error.userOrGroup": "Please enter a user or a group!",
  "services.vpnng.error.startingIPRangeIsReserved": "Starting IP range is reserved.",
  "services.vpnng.error.startingIPRangeIsInvalid": "Starting IP range is invalid.",
  "services.vpnng.error.endIPRangeIsReserved": "End IP range is reserved.",
  "services.vpnng.error.endIPRangeIsInvalid": "End IP range is invalid.",
  "services.vpnng.error.validLeaseLimit": "Please insert a valid Lease Limit, at least three characters",
  "services.vpnng.columns.ipInit": "IP Init",
  "services.vpnng.columns.ipLimit": "IP Limit",
  "services.vpnng.columns.leaseLimit": "Lease Limit",
  "services.vpnng.title.settings": "Virtual DHCP Server Settings",
  "services.vpnng.name": "VPN's name",
  "services.vpnng.sameName": "Same names are not allowed",
  "services.vpnng.virtual.host.ip": "Virtual Host IP Address",
  "services.vpnng.start.ip": "Distributes/Distributed IP Address Start",
  "services.vpnng.limit.ip": "Distributes/Distributed IP Address Limit",
  "services.vpnng.settings.title.optional": "Options Applied to Clients (optional)",
  "services.vpnng.title.add.users.groups": "Add users and user groups",
  "system.general.message.disclaimer.es": "Message - Spanish",
  "system.settings.certificate.nameInvalid": "Invalid name",
  "system.settings.certificate.nameExists": "Certificate name already exists",
  "system.settings.certificate.import": "Imported certificate",
  "system.settings.certificate.invalid": "Invalid certificate",
  "system.settings.certificate.deleteErrorRemoteCAareUsedInProxy": "This certificate is in use in the proxy module and/or ssl profile.",
  "system.settings.certificate.importSucces":
    "Certificate imported successfully",
  "system.settings.certificate.input.certificateRequired":
    "Certificate is required",
  "system.settings.certificate.input.privateKeyRequired":
    "Private key is required",
  "system.settings.certificate.input.nameRequired": "Name is required",
  "system.settings.certificate.deleteRemoteCA":
    "Certificate successfully removed",
  "system.settings.certificate.deleteErrorRemoteCA":
    "Unable to remove certificate",
  "system.settings.certificate.title.name": "Name",
  "system.settings.certificate.title.type": "Type",
  "system.settings.certificate.title.action": "Action",
  "system.settings.certificate.tooltip.upload": "Import certificate",
  "system.settings.certificate.tooltip.trash": "Delete certificate",
  "system.settings.certificate.modal.title": "Import CA",
  "system.settings.certificate.modal.labelCertificate": "Certificate",
  "system.settings.certificate.modal.labelPrivateKey": "Private Key",
  "applicationControl.add.custom": "Add Application Group",
  "applicationControl.add.custom.smart": "Smart App Control",
  "applicationControl.add.custom.group": "Add Custom Group",
  "applicationControl.add.custom.category": "Create Custom Signature Group",
  "applicationControl.delete.group": "Do you want to delete this item?",
  "applicationControl.add.category": "App categories",
  "applicationControl.add.group": "Categories groups",
  "settings.system.updates.Type": "Type",
  "settings.system.updates.Product": "Product",
  "settings.system.updates.Version": "Version",
  "settings.system.updates.Date": "Date",
  "settings.system.updates.Description": "Description",
  "settings.system.updates.Action": "Action",
  "settings.system.updates.UninstallMessage": "Want to delete this package?",
  "settings.system.updates.Uninstall": "Uninstall",
  "settings.system.updates.InstallMesage": "Install Package",
  "settings.system.updates.bbValidation": "is not a bb file",
  "settings.system.updates.bbModalTextUpload": "The file is loading, please wait...",
  "settings.system.updates.bbModalTextremoved": "The package is being removed, please wait...",
  "settings.system.updates.bbModalTextInstalled": "The package is being installed, Please wait...",
  "service.notifications.vpn.monitor.enable": "VPN Monitoring Enabled",
  "service.notifications.vpn.monitor.disable": "VPN Monitoring Desabled",
  "profiles.title.dnscontentfilter": "DNS Content Filter",
  "common.profile.dnscontent": "DNS Content Filter Profile",
  "profiles.default.dnscontentfilter": "Default Action",
  "common.modal.form.error.redirect": "Redirect field is required",
  "system.settings.title.cardfilter": "Advanced settings",
  "system.settings.title.input.processos": "Simultaneous processes",
  "system.settings.title.input.theads": "Threads per process",
  "system.settings.title.input.webproxy.transparente": "Transparent proxy concurrent requests",
  "system.settings.title.input.webproxy": "WebProxy Processes",
  "system.settings.title.input.webproxy.ativo": "Concurrent active proxy requests",
  "dhcp.allinterfacesv4.inuser": "Option All IPV4 interfaces registered, please select another interface.",
  "dhcp.interfacesv4.inuser": "Already has an interface with registered IPV4 servers, please select another option.",
  "common.allip": "All IPV4 interfaces",
  //MFA
  "system.mfa.portal": "Portal",
  "system.mfa.enable.admin": "Enable MFA Admins",
  "system.mfa.enable.portal": "Enable MFA Portal",
  "system.mfa.title.modal": "Generate Token",
  "system.mfa.message.token.success": "Token generated successfully!",
  "system.mfa.message.token.error": "Error generating token:",
  "system.mfa.message.token.alreadyExists.error": "Token already Exists.",
  "system.mfa.message.token.copy": "Token was copied.",
  "system.mfa.message.delete.error": "Unable to delete Token.",
  "system.mfa.settings.title": "MFA Controls",
  "system.mfa.title": "Multi Factor Authentication",
  "cluster_popup.title1": "Disable Spanning Tree Protocol (STP):",
  "cluster_popup.paragraph1": "- Disable the Spanning Tree Protocol (STP) on the switch interfaces to avoid conflicts with UCARP. This is necessary to ensure efficient communication between cluster nodes without the interference of network loops managed by STP.",
  "cluster_popup.title2": "VRRP Protocol Support:",
  "cluster_popup.paragraph2": "- The switch must support the VRRP (Virtual Router Redundancy Protocol) as specified by RFCs 3768, 2787, and 5798. VRRP is essential for routing redundancy, allowing a virtual IP to be shared among multiple routers to increase availability.",
  "cluster_popup.title3": "Proper Network Interface Configuration:",
  "cluster_popup.paragraph3": "- Ensure that all network interfaces involved in the Cluster are correctly configured and operational. Pay special attention to the LAN and DMZ interfaces, which are crucial for internal and external cluster communication.",
  "cluster_popup.title4": "Virtual IP Address Configuration:",
  "cluster_popup.paragraph4": "- Properly configure the virtual IP addresses. UCARP uses these addresses to manage the assignment of Master and Backup roles between servers. Correct configuration of virtual IPs is fundamental for failover functionality.",
  "cluster_popup.titleButton": "For more information, refer to the Blockbit NGFW manual:",
  "cluster_popup.linkButton": "https://docs.blockbit.com/display/RCE/System+-+High+Availability+Tab",
  "kibana.service.down": "To access custom reports, configure the Logger on the device.",
  "kibana.loading": "Loading...",
  "kibana.select.logger": "Select logger",
  "common.selectAll": "Select All",
  "common.deselectAll": "Deselect All",
};

export default enMessages;
